(function () {
  var root = document.querySelector("[data-cp3]");
    /* Se la sezione fosse montata due volte (dall'editor tema si puo'), ogni
       copia dello script si aggancerebbe alla PRIMA: doppi handler, doppi
       pushState, e la giostra ricostruita con sedici slide. La guardia fa
       uscire la seconda copia. */
    if (!root || root.hasAttribute("data-cp3-avviato")) return;
    root.setAttribute("data-cp3-avviato", "1"); if (!root) return;

  var API      = root.getAttribute("data-endpoint") || "/apps/richieste/diamanti";
  /* La porta per UNA pietra sola: serve al collegamento diretto, quando
     qualcuno riceve o salva un indirizzo con ?passo=pietra&pietra=<sigla> e
     quella pietra non è fra le dodici che questa pagina ha in mano. */
  var API_PIETRA = root.getAttribute("data-endpoint-pietra") || "/apps/richieste/diamanti/pietra";
  /* I DUE ARCHIVI. Bianchi e fancy sono due feed diversi con due indici
     diversi: due indirizzi separati e non un parametro dello stesso, cosi'
     una domanda sbagliata su uno non puo' mai pescare nell'altro. Le chiavi
     della risposta sono le stesse, e infatti da qui in poi il codice che
     disegna schede ed elenco e' uno solo. */
  var API_FANCY = root.getAttribute("data-endpoint-fancy") || "/apps/richieste/fancy";
  var API_FANCY_PIETRA = root.getAttribute("data-endpoint-fancy-pietra") || "/apps/richieste/fancy/pietra";
  function fancyOra() { return S.ramo === "fancy"; }
  function apiOra() { return fancyOra() ? API_FANCY : API; }
  function apiPietraOra() { return fancyOra() ? API_FANCY_PIETRA : API_PIETRA; }
  /* la radice della schermata su cui si sta lavorando: le due schermate
     (tagli e colori) hanno gli stessi ganci, e vanno distinte */
  function radiceOra() { return fancyOra() ? "[data-cp3-s2c]" : "[data-cp3-s2]"; }
  /* SUL BROWN LA FASCIA "VIVIDA" NON ESISTE, e non e' una mancanza del
     magazzino: e' che il grado non viene assegnato. "Vivid" descrive una
     saturazione alta, e il brown e' per definizione un giallo-arancio
     DESATURATO — la scala del brown si ferma a Dark e Deep, che parlano di
     tono. Contate sul feed di oggi: 0 brown vivid su 758 pietre brown, in
     tutte e sei le carature, mentre i gialli vivid sono 3.786.

     Prima la fascia si mostrava lo stesso e chi la premeva finiva sul
     messaggio "stai cercando un diamante raro". Li' pero' quel messaggio e'
     falso: non e' raro, non esiste. Meglio non offrire la scelta.

     Attenzione a non generalizzare: blu, verde e grigio hanno anche loro zero
     vivid oggi, ma li' il grado ESISTE e domani puo' arrivarne uno — quelle
     restano al loro posto. */
  function bande() {
    if (!fancyOra()) return QUALITA;
    if (S.colore === "brown") {
      return QUALITA_FANCY.filter(function (f) { return f.id !== "vivida"; });
    }
    return QUALITA_FANCY;
  }
  var ASSETS   = root.getAttribute("data-assets") || "";
  var CONTATTI = root.getAttribute("data-contatti") || "/pages/contatti";

  function el(s) { return root.querySelector(s); }

  /* Numeri all'italiana, identici alla v1: il punto delle migliaia si mette a
     mano (toLocaleString non raggruppa i numeri di quattro cifre), le carature
     sempre con due decimali perché "0,50 ct" e "0,5 ct" non si equivalgono. */
  function num(n) { return String(Math.round(Number(n))).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }

  /* IL PREZZO NON SI ARROTONDA. Qui c'era num(Math.round(n)), cioe' una pietra
     da 896,58 finiva a schermo come "897": quarantadue centesimi inventati dal
     tema su un dato che arriva dal fornitore. Era la stessa cosa gia' tolta dal
     feed, dove il prezzo veniva arrotondato alla decina — e rimetterla qui
     annullava quella correzione. La cifra si scrive intera; i centesimi
     compaiono solo se ci sono davvero, perche' "€ 151.840,00" su una pietra da
     centocinquantamila euro e' rumore, mentre "€ 896,58" e' il prezzo. */
  /* IL PREZZO SI ARROTONDA AI CINQUANTA EURO, su richiesta del cliente
     ("2.007,13 diventa 2k, 2945 diventa 2950"). Niente centesimi: in vetrina
     una cifra tonda si legge, una con i centesimi sembra il totale di uno
     scontrino.

     ATTENZIONE, e' scritto qui perche' non si perda: arrotondando al piu'
     vicino si puo' MOSTRARE MENO di quello che la pietra costa davvero — una
     da 2.007,13 si legge 2.000. Verso un privato il prezzo esposto e' quello
     che vale, quindi sono sette euro che il negozio non incassa. Bastava
     arrotondare sempre PER ECCESSO (Math.ceil al posto di Math.round) per non
     avere mai quel rischio: la scelta e' del cliente, la conseguenza e'
     questa. */
  var SCAGLIONE = 50;

  /* PRIMA LA CIFRA, POI LA VALUTA: "45.900 €" e non "€ 45.900".
     Lo spazio fra le due è unificatore, se no in fondo a una riga stretta la
     cifra resta su una riga e l’euro scende da solo su quella dopo.
     Stessa regola dello snippet snippets/prezzo.liquid, che fa lo stesso
     lavoro per i gioielli e per gli orologi. */
  function euro(n) {
    var v = Number(n);
    if (!isFinite(v)) return "\u2014";
    var neg = v < 0;
    v = Math.round(Math.abs(v) / SCAGLIONE) * SCAGLIONE;
    var s = String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return (neg ? "-" : "") + s + "\u00a0\u20ac";
  }

  /* SOPRA I CINQUANTAMILA IL PREZZO NON SI SCRIVE.

     È una scelta del negozio, non una regola del mercato: sopra quella cifra
     una pietra non si compra da un elenco, si compra parlando con qualcuno. Il
     cartellino diventa un invito a chiedere.

     Vale per le PIETRE soltanto. I gioielli e gli orologi hanno già la loro
     strada — il metacampo "prezzo su richiesta" sulla scheda prodotto — e lì
     la decisione si prende pezzo per pezzo, non con una soglia.

     La soglia sta qui, in un posto solo: cambiarla vuol dire cambiare questo
     numero. */
  var SU_RICHIESTA_DA = 50000;
  var SU_RICHIESTA = "Prezzo su richiesta";

  function sopraSoglia(n) {
    var v = Number(n);
    return isFinite(v) && v > SU_RICHIESTA_DA;
  }
  /* il prezzo esposto: quello che si legge su una scheda o in un elenco */
  function euroPub(n) { return sopraSoglia(n) ? SU_RICHIESTA : euro(n); }
  /* l’estremo di un intervallo: non è un cartellino, è un confine.
     Sopra la soglia dice fin dove arriva senza pubblicare la cifra. */
  function euroLim(n) {
    if (!sopraSoglia(n)) return euro(n);
    return "oltre " + euro(SU_RICHIESTA_DA);
  }
  /* "da X a Y": se anche il minimo è sopra la soglia non resta niente da
     scrivere, e vale la sola frase. */
  function euroFra(a, b) {
    if (sopraSoglia(a)) return SU_RICHIESTA;
    if (b == null || b <= a) return euro(a);
    return euro(a) + " \u2013 " + euroLim(b);
  }


  function ct(n) { return Number(n).toFixed(2).replace(".", ","); }
  function mmTxt(n) { return Number(n).toFixed(1).replace(".", ",") + " mm"; }
  function quante(n) { return num(n) + (n === 1 ? " pietra" : " pietre"); }
  function fuggi(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  /* ══════════════════ LE VOCI DEL PERCORSO ══════════════════
     Gli id sono GLI STESSI della pagina v1: al clic su una pietra si passa di
     là con questi nomi nell'indirizzo, e la v1 li capisce senza traduzioni. */

  /* Il taglio si chiama GOCCIA, ed e' il nome che usa la casa: "pera" e' la
     traduzione letterale dell'inglese "pear" e sul sito non compare mai. La
     chiave del feed e' gia' "goccia", quindi qui chiave ed etichetta coincidono
     diverse, da tenere separate (stessa trappola già documentata nella v1). */
  /* L'ORDINE CONTA ED E' STATO CHIESTO COSI': la giostra gira in tondo e
     attorno al rotondo - che è il preselezionato - ci devono stare il cuore a
     sinistra e la goccia a destra. Il cuore è quindi l'ULTIMA voce, perché in
     un anello l'ultima sta a sinistra della prima; la goccia è la seconda.
     Spostando una voce si sposta anche quello che si vede accanto al rotondo. */
  var FORME = [
    { id: "rotondo",  nome: "Tondo",        disegno: "taglio-rotondo.jpg",  riga: "Il classico: è il taglio che rende più luce di tutti." },
    { id: "goccia",   nome: "Goccia",      disegno: "taglio-goccia.jpg",   riga: "Una punta sola, si porta con la punta verso l'unghia." },
    { id: "ovale",    nome: "Ovale",       disegno: "taglio-ovale.jpg",    riga: "Allunga il dito e sembra più grande a parità di peso." },
    { id: "cushion",  nome: "Cushion",     disegno: "taglio-cushion.jpg",  riga: "Angoli morbidi e luce più calda: per chi ama il romantico." },
    { id: "princess", nome: "Principessa", disegno: "taglio-princess.jpg", riga: "Quadrata, spigoli netti: per chi vuole un segno moderno." },
    { id: "smeraldo", nome: "Smeraldo",    disegno: "taglio-smeraldo.jpg", riga: "Gradini larghi, luce a lampi invece che a scintille." },
    { id: "marquise", nome: "Marquise",    disegno: "taglio-marquise.jpg", riga: "Affusolata alle due punte: la più slanciata di tutte." },
    { id: "radiant",  nome: "Radiant",     disegno: "taglio-radiant.jpg",  riga: "Rettangolare con gli angoli tagliati: brillante ma squadrata." },
    { id: "cuore",    nome: "Cuore",       disegno: "taglio-cuore.jpg",    riga: "Il taglio più esplicito di tutti: si regala per dire una cosa sola." }
  ];

  /* I sei colori fancy, nell'ordine in cui il cliente li ha elencati. Non
     hanno un conteggio perche' nel feed non c'e' nessuna pietra colorata: il
     ramo porta in boutique, non a una lista. */
  /* LE TINTE, con le sigle del feed delle fancy: cambiarle qui senza
     cambiarle in nivoda-fancy.js vorrebbe dire chiedere una tinta che
     l'archivio non conosce. Il numero fra parentesi e' quante ce n'erano il
     15 agosto 2026, giusto per sapere dove si sta: giallo 595, verde 32,
     brown 27, grigio 14, rosa 4, blu 1, arancione 0.
     L'arancione resta nella giostra anche se oggi non ce n'e' nessuno,
     esattamente come il cuore fra i tagli: e' un colore che la gente cerca, e
     la schermata vuota sa gia' dire "lo cerchiamo noi". */
  /* I COLORI DELLA GIOSTRA, e l'animazione di ognuno.

     LA FAMIGLIA BROWN E' UNA VOCE SOLA. Per un momento erano due, Champagne e
     Cognac, che sono i nomi con cui un gioielliere li vende; ma chi cerca un
     diamante marrone cerca "brown", e trovarsi davanti due nomi di liquori
     senza la parola che aveva in mente e' un vicolo cieco. I 47 brown stanno
     tutti qui dentro — i 27 con tinta principale BROWN piu' i 20 giallo-bruni
     che il GIA chiama "Fancy Light Brownish Yellow" e che un gioielliere
     venderebbe come champagne. Champagne e cognac restano scritti sulla
     scheda della singola pietra, dove servono a distinguere due pietre fra
     loro invece che a fare da porta d'ingresso.

     Le sigle sono le tinte del feed, tranne "lilla" e "rosso" che portano una
     "tinta" loro perche' nell'archivio si chiamano viola e rosso.

     Quando "tinta" non c'e', vale la sigla. Quante pietre ci sono oggi
     (15 agosto 2026): giallo 575, verde 32, champagne 29, cognac 18, rosa 4,
     lilla 1, blu 1, rosso 0.

     Le animazioni sono nostre: 600x600, WebP animato, mezzo megabyte l'una —
     erano GIF da cinque megabyte e sono state ritagliate sulla sagoma perche'
     la pietra riempisse il riquadro come nelle fotografie dei tagli bianchi,
     dove ne occupa il 95%. Prima ne occupava il 45% e i colori sarebbero
     sembrati la meta' dei bianchi. */
  var COLORI = [
    { id: "giallo",    nome: "Gialli",    gif: "fancy-giallo-p.webp",
      riga: "Dal giallo tenue al canarino pieno: il fancy pi\u00f9 diffuso, e il pi\u00f9 facile da portare." },
    { id: "brown",     nome: "Brown",     gif: "fancy-brown-p.webp",
      riga: "Dal champagne chiaro al cognac scuro: caldo, si porta tutti i giorni, e a parità di peso è il più accessibile dei fancy." },
    { id: "verde",     nome: "Verdi",     gif: "fancy-verde-p.webp",
      riga: "Nascono verdi sottoterra, per irraggiamento naturale: rarissimi da certificare." },
    { id: "rosa",      nome: "Rosa",      gif: "fancy-rosa-p.webp",
      riga: "Il pi\u00f9 ricercato di tutti: pochi grezzi al mondo, quasi tutti da una miniera sola, ormai chiusa." },
    { id: "lilla",     nome: "Lilla",     gif: "fancy-lilla-p.webp", tinta: "viola",
      riga: "Fra il rosa e il viola: se ne certificano pochissimi, e quasi mai sopra il carato." },
    { id: "blu",       nome: "Blu",       gif: "fancy-blu-p.webp",
      riga: "Il colore delle pietre da collezione: il boro nel reticolo, e il prezzo che ne consegue." },
    /* I ROSSI SONO USCITI dalla giostra, su richiesta. Nel feed non ce n'e'
       nemmeno uno: il rosso e' il fancy piu' raro che esista, se ne conoscono
       poche decine al mondo, e la voce portava sempre e solo al messaggio
       "stai cercando un diamante raro". Per rimetterla basta una riga come
       quelle qui sopra, con id, nome, gif "fancy-rosso-d.webp" e tinta
       "rosso" — la fotografia e' ancora negli assets. */
  ];

  /* LE TRE FASCE DELLE FANCY.

     Sulle bianche le tre porte nascono da colore e purezza. Qui la purezza
     conta pochissimo — una pietra di colore si compra per il colore — e
     quello che muove tutto e' l'INTENSITA', cioe' il gradino della scala del
     GIA scritto sul certificato.

     MISURATO sul feed del 15 agosto 2026: Delicata 333 pietre (mediana
     5.131 euro), Intensa 286 (8.400), Vivida 53 (21.555). Per una volta le
     tre fasce si mettono in fila da sole anche sul prezzo, senza le
     inversioni che sulle bianche avevano costretto a rifarle tre volte: sul
     colore la scala del GIA e quella dei prezzi vanno d'accordo. */
  var QUALITA_FANCY = [
    { id: "delicata", nome: "Delicata", riga: "Fancy Light",
      spiega: "Il colore si manifesta con leggerezza, lasciando alla pietra una luminosità delicata e raffinata." },
    { id: "intensa",  nome: "Intensa",  riga: "Fancy \u00b7 Dark \u00b7 Deep \u00b7 Intense",
      spiega: "Il colore acquista profondità e carattere, diventando l’elemento dominante della pietra." },
    { id: "vivida",   nome: "Vivida",   riga: "Fancy Vivid",
      spiega: "Una presenza cromatica straordinaria, dove intensità e saturazione raggiungono la loro espressione più vibrante." }
  ];

  /* Le fotografie del cliente: nome del file negli assets, dal campo testo
     delle impostazioni. Se il campo è vuoto o il file non c'è ancora, si
     ripiega sul disegno del taglio senza rompere niente. */
  var FOTO = { bianchi: root.getAttribute("data-img-bianchi") || "",
               fancy:   root.getAttribute("data-img-fancy") || "" };
  FORME.forEach(function (f) { FOTO[f.id] = root.getAttribute("data-img-" + f.id) || ""; });
  COLORI.forEach(function (c) {
    /* LA FOTOGRAFIA DELLA PIETRA, non un disegno segnaposto: entra in FOTO,
       se no metti() le mette addosso la classe che la rimpicciolisce del
       dodici per cento e la sbiadisce.

       Dal 17 agosto 2026 sono sei scatti fermi al posto delle animazioni: una
       pietra per colore, ritagliata dalla stessa tavola — asscher rosa,
       radiant giallo, cushion blu, goccia champagne, smeraldo lilla,
       marquise verde — con la loro ombra sotto, che il cliente ha chiesto di
       tenere. Il campo si chiama ancora "gif" per non toccare tre punti di
       codice per un nome. */
    /* L'ANIMAZIONE VIENE PRIMA dell'impostazione del tema. Su quattro colori
       (giallo, verde, rosa, blu) c'era gia' una fotografia ferma configurata
       mesi fa: lasciando vincere quella, meta' giostra sarebbe rimasta immobile
       accanto a meta' giostra animata. Chi vuole tornare a una fotografia ferma
       ha ancora il campo, ma deve cambiare anche questa riga: e' una scelta,
       non una svista. */
    FOTO[c.id] = c.gif || root.getAttribute("data-img-" + c.id) || "";
  });

  /* Le fasce sono le stesse della v1, tarate sui prezzi veri del feed
     (minimo assoluto 180 €: nessuna fascia è vuota per nessuna forma). */
  /* ————— le carature —————
     Ogni voce vale FINO ALLA SUCCESSIVA: "dimensione indicativa" non puo'
     voler dire un peso esatto, perche' le pietre sono un continuo e a 1,00 ct
     spaccato ce ne sono pochissime. Le soglie tonde sono strapiene (a 1,50 ct
     esatti ci sono 2.112 pietre), quindi ogni scaglione parte dalla sua
     soglia compresa. Contate sul feed vero con tools/conta-fasce.js. */
  /* OGNI SCAGLIONE COMINCIA ESATTAMENTE DAL SUO PESO (19 settembre 2026):
     «quando uno sceglie ad esempio 0.70, si parte esattamente da 0.70».

     Prima ognuno partiva dieci centesimi sotto, ed era una scelta ragionata:
     una 0,97 al dito sembra un carato e costa molto meno, perche' il prezzo
     fa un gradino netto sulle misure tonde — a un carato l'ingresso passava
     da 3.009 a 2.686 euro. Ma chi sceglie "1,00 ct" ha chiesto un carato, e
     vedersi offrire una 0,90 e' la risposta a un'altra domanda. La pietra
     conveniente appena sotto la soglia resta il consiglio da dare al banco,
     non una sorpresa nella lista.

     LA PARTE DI SOPRA ARRIVA AL GRADINO SUCCESSIVO, ed e' una misura non una
     preferenza. Con le bande strette abbozzate — 0,70 fino a 0,85, 1,00 fino
     a 1,15 — contate sul feed vero: 3.712 diamanti bianchi su 15.193
     (il 24,4%) e 1.066 fancy su 7.439 (il 14,3%) finirebbero nei buchi fra
     una fascia e l'altra, dove nessun pulsante arriva. Cosi' invece le sei si
     toccano senza sovrapporsi e non si perde niente: zero pietre fuori, su
     tutti e due i rami.

     Per avere anche la parte di sopra stretta servirebbero otto pastiglie
     invece di sei (0,30 · 0,50 · 0,70 · 0,90 · 1,00 · 1,20 · 1,50 · 2+), e
     allora 0,70 arriverebbe a 0,89 e 1,00 a 1,19 sempre senza buchi. E' una
     scelta d'impaginazione: le sei stanno in una riga sola.

     I conteggi delle pastiglie adesso sommano al totale, perche' le fasce non
     si sovrappongono piu'.

     FASCE CAMBIATE l'8 settembre 2026, su richiesta: erano 0,50 · 1 · 1,5 · 2
     · 3 · 3+, adesso sono 0,30 · 0,50 · 0,70 · 1 · 1,5 · 2+. Il taglio fine in
     basso serve perche' li' sta il grosso del magazzino; sopra i due carati le
     pietre sono poche e una fascia sola basta.

     LA STESSA LISTA VALE PER I FANCY, che leggono queste caratura senza averne
     una loro. Il feed dei colorati pero' parte da 0,50 ct: sul ramo fancy la
     pastiglia "0,30" e' quindi sempre vuota. */
  var CARATURE = [
    { id: "c030", nome: "0,30 ct", min: 0.30, max: 0.49 },
    { id: "c050", nome: "0,50 ct", min: 0.50, max: 0.69 },
    { id: "c070", nome: "0,70 ct", min: 0.70, max: 0.99 },
    { id: "c100", nome: "1,00 ct", min: 1.00, max: 1.49 },
    { id: "c150", nome: "1,50 ct", min: 1.50, max: 1.99 },
    { id: "coltre", nome: "2 ct +", min: 2.00, max: 40 }
  ];

  /* ————— le fasce di qualita' —————
     Sono SOGLIE, non intervalli chiusi, e a decidere e' l'anello debole: una
     pietra prende la fascia piu' alta di cui regge sia il colore sia la
     purezza. Un D di colore ma SI1 di purezza non e' una rarita', e' una
     essenziale con un bel colore.

     Gli id sono gli stessi di _preview/nivoda-feed.js: se cambiano li' vanno
     cambiati anche qui. Misurato: cosi' ogni pietra sta in una fascia e una
     sola, le tre insieme coprono il 100% del magazzino, e il prezzo cresce da
     una fascia all'altra a ogni caratura — cosa che con gli intervalli chiusi
     non succedeva (a 5 ct la scala si rovesciava). */
  var QUALITA = [
    { id: "essenziale", nome: "Essenziale",
      riga: "colore D–H · purezza VS1–VS2",
      spiega: "Una selezione equilibrata tra bellezza e valore. Diamanti luminosi e con inclusioni difficilmente percepibili a occhio nudo." },
    { id: "eccellenza", nome: "Eccellenza",
      riga: "colore D–F · purezza VVS1–VVS2",
      spiega: "Una qualità superiore, scelta per chi ricerca un diamante particolarmente bianco e una purezza elevata, anche osservandolo da vicino." },
    { id: "rarita", nome: "Rarità",
      riga: "colore D–E · purezza IF–FL",
      spiega: "Diamanti ai vertici delle scale di colore e purezza. Pietre eccezionali, selezionate per chi ricerca caratteristiche gemmologiche di assoluto rilievo." }
  ];

  function trova(elenco, id) {
    for (var i = 0; i < elenco.length; i++) if (elenco[i].id === id) return elenco[i];
    return null;
  }

  /* ══════════════════ LO STATO, CHE VIVE NELL'INDIRIZZO ══════════════════
     Come nella v1: il tasto indietro del browser funziona da solo, un percorso
     si può mandare a qualcuno, chi ricarica non riparte da capo. */
  var S = { ramo: "bianchi", passo: 1, forma: "", colore: "", caratura: "", fascia: "",
            pietra: "", pietre: [], totale: 0, salto: 0, pagina: 1,
            /* i due cursori sotto la fascia dei risultati: vuoti = nessun
               restringimento, e allora valgono la caratura scelta e tutto il
               listino */
            ctDa: null, ctA: null, pzDa: null, pzA: null };

  /* "3" e "4" erano le due domande separate su misura e qualita': ora sono
     dentro la schermata del taglio, e un indirizzo vecchio ci finisce li'
     invece di rompersi. */
  var PASSI_VALIDI = { "1": 1, "2c": "2c", "fancy": "fancy", "2": 2, "3": 2, "4": 2,
                       "esito": "esito", "pietra": "pietra" };

  function leggiUrl() {
    var p = new URLSearchParams(location.search);
    S.passo  = PASSI_VALIDI[p.get("passo") || "1"] || 1;
    var f = p.get("forma") || "";
    S.forma  = trova(FORME, f) ? f : "";
    var c = p.get("colore") || "";
    S.colore = trova(COLORI, c) ? c : "";
    /* SU QUALE MAGAZZINO SIAMO. Sta nell'indirizzo perche' senza di lui un
       collegamento a una pietra di colore, o un ritorno indietro dal browser,
       finirebbe a chiedere quella pietra all'archivio dei bianchi — che non
       ce l'ha. Se il parametro manca ma c'e' un colore scelto, si capisce
       lo stesso: sono i vecchi indirizzi, e devono continuare a funzionare. */
    S.ramo = (p.get("ramo") === "fancy" || (!p.get("ramo") && c && !f)) ? "fancy" : "bianchi";
    /* Un carato e' la misura da cui parte quasi chiunque: aprire il pannello
       senza nessuna misura accesa vorrebbe dire mostrare i prezzi di tutto il
       magazzino, che non aiutano a decidere niente. */
    S.caratura = trova(CARATURE, p.get("caratura") || "") ? p.get("caratura") : "c100";
    sistemaCaratura();          /* ramo=fancy con caratura=c030: non esiste */
    var fa = p.get("fascia") || "";
    S.fascia = (trova(QUALITA, fa) || trova(QUALITA_FANCY, fa)) ? fa : "";
    /* La sigla di una pietra: dodici caratteri esadecimali e nient'altro. Non
       si fida di quello che arriva nell'indirizzo — finisce in una fetch e in
       un attributo — e quello che non ha questa forma non è una nostra sigla. */
    var sg = (p.get("pietra") || "").trim();
    S.pietra = /^[a-z0-9]{6,32}$/i.test(sg) ? sg : "";
    /* Un indirizzo che salta ai passi 3..5 o all'esito senza un taglio scelto
       è monco: si riparte dalla giostra, col rotondo preselezionato.
       LA SCHEDA DI UNA PIETRA STA NELL'ELENCO DEI PASSI CHE NON HANNO BISOGNO
       DELLA FORMA, ed è la ragione per cui un collegamento diretto funziona:
       chi riceve ?passo=pietra&pietra=<sigla> non ha fatto nessun percorso e
       non deve farne uno per vedere il diamante che gli hanno mandato. */
    var SENZA_FORMA = { "1": 1, "2c": 1, "fancy": 1, "2": 1, "pietra": 1 };
    /* sul ramo delle fancy la cosa scelta nella giostra e' il colore, non la
       forma: senza colore si torna alla giostra dei colori, non a quella dei
       tagli */
    if (fancyOra()) {
      if (!SENZA_FORMA[String(S.passo)] && !S.colore) S.passo = "2c";
      if (S.passo === 2) S.passo = "2c";
    } else if (!SENZA_FORMA[String(S.passo)] && !S.forma) S.passo = 2;
    /* ...ma la scheda senza sigla non è una scheda: si torna all'inizio. */
    if (S.passo === "pietra" && !S.pietra) S.passo = 1;
  }

  function scriviUrl(push) {
    var p = new URLSearchParams();
    p.set("passo", String(S.passo));
    if (S.ramo === "fancy") p.set("ramo", "fancy");
    if (S.forma)  p.set("forma", S.forma);
    if (S.colore) p.set("colore", S.colore);
    if (S.caratura) p.set("caratura", S.caratura);
    if (S.fascia)   p.set("fascia", S.fascia);
    /* la sigla si scrive SOLO sulla scheda: lasciarla addosso ai risultati
       farebbe riaprire il diamante a ogni ritorno indietro */
    if (S.passo === "pietra" && S.pietra) p.set("pietra", S.pietra);
    var u = location.pathname + "?" + p.toString();
    if (push) history.pushState({ cp2: 1 }, "", u); else history.replaceState({ cp2: 1 }, "", u);
  }

  /* ══════════════════ LE INTERROGAZIONI ══════════════════ */

  function bCaratura() { return trova(CARATURE, S.caratura); }

  /* LE CARATURE CHE HANNO SENSO SUL RAMO CORRENTE. Il feed dei colorati parte
     da 0,50 ct, quindi sul ramo fancy la fascia 0,30 sarebbe sempre vuota:
     si toglie invece di lasciare una pastiglia che porta a un elenco vuoto.
     (deciso l'8 settembre 2026) Se un giorno Nivoda mandasse fancy piu'
     piccoli, basta togliere questa funzione e tornare a CARATURE. */
  var SENZA_FANCY = ["c030"];
  function caratureDelRamo() {
    if (S.ramo !== "fancy") return CARATURE;
    return CARATURE.filter(function (c) { return SENZA_FANCY.indexOf(c.id) < 0; });
  }
  /* Se la caratura accesa non esiste su questo ramo, si scende alla prima che
     esiste: uno stato che il pannello non puo' disegnare non deve esistere. */
  function sistemaCaratura() {
    var ok = caratureDelRamo();
    if (!trova(ok, S.caratura)) S.caratura = ok[0].id;
  }
  /* LA FASCIA SI CERCA IN TUTTE E DUE LE SCALE. Cercandola solo fra le tre
     dei bianchi, sul ramo delle fancy trova() tornava undefined — "vivida"
     nell'elenco dei bianchi non c'e' — e chi poi ne leggeva il nome trovava
     undefined. E' cosi' che moriva il pulsante "Richiedi informazioni" sulle
     pietre di colore: percorsoInChiaro() faceva .toLowerCase() su quel niente
     e il gestore del clic si fermava li', prima di aprire il modulo. */
  function bQualita()  { return trova(QUALITA, S.fascia) || trova(QUALITA_FANCY, S.fascia); }

  /* Il tranello del ct_min, ereditato e documentato dalla v1: senza ct_min e
     ct_max l'archivio apre in silenzio una forbice del 50% attorno a 1 ct e
     restituisce due terzi di magazzino in meno. Si mandano SEMPRE. */
  function query(o) {
    o = o || {};
    var f  = o.forma !== undefined ? o.forma : (S.forma || "tutte");
    var ct = bCaratura();
    /* I CURSORI VINCONO sulla pastiglia della caratura: la pastiglia dice da
       dove si e' partiti, il cursore dice dove si e' arrivati. Con
       "senzaCursori" si chiede invece l'insieme intero, ed e' cosi' che si
       misurano gli estremi da dare ai cursori stessi — se li chiedessimo con
       i cursori attivi si stringerebbero da soli a ogni tocco. */
    var da = o.ctDa !== undefined ? o.ctDa
           : (!o.senzaCursori && S.ctDa != null ? S.ctDa : (ct ? ct.min : 0.50));
    var a  = o.ctA  !== undefined ? o.ctA
           : (!o.senzaCursori && S.ctA != null ? S.ctA : (ct ? ct.max : 40));
    var fa = o.fascia !== undefined ? o.fascia : S.fascia;

    /* Sui bianchi si chiede una FORMA, sulle fancy una TINTA: e' l'unica
       differenza fra le due domande, e sta tutta qui. Il chiamante passa
       sempre "forma" perche' per lui e' "la cosa scelta nella giostra". */
    /* Sul ramo delle fancy la voce della giostra puo' non essere una tinta:
       "champagne" e "cognac" sono due sfumature della stessa tinta brown, e
       all'archivio si chiedono con tinta + etichetta. */
    var eti = "";
    if (fancyOra()) {
      var voce = trova(COLORI, o.forma !== undefined ? o.forma : S.colore);
      if (o.forma === undefined) f = S.colore || "tutte";
      if (voce) { f = voce.tinta || voce.id; eti = voce.etichetta || ""; }
    }
    var q = [(fancyOra() ? "tinta=" : "forma=") + encodeURIComponent(f),
             "ct_min=" + da, "ct_max=" + a];
    if (eti) q.push("etichetta=" + encodeURIComponent(eti));
    if (fa) q.push("fascia=" + encodeURIComponent(fa));
    /* Dalla piu' accessibile in su: e' l'ordine onesto quando il budget non lo
       si e' chiesto, ed e' anche quello che rende vero l'"a partire da"
       scritto sulla scheda della fascia. */
    if (!o.senzaCursori) {
      if (S.pzDa != null) q.push("prezzo_min=" + Math.round(S.pzDa));
      if (S.pzA  != null) q.push("prezzo_max=" + Math.round(S.pzA));
    }
    q.push("ordine=prezzo", "verso=" + (o.verso || "asc"));
    return q.join("&");
  }


  function chiedi(qs) {
    return fetch(apiOra() + "?" + qs, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (!d || !d.ok) throw new Error((d && d.error) || "risposta non valida"); return d; });
  }

  /* Solo il totale, e con una memoria: tornando indietro e avanti fra i passi
     le stesse domande non si rifanno all'archivio, che tanto cambia ogni ora
     e non ogni click. */
  var CONTE = {};
  function conta(qs) {
    if (qs in CONTE) return Promise.resolve(CONTE[qs]);
    return chiedi(qs + "&limite=1&conta=1")
      .then(function (d) { CONTE[qs] = d.totale; return d.totale; })
      .catch(function () { return null; });
  }

  var giro = 0;   /* per buttare via le risposte arrivate in ritardo */
  var giroPannello = 0;   /* lo stesso, per i numeri sotto la giostra */

  /* ══════════════════ NAVIGAZIONE FRA LE SCHERMATE ══════════════════ */

  /* I CURSORI VIVONO SOLO SULL'ELENCO E SULLA SCHEDA DI UNA PIETRA.
     Uscendo verso una qualunque altra schermata si azzerano: restando appesi,
     rientrando si sarebbe visto un elenco gia' filtrato senza sapere perche',
     e le tre schede delle fasce si contavano addosso quel filtro.
     "pietra" e' compresa apposta: da li' si torna all'elenco, e l'elenco deve
     essere quello che si era lasciato. */
  function cursoriValgonoQui(passo) { return passo === "esito" || passo === "pietra"; }

  function vai(passo, push) {
    if (!cursoriValgonoQui(passo) && cursoriValgonoQui(S.passo)) cursoriFuori();
    S.passo = passo;
    scriviUrl(push !== false);
    disegna(true);
  }

  function schermate() {
    return { s1: el("[data-cp3-s1]"), s2c: el("[data-cp3-s2c]"), fancy: el("[data-cp3-fancy]"),
             s2: el("[data-cp3-s2]"), sq: el("[data-cp3-sq]"), esito: el("[data-cp3-esito]"),
             pietra: el("[data-cp3-scheda]") };
  }

  /* La firma dei filtri: serve a una cosa sola, sapere se i risultati che
     abbiamo in mano rispondono ancora alla domanda che l'indirizzo pone.
     Tornando indietro dalla scheda di una pietra la risposta è sì, e allora le
     pietre si ridisegnano invece di richiederle: un giro di rete in meno e —
     quello che conta davvero — la posizione nella pagina che il browser
     ripristina trova sotto di sé le stesse schede di prima. */
  var firma = "";
  function firmaFiltri() {
    return [S.ramo, S.forma, S.colore, S.caratura, S.fascia,
            S.ctDa, S.ctA, S.pzDa, S.pzA].join("|");
  }

  function disegna(conFuoco) {
    giro++;
    var sc = schermate();
    for (var k in sc) sc[k].hidden = true;
    el("[data-cp3-guasto]").hidden = true;
    /* sulla scheda della pietra il titolo della pagina è il nome del diamante:
       "Cerca la tua pietra" si toglie di mezzo (vedi il commento sul markup) */
    /* La testata col titolo di pagina non esiste piu' — il cliente l'ha fatta
       togliere quando la scelta e' diventata una schermata sola — ma la riga
       che la nascondeva sulla scheda della pietra era rimasta, e cercando un
       elemento che non c'e' faceva morire disegna() a meta': la pagina si
       apriva con TUTTE le schermate nascoste e niente al loro posto. Si tiene
       il richiamo, tollerante, perche' chi rimettesse una testata domani
       ritrovi il comportamento giusto senza doverlo riscoprire. */
    var testa = el("[data-cp3-testa]");
    if (testa) testa.hidden = S.passo === "pietra";
    /* i due pulsanti fissi vivono solo sulla scheda di una pietra: altrove
       non avrebbero niente da chiedere e niente da certificare */
    var flot = el("[data-cp3-flot]");
    if (flot) flot.hidden = S.passo !== "pietra";
    /* Uscendo dalla scheda il visore di loupe360 esce dal documento. Un iframe
       di terzi lasciato acceso dietro una schermata nascosta continua a
       scaricare e a far girare la sua applicazione: invisibile e costoso. */
    if (S.passo !== "pietra") spegniScheda();
    codaSospesa = (S.passo === "pietra");
    if (!codaSospesa) tiraCoda();

    var fuoco = null;
    if (S.passo === 1)            { sc.s1.hidden = false;    fuoco = "[data-cp3-fuoco-s1]"; }
    else if (S.passo === "2c")    { sc.s2c.hidden = false;   fuoco = "[data-cp3-fuoco-s2c]"; giostraColori(); }
    else if (S.passo === "fancy") { sc.fancy.hidden = false; fuoco = "[data-cp3-fuoco-fancy]"; diciColore(); }
    else if (S.passo === 2)       { sc.s2.hidden = false;    fuoco = "[data-cp3-fuoco-s2]"; giostra(); }
    else if (S.passo === "pietra"){ sc.pietra.hidden = false; fuoco = "[data-cp3-fuoco-p]"; scheda(); }
    else if (S.passo === "esito") {
      sc.esito.hidden = false; fuoco = "[data-cp3-fuoco-esito]";
      if (S.pietre.length && firmaFiltri() === firma) { disegnaLista(); }
      else cerca(true);
    }
    else                          { sc.sq.hidden = false;    fuoco = "[data-cp3-fuoco-sq]"; domanda(); }

    /* Il fuoco segue la schermata (serve a chi naviga con la tastiera o con
       una voce), ma solo dopo un gesto: al primo caricamento non si ruba. */
    if (conFuoco && fuoco) {
      var h = el(fuoco);
      if (h) h.focus({ preventScroll: true });
    }
    /* in cima solo sui passi in avanti: al ritorno col tasto indietro il
         browser ripristina da solo la posizione, e forzarla in alto la perde */
      if (!S.daPopstate) window.scrollTo(0, 0);
      S.daPopstate = false;
  }

  /* ══════════════════ 1 · LO SCHERMO DIVISO ══════════════════ */

  /* La fotografia del cliente entra solo se il file esiste davvero: se il
     campo è pieno ma il file manca, l'errore la toglie e resta il fondo
     chiaro, mai l'icona rotta del browser. */
  function metti(cont, file, disegno, classeDisegno) {
    if (!cont || cont.getAttribute("data-pronto")) return;
    cont.setAttribute("data-pronto", "1");
    var nome = file || disegno;
    if (!nome) return;
    var img = document.createElement("img");
    img.alt = "";
    img.loading = "lazy";
    if (!file && classeDisegno) img.className = classeDisegno;
    img.addEventListener("error", function () {
      if (file && disegno) { img.src = ASSETS + disegno; if (classeDisegno) img.className = classeDisegno; file = ""; }
      else img.remove();
    });
    img.src = ASSETS + nome;
    cont.appendChild(img);
  }

  metti(el("[data-cp3-mezzo-foto='bianchi']"), FOTO.bianchi, "");
  metti(el("[data-cp3-mezzo-foto='fancy']"), FOTO.fancy, "");
  /* Sono la prima schermata: in lazy il browser puo' non caricarle affatto e
     il cliente apre la pagina su due riquadri vuoti. Misurato. */
  root.querySelectorAll("[data-cp3-mezzo-foto] img").forEach(function (i) { i.loading = "eager"; });

  root.querySelectorAll("[data-cp3-tipo]").forEach(function (b) {
    b.addEventListener("click", function () {
      /* QUI SI CAMBIA MAGAZZINO. Da questo momento ogni domanda va
         all'archivio dei diamanti di colore invece che a quello dei bianchi,
         e le tre fasce diventano quelle dell'intensita'. */
      var fancy = b.getAttribute("data-cp3-tipo") === "fancy";
      S.ramo = fancy ? "fancy" : "bianchi";
      sistemaCaratura();        /* passando ai colorati, 0,30 non c'e' piu' */
      if (!fancy) S.colore = ""; else S.forma = "";
      vai(fancy ? "2c" : 2, true);
    });
  });

  /* ══════════════════ IL RAMO FANCY ══════════════════ */

  el("[data-cp3-contatti]").setAttribute("href", CONTATTI);
  var tel = (root.getAttribute("data-telefono") || "").trim();
  var wa  = (root.getAttribute("data-whatsapp") || "").trim();
  if (wa) {
    var linkWa = el("[data-cp3-wa]");
    linkWa.hidden = false;
    linkWa.setAttribute("href", "https://wa.me/" + wa + "?text=" +
      encodeURIComponent("Salve, vorrei informazioni sui diamanti fancy."));
  }
  if (tel) {
    var linkTel = el("[data-cp3-tel]");
    linkTel.hidden = false;
    linkTel.textContent = "Per telefono: " + tel;
    linkTel.setAttribute("href", "tel:" + tel.replace(/\s+/g, ""));
  }
  /* Il titolo e la fotografia nascono dal colore scelto: senza questo la
     schermata restava con due segnaposto vuoti. Se qualcuno arriva qui con un
     indirizzo senza colore, si parla di fancy in generale e non si rompe. */
  function diciColore() {
    var c = trova(COLORI, S.colore);
    el("[data-cp3-fancy-titolo]").textContent =
      c ? "Diamanti fancy " + c.nome.toLowerCase() : "Diamanti fancy";
    el("[data-cp3-fancy-p1]").textContent = c
      ? c.riga + " Non stanno in un archivio online: ognuno è un pezzo unico e si cerca su richiesta."
      : "Ogni diamante colorato è un pezzo unico e si cerca su richiesta: non c'è un archivio da sfogliare.";
    var box = el("[data-cp3-fancy-foto]");
    box.innerHTML = "";
    box.removeAttribute("data-pronto");
    metti(box, c ? FOTO[c.id] : FOTO.fancy, "");
    var im = box.querySelector("img");
    if (im) im.loading = "eager";
  }

  el("[data-cp3-fancy-indietro]").addEventListener("click", function () { vai("2c", true); });
  el("[data-cp3-fancy-bianchi]").addEventListener("click", function () { vai(2, true); });

  /* ══════════════════ 2 · LA GIOSTRA DEI TAGLI ══════════════════
     Solo frecce e clic, niente trascinamento: coerente col resto del sito.
     La selezione della giostra è provvisoria e NON tocca l'indirizzo: diventa
     una scelta — e una voce di cronologia — solo con "Scegli questo taglio". */

  /* creaGiostra costruisce dentro un contenitore vuoto tutto quello che serve —
     le due frecce, la finestra, il nastro e le carte — e restituisce i pochi
     comandi che servono da fuori. La usano sia i tagli sia i colori fancy: e'
     lo stesso oggetto con voci diverse, quindi le due scelte non possono
     divergere nell'aspetto, che e' esattamente quello che ha chiesto il
     cliente ("la scelta del colore segue lo stesso identico stile").

     Il testo sta SOTTO la fotografia — nome sulla carta, poi nome grande,
     spiegazione e pulsante nel blocco [data-cp3-scelto] — e sulla fotografia
     non passa nessun velo: le sfumature laterali sono sul nastro, non sulle
     immagini. */
  function creaGiostra(cont, voci, opz) {
    opz = opz || {};
    var N = voci.length;
    var slides = [], idx = N;          /* si parte sulla copia di mezzo */

    var sx = document.createElement("button");
    sx.type = "button"; sx.className = "cp3-freccia cp3-freccia--sx";
    sx.setAttribute("aria-label", "Precedente"); sx.innerHTML = "&larr;";
    var dx = document.createElement("button");
    dx.type = "button"; dx.className = "cp3-freccia cp3-freccia--dx";
    dx.setAttribute("aria-label", "Successivo"); dx.innerHTML = "&rarr;";

    var finestra = document.createElement("div");
    finestra.className = "cp3-finestra";
    var nastro = document.createElement("div");
    nastro.className = "cp3-nastro";
    finestra.appendChild(nastro);
    cont.appendChild(sx); cont.appendChild(finestra); cont.appendChild(dx);

    /* TRE COPIE di fila. Si vive sulla seconda; appena si sconfina nella prima
       o nella terza si rientra al centro senza transizione, e siccome la voce
       sotto gli occhi e' identica il salto non si vede. Cosi' le frecce non si
       esauriscono mai e la giostra e' un anello vero. */
    for (var giro = 0; giro < 3; giro++) {
      voci.forEach(function (v) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "cp3-slide";
        b.setAttribute("aria-label", (opz.etichetta || "") + v.nome);
        /* NIENTE nome sotto la fotografia: sta gia' nel blocco descrittivo qui
           sotto, e ripeterlo faceva comparire la stessa parola due volte. */
        b.innerHTML = '<span class="cp3-slide-foto" data-slide-foto></span>';
        var posto = b.querySelector("[data-slide-foto]");
        metti(posto, FOTO[v.id], v.disegno, "is-disegno");
        /* le carte laterali stanno fuori dalla finestra: col lazy resterebbero
           bianche proprio quando servono */
        var im = posto.querySelector("img");
        if (im) im.loading = "eager";
        var mio = slides.length;
        b.addEventListener("click", function () { if (mio !== idx) vaiA(mio); });
        nastro.appendChild(b);
        slides.push(b);
      });
    }

    sx.addEventListener("click", function () { vaiA(idx - 1); });
    dx.addEventListener("click", function () { vaiA(idx + 1); });

    cont.closest(".cp3-s2").addEventListener("keydown", function (e) {
      if (e.key === "ArrowUp"   || e.key === "ArrowLeft")  { e.preventDefault(); vaiA(idx - 1); }
      if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); vaiA(idx + 1); }
    });

    /* col dito: si trascina e si lascia andare. Sotto i 40 px e' un tocco
       storto, non uno scorrimento, e la carta resta dov'e'. */
    var x0 = null;
    finestra.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    finestra.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var d = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(d) > 40) vaiA(idx + (d < 0 ? 1 : -1));
    }, { passive: true });

    function normale(i) { return ((i % N) + N) % N; }

    function posiziona(conAnimazione) {
      if (!conAnimazione) nastro.style.transition = "none";
      nastro.style.transform =
        "translateX(calc(50% - " + (idx + 0.5) + " * var(--cp3-slide-w)))";
      slides.forEach(function (s, k) { s.classList.toggle("is-attiva", k === idx); });
      if (!conAnimazione) {
        /* si forza il calcolo PRIMA di riaccendere la transizione, altrimenti
           il browser accorpa le due scritture e il salto si vede */
        void nastro.offsetWidth;
        nastro.style.transition = "";
      }
    }

    /* finito lo scorrimento, se siamo su una copia laterale si rientra al
       centro in silenzio: e' questo che rende l'anello infinito */
    nastro.addEventListener("transitionend", function (e) {
      if (e.propertyName !== "transform") return;
      if (idx >= N && idx < N * 2) return;
      idx = N + normale(idx);
      posiziona(false);
    });

    function scrivi() {
      var v = voci[normale(idx)];
      /* IL NOME DICE ANCHE DI CHE COSA SI PARLA. Sotto la giostra c'era
         scritto "Goccia", oppure "Gialli": la parola giusta ma senza il
         soggetto, e chi arriva da un collegamento non sa se sta guardando
         tagli, colori o montature. Il soggetto si ricava dalla voce stessa —
         se sta nell'elenco dei colori e' un colore — cosi' la stessa giostra
         serve tutti e due i rami senza sapere su quale si trova. */
      var eColore = !!trova(COLORI, v.id);
      var eti = /^Diamant/i.test(v.nome) ? v.nome
              : (eColore ? "Diamanti Fancy " + v.nome : "Diamante " + v.nome);
      cont.parentNode.querySelector("[data-cp3-scelto-nome]").textContent = eti;
      cont.parentNode.querySelector("[data-cp3-scelto-riga]").textContent = v.riga;
      if (opz.suCambio) opz.suCambio(v, idx);
    }

    function vaiA(i) { idx = i; posiziona(true); scrivi(); }

    return {
      vaiA: vaiA,
      apri: function (id) {
        var v = trova(voci, id);
        idx = N + (v ? voci.indexOf(v) : 0);
        posiziona(false);
        scrivi();
      },
      scelta: function () { return voci[normale(idx)]; }
    };
  }

  /* ————— 2a · la giostra dei tagli ————— */

  var gTagli = null;
  function giostra() {
    if (!gTagli) {
      gTagli = creaGiostra(el("[data-cp3-s2] [data-cp3-giostra]"), FORME,
        { etichetta: "Taglio ", suCambio: function (v) { S.forma = v.id; scriviUrl(false); pannello(); } });
      el("[data-cp3-s2-indietro]").addEventListener("click", function () { vai(1, true); });
      costruisciPannello();
    }
    /* si riapre sulla forma gia' scelta; alla prima visita, rotondo */
    gTagli.apri(S.forma);
  }

  /* ══════════════════ IL PANNELLO: MISURA E QUALITA' ══════════════════
     Sta sotto la giostra, nella stessa schermata, ed e' vivo: a ogni cambio
     di taglio o di misura i numeri si rifanno chiedendoli al feed. Non c'e'
     niente da confermare, e non c'e' nessun ordine obbligato — si puo'
     cambiare il taglio dopo aver scelto la fascia, e tutto si riallinea.

     Le richieste sono tante (sette misure piu' tre fasce a ogni tocco):
     per questo c'e' un ritardo di 200 ms che accorpa i clic veloci, un
     contatore di giro che butta le risposte arrivate tardi, e la cache di
     conta()/chiedi() che non richiede due volte la stessa cosa. */

  /* SI COSTRUISCE DUE VOLTE: una per la schermata dei tagli e una per quella
     dei colori. Le pastiglie della misura sono identiche (la caratura non
     cambia fra bianchi e fancy, ed e' una sola scelta condivisa: segnaScelte
     accende le stesse in tutte e due); le tre schede invece sono diverse,
     perche' diverse sono le fasce. Le sigle delle fasce non si sovrappongono
     — essenziale/eccellenza/rarita contro delicata/intensa/vivida — quindi
     chi cerca una scheda per sigla trova sempre quella giusta. */
  /* SI COSTRUISCE UNA VOLTA SOLA.

     Questa funzione costruisce tutti e due i pannelli — quello dei tagli e
     quello dei colori — ma era chiamata da due punti, giostra() e
     giostraColori(), ognuno dietro la PROPRIA guardia (gTagli, gColori). Due
     guardie indipendenti non si proteggono a vicenda: chi in una stessa
     visita passava dai bianchi e poi dai fancy la faceva girare due volte, e
     costruisciUno() AGGIUNGE senza mai svuotare. Sei pastiglie diventavano
     dodici su una riga sola, e le tre schede della qualita' sei, impilate.
     E' esattamente quello che il cliente ha visto come "la pagina sembra
     duplicata" — con la seconda terna pure senza prezzo, perche' i conteggi
     riempiPannello() li scrive sulla prima scheda che trova. */
  var pannelloFatto = false;
  function costruisciPannello() {
    if (pannelloFatto) return;
    pannelloFatto = true;
    costruisciUno("[data-cp3-s2]", QUALITA);
    costruisciUno("[data-cp3-s2c]", QUALITA_FANCY);
  }

  function costruisciUno(radice, fasce) {
    var mis = el(radice + " [data-cp3-misura]");
    if (!mis) return;
    /* seconda cintura: questa funzione aggiunge, e chiamarla due volte sullo
       stesso contenitore ne raddoppierebbe il contenuto. Con la guardia qui
       sopra non ci si arriva mai — ma il giorno che qualcuno la chiama da un
       terzo punto, il difetto non torna. */
    mis.innerHTML = "";
    caratureDelRamo().forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cp3-chipm";
      b.setAttribute("data-cp3-ct", c.id);
      /* NIENTE CONTEGGIO sulla pastiglia: il cliente lo vuole solo sulle tre
         fasce. Qui faceva una seconda riga per ogni misura e mandava le
         pastiglie a capo, mentre devono stare tutte su una riga sola. */
      b.innerHTML = '<span class="cp3-chipm-n">' + fuggi(c.nome) + "</span>";
      b.addEventListener("click", function () {
        S.caratura = c.id;
        scriviUrl(false);
        pannello();
      });
      mis.appendChild(b);
    });

    var qua = el(radice + " [data-cp3-qualita]");
    if (!qua) return;
    qua.innerHTML = "";
    fasce.forEach(function (f) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cp3-fascia";
      b.setAttribute("data-cp3-fa", f.id);
      b.innerHTML =
        '<span class="cp3-fascia-nome">' + fuggi(f.nome) +
          /* LA SCELTA DELLA CASA, e SOLO SUI BIANCHI. Sui bianchi
             l'eccellenza e' il punto in cui il rapporto fra quello che si
             vede e quello che si paga e' migliore, e dirlo aiuta chi non sa
             da dove cominciare.

             Sulle fancy no, e non e' una dimenticanza: li' le tre fasce non
             sono gradini di convenienza ma intensita' di colore diverse —
             delicata, intensa, vivida — e una vale l'altra a seconda di che
             pietra si ha in mente. Consigliarne una vorrebbe dire consigliare
             un gusto. Tolto su richiesta del cliente. */
          (f.id === "eccellenza"
            ? '<span class="cp3-consigliata">Suggerimento Curnis</span>' : "") +
          "</span>" +
        '<span class="cp3-fascia-scala">' + fuggi(f.riga) + "</span>" +
        '<span class="cp3-fascia-testo">' + fuggi(f.spiega) + "</span>" +
        '<span class="cp3-fascia-pz" data-pz></span>' +
        /* L'INVITO STA DENTRO LA SCHEDA, non piu' in un pulsante staccato in
           fondo: il cliente l'ha chiesto "dentro le 3 scelte di qualita'".
           La scheda era gia' un <button>, e un pulsante dentro un pulsante non
           e' HTML valido: quindi e' la scheda intera a portare alle pietre, e
           questa riga lo dice a chiare lettere. */
        "";
      b.addEventListener("click", function () {
        /* se non c'e' niente da mostrare, il tocco apre la richiesta invece di
           portare a un elenco vuoto */
        if (b.classList.contains("is-vuoto")) { chiediRicerca(f); return; }
        /* E NEMMENO PRIMA DI SAPERLO. La classe is-vuoto arriva quando torna
           il conteggio, e fra il disegno della scheda e quella risposta
           passano il mezzo secondo del rimbalzo piu' il giro di rete. Chi
           premeva in quella finestra passava lo stesso, e finiva su un elenco
           vuoto: e' la segnalazione "premo mostra diamanti e poi mi dice che
           non ce ne sono". Finche' il numero non c'e', il tocco apre la
           richiesta invece di rischiare il vicolo cieco. */
        if (!b.hasAttribute("data-contate")) { chiediRicerca(f); return; }
        /* un tocco solo: sceglie la fascia E porta all'elenco. Prima ne
           servivano due, uno per scegliere e uno per andare. */
        S.fascia = f.id;
        cursoriFuori();          /* i cursori valgono per la fascia da cui nascono */
        vai("esito", true);
      });
      qua.appendChild(b);
    });
  }

  var attesaPannello = null;
  function pannello() {
    segnaScelte();
    scopriFasce();
    if (attesaPannello) clearTimeout(attesaPannello);
    attesaPannello = setTimeout(riempiPannello, 200);
  }

  /* Le tre schede delle fasce si costruiscono una volta sola all'avvio, quindi
     quella che non serve va nascosta qui, a ogni cambio di colore. Se era lei
     la scelta corrente si ripiega sull'intensa, se no si resterebbe fermi su
     una fascia che non si vede piu'. */
  function scopriFasce() {
    var viva = root.querySelector('[data-cp3-s2c] [data-cp3-fa="vivida"]');
    if (!viva) return;
    var fuori = fancyOra() && S.colore === "brown";
    viva.hidden = fuori;
    if (fuori && S.fascia === "vivida") S.fascia = "intensa";
  }

  /* l'evidenza si mette subito, senza aspettare il feed: il clic deve
     rispondere all'istante anche se i numeri arrivano dopo */
  function segnaScelte() {
    root.querySelectorAll("[data-cp3-ct]").forEach(function (b) {
      b.classList.toggle("is-scelto", b.getAttribute("data-cp3-ct") === S.caratura);
      b.setAttribute("aria-pressed", b.getAttribute("data-cp3-ct") === S.caratura ? "true" : "false");
    });
    root.querySelectorAll("[data-cp3-fa]").forEach(function (b) {
      b.classList.toggle("is-scelto", b.getAttribute("data-cp3-fa") === S.fascia);
      b.setAttribute("aria-pressed", b.getAttribute("data-cp3-fa") === S.fascia ? "true" : "false");
    });
  }

  /* Che cosa stava cercando, in italiano: serve sia al banner sia al modulo
     di richiesta, e chi risponde in boutique legge questa riga e sa gia' tutto. */
  function cheCosaCerca(f) {
    var p = [];
    /* "Diamanti rosa" diceva il colore ma non che grado di colore: sono
       diamanti FANCY, ed e' il fatto che li distingue da un bianco con una
       sfumatura. Sui bianchi vale lo stesso ragionamento: "Taglio goccia"
       nominava il taglio, non la pietra. */
    if (fancyOra()) { var c = trova(COLORI, S.colore); if (c) p.push("Diamanti Fancy " + c.nome); }
    else { var v = trova(FORME, S.forma); if (v) p.push("Diamante " + v.nome); }
    var m = bCaratura(); if (m) p.push(m.nome);
    if (f) p.push(f.nome + " \u2014 " + f.riga);
    return p.join(" \u00b7 ");
  }

  /* Apre il modulo della richiesta SENZA una pietra: al posto della scheda
     tecnica ci va la descrizione di quello che si stava cercando. */
  function chiediRicerca(f) {
    if (!window.CurnisRichiestaPietra) return;
    var che = cheCosaCerca(f);
    window.CurnisRichiestaPietra.apri({
      titolo: "La pietra che stai cercando",
      spec: che,
      dati: che,
      prezzo: "",
      rif: "",
      foto: "", video: "",
      laboratorio: "GIA",
      quando: new Date().toLocaleString("it-IT"),
      percorso: percorsoInChiaro(),
      allargamento: "richiesta senza pietra: in archivio non ce n'erano",
      pagina: location.href
    });
  }

  root.querySelectorAll("[data-cp3-cercala]").forEach(function (b) {
    b.addEventListener("click", function () { chiediRicerca(null); });
  });

  function riempiPannello() {
    var mio = ++giroPannello;
    /* si contano le fasce vuote per sapere se il magazzino non ha proprio
       niente con queste scelte: in quel caso al posto delle tre schede va un
       invito solo */
    var risposte = 0, vuote = 0;
    var nRisposte = bande().length;
    function segnaRisposta(eVuota) {
      if (mio !== giroPannello) return;
      risposte++; if (eVuota) vuote++;
      if (risposte < nRisposte) return;
      var qua = el(radiceOra() + " [data-cp3-qualita]");
      var box = el(radiceOra() + " [data-cp3-nulla]");
      var tutte = vuote === nRisposte;
      if (qua) qua.hidden = tutte;
      if (box) {
        box.hidden = !tutte;
        var che = el(radiceOra() + " [data-cp3-nulla-che]");
        if (che) che.textContent = cheCosaCerca(null);
      }
    }

    /* I conteggi per misura non si chiedono piu': il numero non si mostra
       (vedi sopra) e sei richieste al feed a ogni tocco erano tutte sprecate. */

    /* per ogni fascia: da quanto si parte e quante ce ne sono. Le fasce sono
       quelle del ramo su cui siamo: le altre tre stanno nell'altra schermata,
       nascosta, e non c'e' motivo di interrogare l'archivio per loro. */
    bande().forEach(function (f) {
      var b = root.querySelector('[data-cp3-fa="' + f.id + '"]');
      var slot = b && b.querySelector("[data-pz]");
      if (!slot) return;
      /* si riparte senza risposta: il numero di prima era di un'altra misura */
      b.removeAttribute("data-contate");
      /* Una richiesta sola per fascia: serviva la seconda per il prezzo piu'
         alto dell'intervallo, e l'intervallo non si mostra piu'. */
      /* SENZA CURSORI, sempre. La scheda dice quante pietre ha la fascia e da
         che prezzo parte: e' la definizione della fascia, non puo' dipendere
         dai cursori impostati su un'altra schermata. Senza questo, tornando
         indietro dall'elenco i tre numeri si rimpicciolivano da soli. */
      var qs = query({ fascia: f.id, senzaCursori: true });
      chiedi(qs + "&limite=1")
        .then(function (basso) {
          if (mio !== giroPannello || !slot.isConnected) return;
          if (!basso || !basso.totale) {
            b.classList.add("is-vuoto");
            b.setAttribute("data-contate", "0");
            /* NON PIU' UN VICOLO CIECO. La scheda vuota adesso e' un invito, e
               premendola si apre il modulo della richiesta gia' compilato con
               quello che il cliente stava cercando. */
            slot.innerHTML =
              '<span class="cp3-fascia-eti">in archivio non ce ne sono</span>' +
              '<span class="cp3-fascia-vai cp3-fascia-vai--cerca">Scrivici, la cerchiamo</span>';
            segnaRisposta(true);
            return;
          }
          b.classList.remove("is-vuoto");
          b.setAttribute("data-contate", String(basso.totale));
          segnaRisposta(false);
          var min = basso.pietre && basso.pietre[0] ? basso.pietre[0].prezzo : null;
          /* UNA CIFRA SOLA, la piu' bassa: il cliente ha preferito "a partire
             da" all'intervallo. Il prezzo E' comprensivo di IVA — la scritta
             e' stata tolta su sua richiesta, il calcolo no: verso un privato
             il prezzo esposto e' quello finale, quindi resta giusto anche
             senza dirlo. */
          /* UNA FRASE SOLA, non due righe staccate: il numero e il prezzo
             dicono la stessa cosa — che cosa puoi avere e da quanto — e
             separati si leggevano come due dati scollegati. */
          /* "174 diamanti a partire da" e basta: "disponibili" era una parola
             che non aggiungeva niente e mandava la riga a capo. */
          slot.innerHTML =
            '<span class="cp3-fascia-eti">' + num(basso.totale) +
              (basso.totale === 1 ? " diamante a partire da" : " diamanti a partire da") +
              "</span>" +
            "<b>" + euroPub(min) + "</b>" +
            '<span class="cp3-fascia-vai">Mostra diamanti</span>';
        })
        .catch(function () {
          if (slot.isConnected) slot.textContent = "";
          segnaRisposta(false);      /* un guasto di rete non e' un magazzino vuoto */
        });
    });

    /* Non c'e' piu' nessun pulsante da spegnere: sono le tre schede a portare
       all'elenco, e quella senza pietre si spegne da sola (is-vuoto). */
  }

  /* ————— 2b · la giostra dei colori fancy —————
     Qui NON si scrive nessun conteggio accanto al colore, e non e' una
     dimenticanza: nel feed non c'e' una sola pietra colorata, quindi
     qualunque numero sarebbe inventato. */

  var gColori = null;
  function giostraColori() {
    if (!gColori) {
      /* Come quella dei tagli, e per lo stesso motivo: girando la giostra
         cambia subito il colore scelto e i numeri accanto si rifanno da soli.
         Il pulsante "Scegli questo colore" non c'e' piu' — sono le tre schede
         dell'intensita' a portare all'elenco, con un tocco solo. */
      gColori = creaGiostra(el("[data-cp3-s2c] [data-cp3-giostra]"), COLORI,
        { etichetta: "Diamante ",
          suCambio: function (v) { S.colore = v.id; scriviUrl(false); pannello(); } });
      el("[data-cp3-s2c-indietro]").addEventListener("click", function () { vai(1, true); });
      costruisciPannello();
    }
    gColori.apri(S.colore);
  }

  /* ══════════════════ 3 · 4 · 5: LE DOMANDE ══════════════════ */

  function figura() {
    var f = trova(FORME, S.forma) || FORME[0];
    var box = el("[data-cp3-figura]");
    /* la figura si ricostruisce a ogni passo: il taglio può essere cambiato */
    box.innerHTML = "";
    box.removeAttribute("data-pronto");
    metti(box, FOTO[f.id], f.disegno, "is-disegno");
    el("[data-cp3-figura-nome]").textContent = f.nome;
  }

  function domanda() {
    figura();
    var n = S.passo;                               /* 3 o 4 */
    el("[data-cp3-sq-passo]").textContent = "Passo " + (n - 1) + " di 3 · " +
      (n === 3 ? "La dimensione" : "La qualità");
    el("[data-cp3-sq-barra]").style.width = (n === 3 ? 66 : 100) + "%";
    el("[data-cp3-sq-indietro]").textContent =
      n === 3 ? "← Cambia taglio" : "← Cambia dimensione";
    el("[data-cp3-postilla]").hidden = true;

    if (n === 3) domandaCaratura();
    else domandaFascia();
  }

  el("[data-cp3-sq-indietro]").addEventListener("click", function () {
    vai(S.passo === 3 ? 2 : 3, true);
  });
  el("[data-cp3-cambia-taglio]").addEventListener("click", function () { vai(2, true); });

  var alSalta = null;
  el("[data-cp3-salta]").addEventListener("click", function () { if (alSalta) alSalta(); });

  function domandaCaratura() {
    el("[data-cp3-fuoco-sq]").textContent = "Che dimensione hai in mente?";
    el("[data-cp3-sq-sotto]").textContent =
      "Il carato è un peso, non una misura. Ogni voce vale fino alla successiva: " +
      "scegli la più vicina a quello che hai in mente, si cambia quando vuoi.";
    var post = el("[data-cp3-postilla]");
    post.hidden = false;
    post.textContent =
      "A parità di peso ovale, goccia e marquise si sviluppano più in lunghezza, " +
      "e al dito sembrano un po' più grandi di una rotonda dello stesso carato.";
    el("[data-cp3-salta]").hidden = true;

    var bottoni = opzioni(caratureDelRamo(), S.caratura, function (v) {
      S.caratura = v.id;
      vai(4, true);
    });
    annota(bottoni, caratureDelRamo(), function (v) {
      return query({ ctDa: v.min, ctA: v.max, fascia: "" });
    });
  }

  /* Le tre fasce con il PREZZO VERO della pietra piu' accessibile per la
     caratura scelta. E' questo che sostituisce la domanda sul budget: il
     cliente non dichiara una cifra, la legge — e cambiando caratura la vede
     muoversi, che e' il modo piu' onesto di spiegare perche' una pietra
     costa quello che costa. */
  function domandaFascia() {
    var ct = bCaratura();
    el("[data-cp3-fuoco-sq]").textContent = "Fino a che punto vuoi salire?";
    el("[data-cp3-sq-sotto]").textContent =
      "Colore e purezza seguono la scala GIA. Sotto ogni fascia trovi il prezzo " +
      "della pietra più accessibile che abbiamo oggi" +
      (ct ? " intorno a " + ct.nome.toLowerCase() : "") + ".";
    el("[data-cp3-salta]").hidden = false;
    el("[data-cp3-salta]").textContent = "Mostramele tutte";
    alSalta = function () { S.fascia = ""; vai("esito", true); };

    var bottoni = opzioni(QUALITA, S.fascia, function (v) {
      S.fascia = v.id;
      vai("esito", true);
    });
    annotaPrezzi(bottoni, QUALITA);
  }

  /* "A partire da" vero, non stimato: si chiede una pietra sola, la piu'
     economica della fascia, e si legge il suo prezzo. Se una fascia e' vuota
     lo si dice invece di lasciare il posto in bianco. */
  /* IL PREZZO SULLE TRE FASCE — perche' un INTERVALLO e non una cifra sola.

     Il disegno del cliente diceva "a partire da". Provato sul feed vero, non
     regge: su 56 combinazioni di forma e caratura, in 7 casi (il 12%) il
     minimo della Rarita' finisce SOTTO quello dell'Eccellenza — ovale a
     0,50 ct, 556 contro 559. Provata la mediana: rovescia uguale, il 12%.
     Provata la mediana a peso fisso, con una finestra stretta attorno al peso
     del chip cosi' da confrontare pietre della stessa taglia: ancora il 12%.

     Non e' un difetto del conto, e' il mercato: una rarita' con forte
     fluorescenza o un velo lattiginoso costa davvero meno di un'eccellenza
     pulita. Nessuna statistica singola mettera' mai in fila tre pietre
     pescate da tre insiemi diversi, e forzare l'ordine vorrebbe dire mentire.

     Quindi si smette di far finta che sia una scala di prezzi — la scala e'
     quella della QUALITA', ed e' garantita dalle soglie — e si mostra quello
     che c'e' davvero: da quanto a quanto si spende in quella fascia con la
     dimensione scelta. Due estremi veri. Gli intervalli si sovrappongono, ed
     e' giusto che si veda: e' esattamente cosi' che stanno le cose. */
  function annotaPrezzi(bottoni, voci) {
    var mio = giro;
    voci.forEach(function (v) {
      var b = bottoni[v.id];
      var slot = b && b.querySelector("[data-conta]");
      if (!slot) return;
      slot.textContent = "…";
      /* come sopra: la fascia si conta intera, non filtrata */
      var qs = query({ fascia: v.id, senzaCursori: true });

      Promise.all([chiedi(qs + "&limite=1"), chiedi(qs + "&limite=1&verso=desc")])
        .then(function (r) {
          if (mio !== giro || !slot.isConnected) return;
          var basso = r[0], alto = r[1];
          if (!basso || !basso.totale) {
            b.classList.add("is-vuota");
            slot.textContent = "nessuna con questa dimensione";
            return;
          }
          b.classList.remove("is-vuota");
          var min = basso.pietre && basso.pietre[0] ? basso.pietre[0].prezzo : null;
          var max = alto && alto.pietre && alto.pietre[0] ? alto.pietre[0].prezzo : null;
          if (min == null) { slot.textContent = ""; return; }
          slot.innerHTML =
            '<span class="cp3-dapart">prezzi di oggi</span>' +
            "<b>" + euroFra(min, max) + "</b>" +
            '<span class="cp3-daminimo">' + quante(basso.totale) + " fra cui scegliere</span>";
        })
        .catch(function () { if (slot.isConnected) slot.textContent = ""; });
    });
  }

  function opzioni(voci, attivo, alClic) {
    var box = el("[data-cp3-opzioni]");
    box.innerHTML = "";
    var bottoni = {};
    voci.forEach(function (v) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cp3-op";
      b.setAttribute("aria-pressed", v.id === attivo ? "true" : "false");
      b.innerHTML =
        '<span class="cp3-op-txt">' +
          '<span class="cp3-op-nome">' + fuggi(v.nome) + "</span>" +
          (v.riga ? '<span class="cp3-op-riga">' + fuggi(v.riga) + "</span>" : "") +
          (v.spiega ? '<span class="cp3-op-spiega">' + fuggi(v.spiega) + "</span>" : "") +
        "</span>" +
        '<span class="cp3-op-conta" data-conta></span>';
      b.addEventListener("click", function () { alClic(v); });
      box.appendChild(b);
      bottoni[v.id] = b;
    });
    return bottoni;
  }

  /* Il numero vero accanto a ogni risposta, PRIMA del clic: i vicoli ciechi
     si vedono, non si scoprono dopo. Le risposte in ritardo si buttano. */
  function annota(bottoni, voci, fnQuery) {
    var mio = giro;
    voci.forEach(function (v) {
      var b = bottoni[v.id];
      var slot = b && b.querySelector("[data-conta]");
      if (!slot) return;
      slot.textContent = "…";
      conta(fnQuery(v)).then(function (t) {
        if (mio !== giro || !slot.isConnected) return;
        if (t == null) { slot.textContent = ""; return; }
        if (t === 0) {
          b.classList.add("is-vuota");
          slot.textContent = "nessuna con quello che hai scelto finora";
        } else {
          b.classList.remove("is-vuota");
          slot.textContent = "· " + quante(t);
        }
      });
    });
  }

  /* ══════════════════ I RISULTATI ══════════════════
     Le schede sono le stesse della v1, rifatte qui senza toccare i suoi file.
     Il clic NON apre una modale in questa pagina: porta alla v1 con la sigla
     nell'indirizzo, dove scheda, spiegazioni e richiesta in boutique esistono
     già e restano mantenute in un posto solo. */

  /* VENTI, non dodici (chiesto il 14 settembre 2026). Il conto delle pagine,
     il salto e il riepilogo "n di m" leggono tutti da qui: si cambia solo
     questo numero e il resto segue da solo. */
  var PER_VOLTA = 20;

  /* ══════════════════ LE SCALE DEGLI INDICATORI ══════════════════
     SONO ASSOLUTE E NON SI RICALCOLANO MAI SUI RISULTATI DI OGGI. È la regola
     più importante di questo blocco: il percorso "la più pura" impone
     colore_max=F e purezza_max=VVS2, quindi con una scala relativa la stessa
     identica pietra cambierebbe posizione fra una ricerca e l'altra e la tacca
     smetterebbe di voler dire qualcosa. Sono fisse, e il loro troncamento è
     dichiarato in legenda.

     PERCHÉ IL COLORE SI FERMA A I E LA PUREZZA A SI2. La scala GIA del colore
     arriva fino a Z (23 gradini) e quella della purezza fino a I3 (11): il
     magazzino sta tutto nei primi 6 e nei primi 8, e sotto quei gradini non
     c'è UNA pietra (verificato con conta=1 sull'archivio intero: 60.729
     righe, purezza_max=SI2 ne rende 60.729, cioè tutte).
     I GRADINI NON PESANO TUTTI UGUALE, e va detto perché la motivazione
     scritta qui prima ("fra il 12% e il 18%") era falsa e chi la legge fra un
     anno ci costruisce sopra: sul colore sì, ogni gradino sta fra il 15,9% e
     il 17,7%; sulla purezza no, FL è lo 0,64% (391 pietre, misurate adesso) e
     IF il 6,58% (3.995). I due gradini quasi sempre spenti restano lo stesso,
     e non per simmetria: sono l'ESTREMO MIGLIORE, il posto dove l'occhio va a
     cercare il massimo. Toglierli metterebbe VVS1 in testa e farebbe credere
     che VVS1 sia il meglio che esista.
     Disegnare invece la scala INTERA non è questione di gusto, è questione di
     pixel: il binario misura ~119 px sulla scheda desktop più stretta e ~59 px
     sul telefono a due colonne, quindi 23 gradini con i gap da 3 px darebbero
     2,3 px l'uno sul desktop e sul telefono non ci starebbero affatto (22 gap
     da 3 px fanno già 66 px su 59 disponibili). Per di più 17 segmenti su 23,
     il 74% dell'inchiostro, resterebbero vuoti per sempre, e la differenza fra
     una D e una I — l'unica che il cliente deve vedere, perché è quella che
     muove il prezzo — verrebbe schiacciata in un quarto della larghezza.
     L'onestà si paga con una riga di legenda, non tenendo mezzo binario vuoto.

     LA FLUORESCENZA È L'UNICA COPERTA PER INTERO: cinque gradini, nessun
     taglio, nessuna nota di troncamento. */
  var SCALA_COLORE  = ["D", "E", "F", "G", "H"];
  var SCALA_PUREZZA = ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2"];
  /* SULLE FANCY LA SCALA DELLA PUREZZA E' PIU' LUNGA.

     Sulle bianche si ferma a VS2 perche' le tre fasce non ammettono niente di
     peggio: un gradino che non puo' mai accendersi sarebbe una casella morta.
     Sulle pietre di colore invece la purezza non entra nelle fasce — si
     comprano per il colore — e una SI1 e' una pietra normale e vendibile,
     spesso la piu' interessante come rapporto fra quello che si vede e quello
     che si paga.

     Il 16 agosto 2026 il cliente ha tolto il pavimento della purezza dalla
     configurazione del feed fancy: le SI stanno arrivando. Senza allungare
     questa scala, la riga della purezza su quelle pietre non avrebbe nessun
     gradino acceso e sparirebbe dalla scheda — in silenzio, senza errori. */
  var SCALA_PUREZZA_FANCY = ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2", "I1"];
  /* LA SCALA DELLE FANCY. Su una pietra di colore la lettera D-Z non esiste:
     il GIA scrive QUANTO colore c'e', e la scala e' questa. Sono i sei
     gradini che il commercio usa davvero (dei nove del GIA restano fuori
     Faint, Very Light e Light, che a questi prezzi non si vedono mai), messi
     dal meno colore al piu' colore — che qui e' anche l'ordine del prezzo.
     "Dark" sta fra Fancy e Deep perche' e' li' che lo mette il GIA: e' un
     colore pieno che tende al buio, non un colore tenue. */
  /* DAL PIU' PREGIATO AL MENO, come la scala dei bianchi qui sopra: li' la D
     — il colore migliore — sta a sinistra, e chi guarda una scheda impara a
     leggere "piu' a sinistra, meglio e'". Sulle fancy il gradino piu' alto e'
     il Vivid, quindi va messo dalla stessa parte. Scritta al contrario, la
     stessa posizione voleva dire due cose opposte nelle due schede. */
  var SCALA_INTENSITA = ["Fancy Vivid", "Fancy Intense", "Fancy Deep",
                         "Fancy Dark", "Fancy", "Fancy Light"];
  /* le parole arrivano già tradotte dal feed (mappa FLUO): NON→Nessuna,
     FNT→Debole, MED→Media, STG→Forte, VST→Molto forte */
  /* SOLO NESSUNA E DEBOLE. Da quando il magazzino esclude la fluorescenza da
     media in su, disegnare cinque gradini di cui tre sempre spenti raccontava
     una scala che non esiste: il cliente ha chiesto di togliere quelli che non
     ci servono piu'. Se un giorno si riammettono, si rimettono qui. */
  var SCALA_FLUO    = ["Nessuna", "Debole"];
  /* la scala dei tre gradi di finitura, che nel nostro magazzino è sempre al
     primo gradino: si disegna per intero lo stesso, perché una tacca in testa
     a una scala di cinque dice "il massimo che il GIA assegna", mentre una
     tacca sola senza binario non direbbe niente */
  var SCALA_FINITURA = ["Excellent", "Very good", "Good", "Fair", "Poor"];

  var ORDINALI = ["primo", "secondo", "terzo", "quarto", "quinto", "sesto", "settimo", "ottavo"];
  var QUANTI = { 5: "cinque", 6: "sei", 8: "otto" };

  /* Un binario: N blocchetti alti 6 px, uno solo pieno e alto 10 px sul
     gradino di questa pietra, e sotto le sigle della scala. Il numero di
     colonne non è scritto da nessuna parte — lo conta il CSS dai figli — così
     il disegno non può divergere dai dati.
     Quando il valore non sta nella scala (fluorescenza assente: 27 pietre su
     60.729) si emette il posto vuoto: stessa altezza, nessun segno. Mai un
     binario vuoto e mai la tacca al gradino zero, che si leggerebbero tutti e
     due come "il peggio possibile". */
  /* Le sigle da scrivere sotto ai gradini. Le parole intere della fluorescenza
     e della finitura non ci stanno in un sesto di scheda, quindi si abbreviano
     come fa il certificato: chi legge "EX" su una scala di cinque capisce dov'e'
     senza bisogno della parola intera, e la parola intera resta nella frase per
     chi ascolta e nella scheda della pietra. */
  var SIGLA = {
    "Nessuna": "No", "Debole": "Deb", "Media": "Med", "Forte": "For", "Molto forte": "M.for",
    "Excellent": "EX", "Very good": "VG", "Good": "G", "Fair": "F", "Poor": "P"
  };
  /* i gradini dell'intensita' per esteso non ci starebbero: "Fancy" davanti a
     tutti e' sottinteso, sul certificato c'e' sempre */
  SIGLA["Fancy Light"] = "Light";   SIGLA["Fancy"] = "Fancy";
  SIGLA["Fancy Dark"] = "Dark";     SIGLA["Fancy Deep"] = "Deep";
  SIGLA["Fancy Intense"] = "Intense"; SIGLA["Fancy Vivid"] = "Vivid";

  function binario(scala, valore, classe, nome) {
    var i = scala.indexOf(valore);

    /* IL POSTO VUOTO SI COSTRUISCE COME UNA RIGA VERA, E POI SI NASCONDE.
       Non è un vezzo: prima il ramo del dato mancante emetteva un contenitore
       senza figli, e un contenitore senza figli è alto zero. Con
       visibility:hidden il posto resta occupato, sì, ma alto quanto la sola
       etichetta a sinistra (una riga di testo) invece dei ~23 px di una riga
       disegnata: la scheda restava alta uguale — la griglia ha grid-auto-rows
       1fr, quello è garantito altrove — ma il blocco della finitura le saliva
       di una dozzina di pixel e non era più allineato con le schede accanto.
       Costruendo la riga per intero con i < 0 (nessun gradino acceso, perché
       nessun k può valere -1) l'altezza è identica PER COSTRUZIONE, non per un
       numero scritto a mano che il primo ritocco al disegno smentirebbe. Poi
       cp3-sc--vuota la rende invisibile: il dato che manca non si disegna. */
    var blocchi = "", sigle = "";
    for (var k = 0; k < scala.length; k++) {
      var acceso = k === i;
      blocchi += acceso ? '<i class="on"></i>' : "<i></i>";
      var testo = SIGLA[scala[k]] || scala[k];
      sigle += acceso ? '<span class="on">' + testo + "</span>" : "<span>" + testo + "</span>";
    }
    return '<span class="cp3-sc-riga' + (i < 0 ? " cp3-sc--vuota" : "") + '">' +
             '<span class="cp3-sc-nome">' + (nome || "") + "</span>" +
             "<span>" +
               '<span class="cp3-sc' + (classe ? " " + classe : "") + '">' + blocchi + "</span>" +
               '<span class="cp3-sc-eti">' + sigle + "</span>" +
             "</span>" +
           "</span>";
  }

  /* ————— LA FRASE PER CHI ASCOLTA —————
     ATTENZIONE, QUI C'È LA TRAPPOLA PIÙ FACILE DI TUTTA LA PAGINA: l'ancora
     della scheda porta un aria-label, e un aria-label sull'ancora SOSTITUISCE
     tutto il suo contenuto interno. Qualunque role="img", titolo o testo
     nascosto messo dentro le scale darebbe un DOM apparentemente accessibile e
     un lettore di schermo che non le annuncia MAI. Per questo le scale sono
     marcate aria-hidden e i gradi stanno qui, dentro la stringa dell'ancora.
     Se un giorno l'aria-label venisse tolto, il contenuto interno tornerebbe a
     parlare da sé: ma direbbe "1,01 ct 6,4 mm € 4.250" e basta, perché i
     binari sono disegni e restano muti. */
  function vocePietra(x) {
    var p = [];
    p.push("Apri la scheda della pietra da " + ct(x.carati) + " carati, " +
           num(Math.round(x.prezzo)) + " euro.");

    var ic = SCALA_COLORE.indexOf(x.colore);
    if (ic >= 0) p.push("Colore " + x.colore + ", " + ORDINALI[ic] + " gradino su " +
                        QUANTI[SCALA_COLORE.length] + ", da D a I.");
    var ip = SCALA_PUREZZA.indexOf(x.purezza);
    if (ip >= 0) p.push("Purezza " + x.purezza + ", " + ORDINALI[ip] + " su " +
                        QUANTI[SCALA_PUREZZA.length] + ", da FL a SI2.");
    if (SCALA_FLUO.indexOf(x.fluorescenza) >= 0) {
      p.push("Fluorescenza " + x.fluorescenza.toLowerCase() + ".");
    }

    /* Il grado di taglio il GIA lo assegna solo ai rotondi: sulle altre sette
       forme il campo torna vuoto su 23.424 pietre, il 38,6% del magazzino.
       Non è un caso di bordo, è quasi due schede su cinque, e non si racconta
       come una mancanza della pietra ma come un fatto sul certificato.
       VIETATO dedurre il grado da tavola e profondità, che il feed espone:
       sarebbe inventare un grado GIA che il certificato non porta. */
    p.push(x.taglio
      ? "Taglio, lucidatura e simmetria Excellent."
      : "Lucidatura e simmetria Excellent; il grado di taglio il GIA lo assegna solo alle pietre rotonde.");
    return p.join(" ");
  }

  function cerca(azzera) {
    if (azzera) { S.salto = 0; S.pagina = 1; S.pietre = []; el("[data-cp3-lista]").innerHTML = ""; }
    /* le pietre che stanno per arrivare rispondono a QUESTI filtri: da qui in
       poi tornare ai risultati con la stessa firma non richiede una ricerca */
    firma = firmaFiltri();
    /* ogni ricerca nuova invalida le risposte ancora in viaggio della vecchia */
    giro++;
    var mio = giro;
    el("[data-cp3-vuoto]").hidden = true;
    /* il conteggio sopra la griglia non esiste piu' (tolto su richiesta): si
       scrive solo se qualcuno un giorno lo rimette */
    var cc = el("[data-cp3-conteggio]");
    if (cc) cc.textContent = "Cerco fra le pietre disponibili…";
    el("[data-cp3-pagine]").hidden = true;

    chiedi(query() + "&limite=" + PER_VOLTA + "&salto=" + S.salto)
      .then(function (d) {
        if (mio !== giro) return;
        S.totale = d.totale;
        /* il feed si rinfresca ogni ora: fra una pagina e l'altra una pietra
           può tornare due volte, e i doppioni si scartano per sigla */
        var viste = {};
        S.pietre.forEach(function (x) { viste[x.id] = true; });
        (d.pietre || []).forEach(function (x) { if (!viste[x.id]) { viste[x.id] = true; S.pietre.push(x); } });
        disegnaLista();
        if (S.totale === 0) proponiVuoto(mio);
      })
      .catch(function () { if (mio === giro) guasto(); });
  }

  /* ————— LE PAGINE —————
     Ogni pagina RIFA' l'elenco invece di aggiungersi in coda: e' la differenza
     fra pagine e pila. Svuoto sia le pietre in mano sia la griglia, cosi'
     disegnaLista — che disegna solo quelle che mancano — le disegna tutte. */
  function vaiAPagina(n) {
    var pagine = Math.max(1, Math.ceil(S.totale / PER_VOLTA));
    n = Math.min(Math.max(1, n), pagine);
    if (n === S.pagina) return;
    S.pagina = n;
    S.salto = (n - 1) * PER_VOLTA;
    S.pietre = [];
    el("[data-cp3-lista]").innerHTML = "";
    cerca(false);
    /* L'OCCHIO TORNA IN CIMA. Cambiare pagina restando a meta' elenco vuol
       dire trovarsi davanti pietre diverse senza aver visto le prime. Tolgo
       l'altezza dell'intestazione, che sta fissa e coprirebbe la prima riga. */
    var lista = el("[data-cp3-lista]");
    if (lista) {
      var testa = parseFloat(getComputedStyle(document.documentElement)
                    .getPropertyValue("--header-h")) || 72;
      var y = lista.getBoundingClientRect().top + window.pageYOffset - testa - 24;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }

  /* Prima, ultima, la corrente con le due vicine, e le ellissi in mezzo.
     Su 67 pagine sono sette bottoni invece di sessantasette. */
  function elencoPagine(qui, quante) {
    var v = [], i;
    if (quante <= 7) { for (i = 1; i <= quante; i++) v.push(i); return v; }
    v.push(1);
    var da = Math.max(2, qui - 1), a = Math.min(quante - 1, qui + 1);
    /* la finestra resta larga tre anche ai capi, se no la fila si accorcia
       sulla prima e sull'ultima pagina e i numeri ballano */
    if (qui <= 3)          { da = 2; a = 4; }
    if (qui >= quante - 2) { da = quante - 3; a = quante - 1; }
    if (da > 2) v.push("…");
    for (i = da; i <= a; i++) v.push(i);
    if (a < quante - 1) v.push("…");
    v.push(quante);
    return v;
  }

  function disegnaPagine() {
    var nav = el("[data-cp3-pagine]");
    if (!nav) return;
    var quante = Math.ceil(S.totale / PER_VOLTA);
    if (!S.totale || quante <= 1) { nav.hidden = true; nav.innerHTML = ""; return; }
    var qui = S.pagina;
    var h = '<button type="button" class="cp3-pag" data-cp3-pag="' + (qui - 1) + '"' +
            (qui <= 1 ? " disabled" : "") + ' aria-label="Pagina precedente">&lsaquo;</button>';
    elencoPagine(qui, quante).forEach(function (n) {
      if (n === "…") { h += '<span class="cp3-pag-salto" aria-hidden="true">&hellip;</span>'; return; }
      h += '<button type="button" class="cp3-pag' + (n === qui ? " is-qui" : "") + '"' +
           ' data-cp3-pag="' + n + '"' + (n === qui ? ' aria-current="page"' : "") +
           ' aria-label="Pagina ' + n + '">' + n + "</button>";
    });
    h += '<button type="button" class="cp3-pag" data-cp3-pag="' + (qui + 1) + '"' +
         (qui >= quante ? " disabled" : "") + ' aria-label="Pagina successiva">&rsaquo;</button>';
    var primo = (qui - 1) * PER_VOLTA + 1;
    var ultimo = Math.min(qui * PER_VOLTA, S.totale);
    h += '<p class="cp3-pag-conto">Pietre ' + primo + "–" + ultimo + " di " + S.totale + "</p>";
    nav.innerHTML = h;
    nav.hidden = false;
  }

  el("[data-cp3-pagine]").addEventListener("click", function (e) {
    var b = e.target.closest("[data-cp3-pag]");
    if (!b || b.disabled) return;
    vaiAPagina(+b.getAttribute("data-cp3-pag"));
  });

  function guasto() {
    var cg = el("[data-cp3-conteggio]");
    if (cg) cg.textContent = "";
    var g = el("[data-cp3-guasto]");
    g.hidden = false;
    g.innerHTML = "<p>In questo momento non riusciamo a interrogare l'archivio delle pietre. " +
      "Non è colpa di quello che hai scelto: riprova fra qualche minuto, oppure " +
      '<a href="' + fuggi(CONTATTI) + '">scrivici</a> e la ricerca la facciamo noi.</p>';
  }

  function disegnaLista() {
    var n = S.pietre.length;

    /* LA FASCIA DEI FILTRI RESTA SEMPRE (13 settembre 2026). Era legenda(n > 0):
       con zero pietre spariva, e con lei sparivano "Stai guardando", i due
       cursori (caratura e prezzo) e "Cambia le scelte" — cioe' tutto quello
       che serve per rifare la ricerca. Restava la sola frase "nessun
       risultato" in mezzo alla pagina bianca, e da li' l'unica uscita era
       tornare indietro col browser. E' la segnalazione.
       I limiti dei cursori non dipendono dalle pietre trovate: li chiede una
       interrogazione sua all'archivio, quindi funzionano anche a mani vuote. */
    legenda(true);

    var lista = el("[data-cp3-lista]");
    /* SI AGGIUNGE, NON SI RIFA'. Prima ogni "mostra altre pietre" svuotava la
       griglia e la ricostruiva da capo: le schede gia' in pagina perdevano il
       loro visore e lo riscaricavano tutte insieme — e' il ricaricamento che
       il cliente ha segnalato. Ora si disegnano solo le pietre nuove, e
       quelle di prima restano dove sono, accese. */
    var gia = lista.children.length;
    S.pietre.slice(gia).forEach(function (x) {
      /* LA SCHEDA NON È PIÙ UN'ANCORA MA UN CONTENITORE, e il motivo è uno
         solo: dentro un'ancora non ci si può mettere un pulsante, e da
         telefono il 360 ha bisogno di un pulsante vero che NON rubi il clic
         diretto alla scheda della pietra. Il collegamento resta un'ancora
         vera (tasto centrale, "apri in nuova scheda", tastiera): è il corpo
         di testo, e il suo bersaglio è tutta la scheda grazie allo ::after
         steso sopra. Il pulsante del 360 sta più in alto di quello ::after,
         quindi il suo tocco non arriva mai al collegamento. */
      var card = document.createElement("div");
      card.className = "cp3-card";
      /* la sigla sulla scheda: al clic serve a ritrovare l'oggetto già in mano
         e aprire il diamante senza un altro giro di rete */
      card.setAttribute("data-cp3-id", x.id);

      var v = x.giro && x.giroN ? "1" : "";
      if (v) {
        card.setAttribute("data-cp3-giro", x.giro);
        card.setAttribute("data-cp3-giron", x.giroN);
      }
      if (v) {
        /* l'indirizzo si tiene qui e l'iframe si costruisce dopo: finché la
           scheda non entra nello schermo non si scarica niente */
        card.setAttribute("data-cp3-src", v);
        card.setAttribute("data-cp3-360", "");
      }

      card.innerHTML =
        '<span class="cp3-card-foto">' +
          (v ? '<span class="cp3-card-culla" data-cp3-culla aria-hidden="true"></span>' : "") +
          /* NIENTE FOTOGRAFIE nel riquadro: ne' quella del fornitore (vietata
             dal cliente) ne' il nostro disegno del taglio, che faceva
             sembrare caricata una scheda ancora vuota. Al suo posto la C di
             Curnis che pulsa: dice "sto arrivando" invece di mostrare una
             pietra che non e' quella. Sparisce da sola quando il visore e'
             pronto. */
          '<span class="cp3-card-caric" aria-hidden="true">' +
            '<img src="' + fuggi(ASSETS + "curnis-c-oro.png") + '" alt="" loading="eager">' +
          "</span>" +
          /* IL PRIMO FOTOGRAMMA, che e' anche tutto quello che serve finche'
             nessuno ci passa sopra col mouse: venti chilobyte, non un'intera
             applicazione di terzi. */
          /* LA FOTOGRAFIA DEL FEED, non il primo fotogramma (20 settembre
             2026, segnalato: «le pietre sono molto spesso tipo girate,
             dovrebbero essere tutti frontali»). Il primo fotogramma di un giro
             e' la posa in cui il fornitore ha cominciato a girare la pietra:
             una qualunque, spesso storta. La colonna «image» del feed porta
             invece lo scatto frontale dall'alto su fondo bianco, e ce l'ha il
             77% del magazzino (185 diamanti su 240, contati).
             Dove non c'e', resta il primo fotogramma: meglio una pietra storta
             di un riquadro vuoto. */
          (x.immagine
            ? '<img class="cp3-card-360" data-cp3-360img alt="" loading="lazy" decoding="async" src="' +
                fuggi(x.immagine) + '">'
            : (v ? '<img class="cp3-card-360" data-cp3-360img alt="" loading="lazy" decoding="async" src="' +
                 fuggi(fotogramma(x, 0)) + '">' : "")) +
        "</span>" +
        '<a class="cp3-card-corpo" href="' + fuggi(versoScheda(x)) + '" aria-label="' + fuggi(vocePietra(x)) + '">' +
          /* l'ordine che ha chiesto il cliente: la caratura come primo valore,
             il prezzo centrale, poi il gruppo A (colore, purezza,
             fluorescenza) e infine il gruppo B (taglio, lucidatura,
             simmetria). Il cliente ha nominato "taglio" in tutti e due i
             gruppi: sta UNA VOLTA SOLA, nel gruppo B, insieme a lucidatura e
             simmetria — sono i tre gradi di finitura del GIA, si leggono sulla
             stessa scala Excellent..Poor e nel nostro magazzino valgono tutti
             e tre Excellent, quindi disegnarli due volte sarebbe ripetere zero
             informazione. */
          '<span class="cp3-card-ct">' + ct(x.carati) + " ct</span>" +
          /* I MILLIMETRI RESTANO, le segnalazioni no — e la scelta è motivata
             dall'altezza uguale, che è la richiesta numero uno.
             I mm sono un segno di larghezza fissa ("6,4 mm"), non vanno mai a
             capo, e sono l'unica cifra che traduce il carato in quello che si
             vedrà davvero al dito: il carato è un peso, non una misura.
             Le segnalazioni del fornitore (bruna, lattiginosa, verde) sono
             invece FRASI, e una frase o va a capo — e allora due schede
             affiancate hanno altezze diverse — o va troncata, e troncare un
             avviso è peggio che non darlo. Non solo: sono strettamente legate
             al prezzo, e l'ordinamento predefinito qui è "dalla più
             accessibile", quindi si ammucchiano in cima (misurato sulle 48
             pietre più economiche del feed: 29 ne hanno una). Una griglia
             dove più di metà delle schede porta una riga di cautela non è una
             griglia per confrontare, è un elenco di difetti. Restano dove
             servono e dove c'è spazio per dirle per intero: sulla scheda della
             singola pietra, a un clic da qui.
             Se i mm mancassero, al loro posto va uno spazio unificatore: la
             riga resta alta uguale e la scheda accanto non si accorcia. */
          /* I MILLIMETRI SONO STATI TOLTI su richiesta. Erano l'unica cifra che
             traduceva il carato in quello che si vede al dito, e restano
             sulla scheda della singola pietra: qui facevano una riga in piu'
             su ogni scheda per un dato che in dodici schede uguali non
             distingue niente. */
          /* aria-hidden: i gradi li dice la frase dell'ancora qui sopra (vedi
             vocePietra), qui dentro non verrebbero MAI annunciati */
          '<span class="cp3-scale" aria-hidden="true">' +
            /* sulle fancy il gradino acceso e' quello dell'intensita' */
            (fancyOra()
              ? binario(SCALA_INTENSITA, x.intensita, "", "Colore")
              : binario(SCALA_COLORE, x.colore, "", "Colore")) +
            binario(fancyOra() ? SCALA_PUREZZA_FANCY : SCALA_PUREZZA, x.purezza, "", "Purezza") +
            /* LA FLUORESCENZA SOLO SUI COLORATI. Sui bianchi in vetrina passa
               solo "Nessuna" (regola del 7 settembre 2026), quindi la barra
               farebbe lo stesso gradino su ogni scheda: non distingue niente e
               occupa una riga. Sui fancy quella regola non c'e' e la
               fluorescenza va ancora da nessuna a forte, dove cambia il
               prezzo: li' la barra serve e resta. */
            (fancyOra() ? binario(SCALA_FLUO, x.fluorescenza, "", "Fluoresc.") : "") +
          "</span>" +
          '<span class="cp3-fin" aria-hidden="true">' +
            /* un binario solo per tutti e tre i costanti, e la tacca sta sul
               primo gradino perché lucidatura e simmetria sono Excellent su
               60.729 righe su 60.729 — anche sulle forme senza grado di
               taglio. Nessun buco visibile sul 38,6% delle schede: cambia solo
               la frase per chi ascolta. */
            /* La riga "taglio, lucidatura e simmetria" e' stata tolta: valeva
               Excellent su tutte e 60.729 le pietre del magazzino, quindi
               disegnava tre tacche identiche su ogni scheda senza distinguere
               niente. Il dato resta nella scheda della pietra, dove serve. */
          "</span>" +
          /* IL PREZZO IN FONDO, sotto le scale: e' l'ultima cosa che si legge
             prima di decidere, e messo in cima rubava l'occhio alla caratura,
             che e' il dato con cui si confrontano due pietre. */
          '<span class="cp3-card-prezzo">' + euroPub(x.prezzo) + "</span>" +
        "</a>" +
        (v ? '<button type="button" class="cp3-card-tocco" data-cp3-tocco aria-pressed="false">' +
               '<span class="cp3-vis-nascosto">Fai girare la pietra</span>' +
               '<span aria-hidden="true">360°</span></button>'
           : "");

      lista.appendChild(card);
    });

    /* le schede sono nuove: l'osservatore va rifatto su queste, e gli iframe
       della lista di prima sono già spariti con l'innerHTML */
    /* niente piu' osservatore ne' iframe: il giro e' fatto di fotografie
       nostre, e basta agganciare il mouse alla lista una volta sola */
    /* NIENTE GIRO IN LISTA (20 settembre 2026, chiesto: «al posto del video
       nella lista mostriamo l'immagine»). agganciaGiro attaccava alla griglia
       il comando che faceva girare la pietra col movimento del mouse; non si
       chiama piu', e con lui non parte piu' lo scarico dei fotogrammi di ogni
       carta sfiorata. Resta segnaFotogrammi, che non muove niente: ritira la C
       che pulsa quando la fotografia e' arrivata e tinge il riquadro del
       fondo dello scatto. */
    preparaScheda(lista);
    segnaFotogrammi(lista);

    disegnaPagine();
  }

  /* ————— la legenda, scritta qui e non nel documento —————
     Sta in questa funzione apposta: è la stessa che disegna le tacche, quindi
     legenda e scale nascono e muoiono insieme. È l'unica cosa che impedisce
     alla scala di mentire.
     SULLA FLUORESCENZA SI PESANO LE PAROLE: che "nessuna" sia la migliore è un
     giudizio di MERCATO, non del GIA. Il certificato la riporta come
     caratteristica, non come grado, e il GIA stesso dice che nella maggior
     parte dei casi non ha effetto visibile. Qui si scrive quindi "quella che
     il mercato preferisce", mai "la migliore": è una frase da far confermare
     al cliente prima di considerarla definitiva. */
  /* L'INTESTAZIONE DEI RISULTATI — era due paragrafi di gemmologia, adesso e'
     una fascia. Il cliente li ha fatti togliere: chi arriva qui ha gia' scelto,
     e una lezione sulle scale del GIA in cima a un elenco allontana invece di
     aiutare. Le spiegazioni restano dove servono, sulla scheda della pietra.
     Al loro posto: le scelte fatte, a sinistra, e la fotografia del taglio
     scelto a destra — cosi' si riconosce a colpo d'occhio che cosa si sta
     guardando, con lo stesso disegno delle schede della qualita'. */
  /* ————— I DUE CURSORI —————

     Stanno sotto la fascia di riepilogo, e non e' un dettaglio: fin qui il
     cliente ha risposto a tre domande grosse (taglio, caratura, qualita') e
     si trova davanti un elenco. Le due cose che vorra' stringere sono sempre
     le stesse — quanto e' grande e quanto costa — e farlo tornare indietro a
     rifare il percorso per cambiare mezzo carato e' un giro inutile.

     GLI ESTREMI SI MISURANO SULL'INSIEME, non si inventano. Il cursore della
     caratura parte dai confini della fascia scelta; quello del prezzo da
     quanto costa davvero la piu' economica e la piu' cara di quel gruppo —
     due domande all'archivio, una in salita e una in discesa. Un cursore che
     va da zero a centomila quando le pietre stanno fra 2.000 e 9.000 non
     serve a niente: le prime due dita di corsa sarebbero vuote.

     DUE MANIGLIE SU UN BINARIO SOLO: due <input type=range> sovrapposti, con
     il tratto colorato in mezzo. Ognuno spinge l'altro invece di attraversarlo,
     se no si finisce con il minimo sopra il massimo e zero risultati. */
  var attesaCursori = null;
  function cursoriFuori() { S.ctDa = S.ctA = S.pzDa = S.pzA = null; barraCursori = null; }

  /* LA BARRA SI COSTRUISCE UNA VOLTA SOLA e poi si RIAPPENDE, non si rifa'.

     legenda() riscrive tutto il contenuto del suo contenitore a ogni disegno
     dell'elenco, e l'elenco si ridisegna a ogni tocco dei cursori: rifacendo
     la barra ogni volta, il pomello spariva da sotto il dito a meta'
     trascinamento e il pulsante "Azzera" tornava nascosto un attimo dopo
     essere comparso. Riappendere lo STESSO nodo conserva valori, fuoco e
     stato senza una riga di ripristino.

     La barra vale per una ricerca: cambiando taglio, colore, caratura o
     fascia gli estremi non sono piu' quelli, e allora se ne fa una nuova. */
  var barraCursori = null, firmaCursori = "";

  function costruisciCursori(box) {
    var suo = [S.ramo, S.forma, S.colore, S.caratura, S.fascia].join("|");
    if (barraCursori && firmaCursori === suo) { box.appendChild(barraCursori); return; }
    firmaCursori = suo;
    var ct = bCaratura();
    var ctMin = ct ? ct.min : 0.3, ctMax = ct ? ct.max : 10;
    if (!(ctMax > ctMin)) ctMax = ctMin + 1;

    var barra = document.createElement("div");
    barra.className = "cp3-cursori";
    barra.innerHTML =
      '<div class="cp3-cur">' +
        '<div class="cp3-cur-testa"><span>Caratura</span><span data-cp3-cur-eti-ct></span></div>' +
        '<div class="cp3-cur-pista" data-cp3-cur-pista-ct>' +
          '<span class="cp3-cur-binario"></span><span class="cp3-cur-tratto" data-cp3-cur-tratto-ct></span>' +
          '<input type="range" data-cp3-cur-ct-da aria-label="Caratura minima">' +
          '<input type="range" data-cp3-cur-ct-a aria-label="Caratura massima">' +
        '</div>' +
      '</div>' +
      '<div class="cp3-cur">' +
        '<div class="cp3-cur-testa"><span>Prezzo</span><span data-cp3-cur-eti-pz></span></div>' +
        '<div class="cp3-cur-pista" data-cp3-cur-pista-pz>' +
          '<span class="cp3-cur-binario"></span><span class="cp3-cur-tratto" data-cp3-cur-tratto-pz></span>' +
          '<input type="range" data-cp3-cur-pz-da aria-label="Prezzo minimo">' +
          '<input type="range" data-cp3-cur-pz-a aria-label="Prezzo massimo">' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cp3-cur-azzera" data-cp3-cur-azzera hidden>Azzera</button>';
    box.appendChild(barra);
    barraCursori = barra;

    var ctA1 = barra.querySelector("[data-cp3-cur-ct-da]");
    var ctA2 = barra.querySelector("[data-cp3-cur-ct-a]");
    var pzA1 = barra.querySelector("[data-cp3-cur-pz-da]");
    var pzA2 = barra.querySelector("[data-cp3-cur-pz-a]");
    var etiCt = barra.querySelector("[data-cp3-cur-eti-ct]");
    var etiPz = barra.querySelector("[data-cp3-cur-eti-pz]");
    var trCt = barra.querySelector("[data-cp3-cur-tratto-ct]");
    var trPz = barra.querySelector("[data-cp3-cur-tratto-pz]");
    /* il blocco intero del prezzo, e la memoria di averlo tolto: serve a
       "applica", che se no leggerebbe due campi non piu' in pagina */
    var curPz = barra.querySelectorAll(".cp3-cur")[1];
    var pzFuori = false;
    var azzera = barra.querySelector("[data-cp3-cur-azzera]");

    [ctA1, ctA2].forEach(function (i) {
      i.min = ctMin; i.max = ctMax; i.step = 0.01;
    });
    ctA1.value = S.ctDa != null ? S.ctDa : ctMin;
    ctA2.value = S.ctA != null ? S.ctA : ctMax;

    function tratto(el2, a, b, min, max) {
      var w = max - min || 1;
      el2.style.left = ((a - min) / w * 100) + "%";
      el2.style.right = ((max - b) / w * 100) + "%";
    }
    function scriviCt() {
      var a = Math.min(+ctA1.value, +ctA2.value), b = Math.max(+ctA1.value, +ctA2.value);
      etiCt.textContent = ctIt(a) + " – " + ctIt(b) + " ct";
      tratto(trCt, a, b, ctMin, ctMax);
    }
    function scriviPz() {
      if (!pzA1.max) { etiPz.textContent = "…"; return; }
      var a = Math.min(+pzA1.value, +pzA2.value), b = Math.max(+pzA1.value, +pzA2.value);
      /* IL CURSORE DEL BUDGET SCRIVE SEMcp3 UNA CIFRA, e la cifra e' quella
         piu' bassa.

         Prima, su una selezione tutta sopra la soglia dei cinquantamila, si
         spegneva e restava la parola "su richiesta": era il modo di non
         pubblicare prezzi alti, ma toglieva al visitatore l'unico modo di dire
         quanto vuole spendere. Adesso la maniglia sinistra mostra sempre il
         suo valore — la stessa cifra che le schede delle fasce chiamano
         "a partire da" — e la destra, finche' sta al massimo, non scrive un
         numero ma "in su".

         Appena la destra si muove, il suo numero si scrive: quel tetto lo ha
         scelto il visitatore, e' un numero suo e non il prezzo di una pietra.

         La soglia continua a valere sui CARTELLINI: nelle schede e sulla
         pagina del diamante una pietra sopra i cinquantamila dice sempre
         "Prezzo su richiesta". */
      /* IN CIMA DAVVERO, non "quasi". Era "b >= max - passo", una tolleranza
         per gli arrotondamenti: ma un passo e' mezzo punto percentuale della
         corsa, una posizione che si sceglie apposta, e li' si leggeva "in su"
         mentre il filtro un tetto ce l'aveva — la ricerca tornava vuota e
         l'etichetta diceva il contrario. */
      var alMassimo = b >= (+pzA1.max);
      etiPz.textContent = alMassimo
        ? "da " + euro(a) + " in su"
        : euro(a) + " – " + euro(b);
      tratto(trPz, a, b, +pzA1.min, +pzA1.max);
    }
    function ctIt(n) { return Number(n).toFixed(2).replace(".", ","); }

    function applica() {
      S.ctDa = Math.min(+ctA1.value, +ctA2.value);
      S.ctA  = Math.max(+ctA1.value, +ctA2.value);
      if (!pzFuori && pzA1.max) {
        S.pzDa = Math.min(+pzA1.value, +pzA2.value);
        S.pzA  = Math.max(+pzA1.value, +pzA2.value);
      }
      var tocco = (S.ctDa > ctMin + 0.001) || (S.ctA < ctMax - 0.001) ||
                  (!pzFuori && pzA1.max && (+pzA1.value > +pzA1.min || +pzA2.value < +pzA2.max));
      azzera.hidden = !tocco;
      if (attesaCursori) clearTimeout(attesaCursori);
      attesaCursori = setTimeout(function () { cerca(true); }, 320);
    }

    /* LE DUE MANIGLIE NON SI SOVRAPPONGONO. Portandole sullo stesso punto la
       fascia diventa larga zero — minimo 4.250 e massimo 4.250 — e la ricerca
       non puo' tornare con niente: non e' un guasto, e' una domanda senza
       risposta. Quella mossa spinge l'altra di un passo; se l'altra e' gia' al
       fondo della corsa, si ferma la mossa. La fascia minima resta sempre un
       passo: 0,01 ct sulla caratura, il passo del listino sul prezzo. */
    function distanzia(basso, alto, mossoIlBasso) {
      var passo = +basso.step || 1;
      /* corsa piu' corta di un passo: non c'e' niente da separare */
      if ((+alto.max - +basso.min) < passo) return;
      if (+basso.value > +alto.value - passo) {
        if (mossoIlBasso) {
          var v = +alto.value - passo;
          if (v < +basso.min) { v = +basso.min; alto.value = v + passo; }
          basso.value = v;
        } else {
          var w = +basso.value + passo;
          if (w > +alto.max) { w = +alto.max; basso.value = w - passo; }
          alto.value = w;
        }
      }
    }

    ctA1.addEventListener("input", function () { distanzia(ctA1, ctA2, true);  scriviCt(); applica(); });
    ctA2.addEventListener("input", function () { distanzia(ctA1, ctA2, false); scriviCt(); applica(); });
    pzA1.addEventListener("input", function () { distanzia(pzA1, pzA2, true);  scriviPz(); applica(); });
    pzA2.addEventListener("input", function () { distanzia(pzA1, pzA2, false); scriviPz(); applica(); });
    azzera.addEventListener("click", function () {
      ctA1.value = ctMin; ctA2.value = ctMax;
      if (!pzFuori && pzA1.max) { pzA1.value = pzA1.min; pzA2.value = pzA2.max; }
      cursoriFuori();
      scriviCt(); scriviPz();
      azzera.hidden = true;
      cerca(true);
    });

    scriviCt();
    /* gli estremi del prezzo: la piu' economica e la piu' cara dell'insieme
       INTERO, chieste senza i cursori addosso */
    var mio = giro;
    Promise.all([
      chiedi(query({ senzaCursori: true }) + "&limite=1"),
      chiedi(query({ senzaCursori: true, verso: "desc" }) + "&limite=1")
    ]).then(function (r) {
      if (mio !== giro || !barra.isConnected) return;
      var basso = r[0] && r[0].pietre && r[0].pietre[0];
      var alto = r[1] && r[1].pietre && r[1].pietre[0];
      if (!basso || !alto) { etiPz.textContent = "—"; return; }
      var lo = Math.floor(basso.prezzo), hi = Math.ceil(alto.prezzo);
      if (hi <= lo) hi = lo + 1;

      /* DOVE CI SONO PIETRE SU RICHIESTA, IL CURSORE DEL PREZZO NON SI
         DISEGNA.

         Nascondere la cifra sul cartellino non basta: trascinando la maniglia
         si vede l'elenco stringersi, e in dieci secondi si sa fra che cifre
         sta ogni pietra. Un filtro sul prezzo e' una pubblicazione del prezzo,
         solo piu' lenta.

         Basta UNA pietra sopra soglia perche' il blocco esca: si guarda il
         massimo dell'insieme, non il minimo. Resta il cursore della caratura,
         che di prezzi non sa niente. */
      if (sopraSoglia(hi)) {
        pzFuori = true;
        if (curPz) curPz.remove();
        return;
      }

      var passo = Math.max(1, Math.round((hi - lo) / 200));
      /* IL FONDO CORSA SULLA GRIGLIA. Il cursore incolla il valore a
         min + k·passo, e (alto-basso) non e' un multiplo del passo: il fondo
         restava irraggiungibile e la maniglia si fermava un gradino prima.
         Non era un dettaglio: al riposo il filtro spediva un tetto piu' basso
         del listino e faceva sparire le pietre piu' care da sole. */
      var cima = lo + passo * Math.ceil((hi - lo) / passo);
      [pzA1, pzA2].forEach(function (i) { i.min = lo; i.max = cima; i.step = passo; });
      pzA1.value = S.pzDa != null ? Math.max(lo, S.pzDa) : lo;
      pzA2.value = S.pzA != null ? Math.min(cima, S.pzA) : cima;
      scriviPz();
    }).catch(function () { etiPz.textContent = "—"; });
  }

  function legenda(mostra) {
    var box = el("[data-cp3-legenda]");
    box.hidden = !mostra;
    if (!mostra) { box.innerHTML = ""; return; }

    var f = trova(FORME, S.forma);
    var misura = bCaratura();
    var qa = bQualita();
    var voci = [];
    if (misura) voci.push({ t: "Misura", v: misura.nome });
    if (qa) voci.push({ t: "Qualita\u0300", v: qa.nome });
    if (qa) voci.push({ t: "Scala", v: qa.riga });

    box.innerHTML =
      '<div class="cp3-fascia-testa">' +
        '<div class="cp3-ft-testo">' +
          '<p class="cp3-ft-occhiello">Stai guardando</p>' +
          /* Sul ramo delle fancy la forma non si sceglie — si prendono tutti i
             tagli — e scrivere "Tutti i tagli" e basta non diceva di che
             pietre si stesse parlando. Il colore invece e' esattamente la
             scelta fatta, ed e' quello che va scritto qui. */
          /* LO STESSO NOME CHE SI LEGGE SOTTO LA GIOSTRA. Qui c'era scritto
             "Rotondo", e sopra "Stai guardando": messe insieme, le due righe
             dicevano "stai guardando rotondo". Il soggetto mancava, ed e' la
             stessa mancanza segnalata sulla giostra. Sul ramo delle fancy la
             forma non si sceglie — si prendono tutti i tagli — quindi li' il
             soggetto e' il colore, e quale sia il taglio lo dice la riga dei
             dati qui sotto. */
          '<p class="cp3-ft-nome">' + fuggi(
            fancyOra()
              ? "Diamanti Fancy " + ((trova(COLORI, S.colore) || {}).nome || "di colore")
              : (f ? "Diamante " + f.nome : "Tutti i tagli")) + "</p>" +
          '<dl class="cp3-ft-dati">' +
            voci.map(function (o) {
              return "<div><dt>" + fuggi(o.t) + "</dt><dd>" + fuggi(o.v) + "</dd></div>";
            }).join("") +
          "</dl>" +
          /* NON PIU' UN FILO. "Cambia le scelte" e' l'unica via d'uscita da
             questa schermata — e' come si torna indietro a cambiare taglio,
             caratura o qualita' — e scritto come un collegamentino sottolineato
             si perdeva sotto i dati. Adesso e' un pulsante col contorno, con la
             freccia all'indietro che dice dove porta. */
          '<button type="button" class="cp3-ft-cambia" data-cp3-ft-cambia>' +
            '<span aria-hidden="true">&larr;</span> Cambia le scelte</button>' +
        "</div>" +
        /* LA FOTOGRAFIA IN ALTO A DESTRA VALE ANCHE PER LE FANCY.

           Sulle bianche qui c'e' il taglio scelto, e serve a ricordare che
           cosa si sta guardando mentre si scorrono cento pietre. Sul ramo
           delle fancy il taglio non si sceglie — si prendono tutti — quindi
           la scelta fatta e' il colore, ed e' il colore che va mostrato: la
           stessa fotografia della giostra da cui si e' arrivati. Senza,
           l'intestazione delle fancy era l'unica del sito con l'angolo
           destro vuoto. */
        (function () {
          var foto = fancyOra()
            ? ((trova(COLORI, S.colore) || {}).gif || "")
            : (f ? (FOTO[f.id] || f.disegno) : "");
          if (!foto) return "";
          var che = fancyOra()
            ? "Diamanti fancy " + ((trova(COLORI, S.colore) || {}).nome || "di colore").toLowerCase()
            : (f ? "Un diamante taglio " + f.nome.toLowerCase() : "");
          return '<div class="cp3-ft-foto"><img src="' + fuggi(ASSETS + foto) +
                 '" alt="' + fuggi(che) + '" loading="eager"></div>';
        })() +
      "</div>";

    var b = box.querySelector("[data-cp3-ft-cambia]");
    if (b) b.addEventListener("click", function () { vai(2, true); });
    costruisciCursori(box);
  }


  /* L'INDIRIZZO DELLA SCHEDA, che è di questa stessa pagina.
     Fino al 15 agosto 2026 puntava alla vecchia pagina v1, cancellata su
     richiesta del cliente: la scheda è qui, al passo "pietra". I filtri restano
     nell'indirizzo anche se alla scheda non servono, e non è ridondanza: sono
     quello che permette a "Torna alle pietre" di riportare ai RISULTATI GIUSTI
     anche a chi la scheda l'ha ricevuta per messaggio e non l'ha cercata.
     Resta un'ancora vera: tasto centrale, "apri in una scheda nuova" e
     tastiera fanno il loro mestiere: il clic normale lo intercetta il
     JavaScript qui sotto e cambia schermata senza ricaricare la pagina. */
  function versoScheda(x) {
    var p = new URLSearchParams();
    p.set("passo", "pietra");
    if (S.forma)  p.set("forma", S.forma);
    if (S.caratura) p.set("caratura", S.caratura);
    if (S.fascia)   p.set("fascia", S.fascia);
    p.set("pietra", x.id);
    return location.pathname + "?" + p.toString();
  }

  /* Le tre funzioni che scrivevano la riga in italiano sotto la caratura
     (rigaCard, coloreParola, purezzaParola) sono state tolte: comprimevano sei
     gradini di colore in tre aggettivi e la purezza in una frase, cioè proprio
     quello che le scale adesso mostrano per intero e senza approssimare. */

  /* ══════════════════ IL 360 AL PASSAGGIO DEL MOUSE ══════════════════

     COS'È IL "VIDEO" CHE DÀ IL FEED. Non è un filmato scaricabile: è una
     PAGINA di loupe360.com (3,2 KB di HTML che accendono un'applicazione
     React). Non ha X-Frame-Options né frame-ancestors, quindi si può
     incorporare in un iframe: è l'unico modo che abbiamo oggi di far girare
     la pietra.

     DUE CORREZIONI ALL'INDIRIZZO, in url360 qui sotto: il visore va reso
     responsive e va acceso. Senza la seconda la pietra sta ferma, e il
     cliente ha chiesto esattamente il contrario.

     PERCHÉ NON BASTA CARICARE L'IFRAME QUANDO IL MOUSE ARRIVA. Un iframe
     aperto in quel momento vuole qualche secondo prima di mostrare una pietra
     che gira, e "istantaneo" non è. Quindi si fa il contrario: l'iframe si
     PREPARA PRIMA, in silenzio, nascosto DIETRO la fotografia (non
     display:none, che non caricherebbe nulla: sta lì sotto, acceso e già in
     rotazione). Al passaggio del mouse non si carica niente — si toglie di
     mezzo la fotografia, e sotto c'è la pietra già in movimento. Uscendo col
     mouse la fotografia torna.

     QUANTE SE NE PREPARANO: QUATTRO, ED È UNA MISURA, NON UN NUMERO A CASO.
     Ogni iframe è un'applicazione React che scarica un pacchetto JavaScript
     da 4,8 MB (misurato: loupe360.com/assets/index-*.js, 4.861.101 byte) e
     poi interroga il proprio archivio e le proprie immagini. Le dodici schede
     di una pagina di risultati fanno dodici applicazioni insieme: il
     pacchetto dopo il primo arriva dalla cache, ma restano dodici avvii,
     dodici interrogazioni e dodici volte la memoria. Quattro è il compromesso:
     copre le schede su cui il mouse sta per arrivare senza affossare il
     caricamento. Le altre si preparano a turno, mano a mano che si scorre.

     E SOLO QUANDO LA SCHEDA È SULLO SCHERMO: un IntersectionObserver con 150
     px di anticipo mette in coda le schede che entrano e SMONTA l'iframe di
     quelle che escono, liberando il posto. Su una ricerca da centinaia di
     pietre non si accumula niente.

     DA TELEFONO NON SI PREPARA NIENTE. Lì il passaggio del mouse non esiste,
     il 360 si apre col pulsante, e scaricare quattro applicazioni React su
     una connessione dati per un gesto che forse non arriva sarebbe maleducato.

     SE LA PIETRA NON HA IL VIDEO (haVideo falso) la scheda non cambia
     comportamento e non promette niente: nessuna culla, nessun pulsante,
     nessun osservatore. La fotografia resta e basta.

     IL GIORNO IN CUI IL FEED AVRÀ videosImageUri E videosFrame — il cliente
     le ha già attivate, manca solo che il file venga rigenerato — questo
     blocco va buttato e rifatto con la sequenza di fotogrammi: qualche decina
     di JPEG nostri, precaricabili tutti e dodici, che girano al primo
     movimento del mouse senza dipendere da un sito esterno, senza un iframe e
     senza 4,8 MB di JavaScript altrui. È l'unico modo per avere il movimento
     davvero istantaneo. Fino ad allora, questo. */

  /* L'indirizzo del visore, riscritto. Il feed dà la pagina com'è nel CSV:
     https://loupe360.com/diamond/<certificato>/video/500/500 — uniforme sul
     100% delle pietre, verificato. Due cose non vanno bene così:
     1) 500/500 sono PIXEL FISSI, e il visore se li mette addosso come
        larghezza e altezza: dentro una scheda larga 270 px si vedrebbe solo
        l'angolo in alto a sinistra. Il percorso ".../video/rsp/<autoplay>" è
        quello responsive: senza numeri il visore si prende il 100% di quello
        che gli si dà.
     2) l'ultimo segmento del percorso è l'interruttore del movimento: nel
        codice del visore vale vero solo se è "true" o "autoplay", e quel
        valore è esattamente ciò che il visore stesso chiama "is_hovering".
        L'indirizzo del feed non ce l'ha, quindi la pietra parte FERMA. Con
        "/autoplay" gira da sola: è la ragione per cui la fotografia può
        limitarsi a scomparire, senza che noi si debba simulare un passaggio
        del mouse dentro un documento di un altro dominio (cosa che, essendo
        di un'altra origine, non potremmo comunque fare).
     Se un giorno il feed cambiasse forma all'indirizzo, la riscrittura non
     scatta e si usa quello che arriva: al massimo un'inquadratura peggiore,
     mai una pagina rotta. */
  /* L'INDIRIZZO DEL VISORE — misurato a mano su loupe360, perche' le tre
     forme si somigliano e due su tre sono sbagliate:

       .../video/rsp/autoplay   il visore GIRA DA SOLO in loop
       .../video/rsp            NON e' una pagina valida: esce la maschera di
                                accesso di Nivoda al posto della pietra
       .../video/500/500        il visore mostra un FOTOGRAMMA FERMO e la
                                pietra la gira chi guarda

     Il cliente ha chiesto che non giri da sola e che si fermi sul primo
     fotogramma: quindi si usa la terza, che per fortuna e' gia' quella che
     manda il feed. L'unica cosa da togliere e' la stringa di richiesta, dove
     viaggia f_id — cioe' la chiave del CSV con dentro costi e fornitori — e
     ci pensa gia' pulisci() nel feed.

     "Il mouse controlla la rotazione solo passandoci sopra, senza premere"
     non si puo' fare da qui: l'iframe e' di un altro dominio e i movimenti
     del puntatore non ci arrivano. Per averlo servono le colonne
     videosImageUri / videosFrame, che al 15 agosto NON sono ancora nel feed
     (37 colonne, ricontrollate). Quando arriveranno il visore lo facciamo
     noi, un fotogramma per grado, e allora si potra'. */
  /* ══════════════════ IL GIRO A 360°, FATTO IN CASA ══════════════════

     Fino a stamattina il giro era il visore di loupe360 dentro un iframe, e
     si portava dietro quattro guai che non si potevano risolvere da fuori:
     partiva da solo ma si fermava al passaggio del mouse e non ripartiva;
     disegnava a 500x500 fissi e andava rimpicciolito; non si potevano leggere
     i suoi pixel per tingere lo sfondo; e ogni scheda della griglia era
     un'applicazione React intera che si ricaricava a ogni scorrimento.

     Il feed nuovo porta videosImageUri e videosFrame, e da li' si ricavano i
     fotogrammi veri: 256 immagini webp da una ventina di chilobyte, con
     Access-Control-Allow-Origin: *. Quindi il visore lo facciamo noi, con dei
     semplici <img>. Ne viene che:
       · nella lista si carica UN fotogramma invece di un'applicazione — venti
         chilobyte contro qualche centinaio, e niente piu' ricaricamenti;
       · il mouse fa girare la pietra passandoci sopra, senza premere, che e'
         esattamente quello che il cliente chiedeva e che dall'esterno di un
         iframe non era possibile;
       · sulla pagina della pietra il giro parte da solo, si lascia guidare col
         mouse e riparte da solo quando il mouse se ne va;
       · lo sfondo si campiona dal PRIMO FOTOGRAMMA VERO, non piu' da un'altra
         immagine.

     NON si scaricano tutti e 256 i fotogrammi: sarebbero cinque megabyte. Se
     ne prende uno ogni PASSO (il giro resta fluido a occhio) e si caricano a
     mano a mano. */
  /* TRENTADUE POSE, undici gradi l'una: e' il minimo che a occhio sembra un
     giro continuo. Il PASSO pero' non puo' essere fisso: i fornitori girano
     le pietre con 16, 63, 64, 128, 256 o 400 fotogrammi, e un passo di otto
     su una pietra da sedici darebbe due pose sole. Si calcola sul numero
     vero, e sulle pietre girate poco si prendono tutti i fotogrammi che ci
     sono. */
  /* ═══════════ QUANTE POSE, E OGNI QUANTO ═══════════

     Tutto quello che segue viene da una misura, non da un'impressione.

     IL DIFETTO SEGNALATO ERA DOPPIO. Primo, usavamo 32 fotogrammi su 256:
     11,25 gradi per posa, mentre chi fotografa diamanti a 360 gira fra i 72 e
     i 140 scatti (da 5 a 2,6 gradi). Secondo — e qui il cliente ha
     ragione due volte — il passo di 80 millisecondi non veniva nemmeno
     rispettato: misurato su 125 colpi, un setInterval(80) batte in media ogni
     84,95 ms e in dieci secondi accumula 626 ms di ritardo.

     IL BATTIMENTO CON LO SCHERMO e' la causa principale, ed e' aritmetica: uno
     schermo a 60 Hz disegna ogni 16,667 ms, e 80 / 16,667 = 4,8. Non essendo
     un numero intero, tre pose ogni venti durano un quarto di meno delle
     altre. E' una scossa periodica, e a 80 ms non si puo' togliere. 50 ms
     invece sono esattamente 3 disegni a 60 Hz e 6 a 120: tutte le pose durano
     uguale.

     LA REGOLA UNICA: 112,5 gradi al secondo, cioe' un giro in 3,2 secondi
     dovunque. Il tempo di una posa e' "gradi della posa diviso 112,5", e viene
     sempre un multiplo di 50 ms.

       scheda della pietra   64 pose    5,625 gradi     50 ms   20 al secondo
       lista                 32 pose   11,25  gradi    100 ms   10 al secondo

     PERCHE' 64. Divide esattamente 256, che e' l'87,2% del magazzino: nessun
     arrotondamento, nessun salto piu' corto alla chiusura del giro. Il 96,25%
     delle pietre ha almeno 64 fotogrammi. Costa 1,01 MB mediani contro 0,51,
     e 567 ms invece di 396 per averli tutti (misurato, 16 richieste in
     parallelo) — lontanissimo dai 4,05 MB del giro intero. */
  /* ═══ IL MASSIMO, e perche' e' questo ═══

     128 pose sulla scheda della pietra: 2,81 gradi l'una. E' il limite alto
     della forbice che usa chi fotografa diamanti a 360 (72-140 scatti per
     giro), e sopra non si guadagna niente che l'occhio possa vedere — si
     paga solo banda: 128 pose costano 2,02 MB mediani, tutti e 256 i
     fotogrammi ne costerebbero 4,05 per un miglioramento che nessuno
     distingue.

     33,333 millisecondi per posa, cioe' 30 immagini al secondo. Non e' un
     numero scelto a occhio: sono ESATTAMENTE due disegni di schermo a 60 Hz
     (e quattro a 120), quindi tutte le pose durano lo stesso tempo. Con un
     passo che non e' multiplo intero del disegno, alcune pose durerebbero un
     terzo in meno delle altre e si vedrebbe come una scossa periodica — e'
     il difetto che avevamo a 80 ms.

     Il gradino successivo sarebbe 60 immagini al secondo (16,667 ms), ma li'
     il collo di bottiglia non e' piu' la banda: e' la decodifica di un webp
     ogni sedici millesimi di secondo, che su un portatile normale non sta
     dietro e produce salti veri — cioe' andrebbe PEGGIO. */
  /* IL GIRO ALLA MASSIMA FLUIDITA' CHE UNO SCHERMO PUO' MOSTRARE.

     Il cliente ha confrontato la nostra scheda col visore di Nivoda e ha visto
     la nostra "piu' a scatti". Aveva ragione, e il motivo non era il numero di
     fotogrammi disponibili ma il RITMO con cui li mostravamo.

     Com'era: 128 pose ogni 33,333 ms. Trentatre millesimi sono due disegni di
     schermo a 60 Hz, cioe' TRENTA fotogrammi al secondo — e trenta al secondo
     su un oggetto che ruota si vedono, uno per uno. La pietra segnalata
     (certificato 2175513456) di fotogrammi ne ha 256: ne stavamo buttando via
     la meta', e quella che restava la mostravamo a passo doppio.

     Com'e' adesso: 256 pose ogni 16,667 ms. Un fotogramma per ogni disegno di
     schermo, SESSANTA al secondo. Il giro completo dura esattamente quanto
     prima — 256 x 16,667 fa gli stessi 4,27 secondi di 128 x 33,333 — quindi
     la pietra non ha cambiato velocita': ha raddoppiato la definizione del
     movimento.

     PERCHE' MI FERMO A 256 e non prendo tutto. Alcune pietre ne hanno 512, una
     ne ha 751. Ma sopra i sessanta al secondo lo schermo non disegna, e a
     parita' di durata del giro 512 fotogrammi in 4,27 secondi vorrebbero dire
     mostrarne 120 al secondo: la meta' non arriverebbe mai all'occhio. Le
     alternative sarebbero due, e sono tutt'e due peggiori: usarli tutti a 60
     al secondo (il giro diventa 8,5 secondi, la pietra rallenta) oppure
     saltarne uno su due mentre giriamo (che e' quello che facevamo prima).
     256 a 60 Hz e' il tetto vero, non un compromesso.

     Sulle pietre che ne hanno meno si usano tutte quelle che ci sono:
     indiciPose prende min(quante, n).

     COSTO: i fotogrammi da scaricare raddoppiano, circa 3,8 MB per pietra a
     15 KB l'uno. Restano in cache sei mesi e la C continua a girare finche'
     non sono arrivati tutti, quindi non si vedono strappi — si aspetta un po'
     di piu' la prima volta. */
  var POSE_SCHEDA = 256;
  var POSE_LISTA  = 32;
  var POSE_PRIME  = 16;        /* quante se ne prendono al primo colpo in lista */
  var MS_SCHEDA = 1000 / 60;   /* 16,667: un fotogramma per ogni disegno di schermo */
  var MS_LISTA  = 100;         /* sei disegni: le carte girano piu' piano */

  /* GLI INDICI DELLE POSE, distribuiti su tutto il giro.

     Non "un fotogramma ogni passo" ma round(j * n / K): con il passo fisso, le
     pietre il cui numero di fotogrammi non e' divisibile — 1.623 su 70.189,
     il 2,31% — avevano l'ultimo salto piu' corto degli altri, cioe' una
     scossa a ogni giro. E le 1.968 pietre da soli 16 fotogrammi finivano con
     16 pose senza che nessuno se ne accorgesse. Cosi' invece le pose sono
     sempre esattamente K (o tutte quelle che ci sono, se sono meno) e sempre
     equidistanti. */
  function indiciPose(n, quante) {
    if (!n) return [];
    var K = Math.min(quante, n), out = [];
    for (var j = 0; j < K; j++) out.push(Math.round(j * n / K) % n);
    return out;
  }

  function fotogramma(x, n) {
    if (!x || !x.giro || !x.giroN) return "";
    var i = ((n % x.giroN) + x.giroN) % x.giroN;
    return x.giro + i + ".webp";
  }

  function pose(x) {
    if (!x || !x.giro || !x.giroN) return [];
    return indiciPose(x.giroN, POSE_SCHEDA);
  }

  /* ═══════════ UN MOTORE SOLO PER TUTTA LA PAGINA ═══════════

     Prima ogni cosa che girava aveva il suo setInterval: la scheda della
     pietra uno, ogni carta toccata da telefono un altro. Dodici timer
     indipendenti sono dodici sorgenti di battimento.

     Adesso c'e' un requestAnimationFrame solo, e soprattutto NON si avanza di
     una posa a ogni colpo: si calcola dove la pietra DEVE essere a
     quell'istante, partendo da un tempo di riferimento. Cosi' l'errore non si
     accumula mai, se un disegno di schermo salta la posa dopo e' comunque
     quella giusta, e a scheda nascosta il browser non ci chiama affatto —
     mentre un setInterval, in secondo piano, Chrome lo strozza a un colpo al
     secondo e la pietra "striscia". */
  var GIRANTI = [];            /* { img, pose, x, t0, fermo, ms } */
  var motoreVivo = false;

  function motore(adesso) {
    var vivi = 0;
    for (var i = 0; i < GIRANTI.length; i++) {
      var g = GIRANTI[i];
      if (!g.img || !g.img.isConnected) { GIRANTI.splice(i--, 1); continue; }
      /* si contano solo quelle che girano DAVVERO: una pietra ferma sotto il
         mouse teneva sveglio il motore all'infinito. Chi riprende chiama
         riprendiGiro, che riaccende. */
      if (g.fermo) continue;
      vivi++;
      var k = Math.round((adesso - g.t0) / g.ms) % g.pose.length;
      if (k < 0) k += g.pose.length;
      if (k === g.k) continue;
      var n = g.pose[k];
      /* SI MOSTRA SOLO QUELLO CHE E' GIA' IN MEMORIA.

         Prima la guardia scattava soltanto se il fotogramma era in magazzino
         ma non ancora arrivato. Per quelli che in magazzino non c'erano
         ancora — e all'inizio sono la stragrande maggioranza, perche' il
         magazzino si riempie a sedici per volta — passava dritta e assegnava
         all'immagine un indirizzo da scaricare: l'immagine si svuotava e si
         vedeva il buco. Era il "salta tanti frame".

         Adesso, se c'e' un magazzino, il fotogramma o e' arrivato o non si
         mostra: si tiene quello di prima e si riprova al giro dopo. La pietra
         rallenta, non lampeggia. */
      var pronta = g.avute ? g.avute[n] : null;
      if (g.avute && !(pronta && pronta.complete && pronta.naturalWidth)) continue;
      g.k = k;
      g.img.src = pronta ? pronta.src : fotogramma(g.x, n);
    }
    if (vivi) requestAnimationFrame(motore);
    else motoreVivo = false;
  }

  function accendiMotore() {
    if (motoreVivo) return;
    motoreVivo = true;
    requestAnimationFrame(motore);
  }

  /* ═══════════ I FOTOGRAMMI SI PRENDONO PRIMA DEL CLIC ═══════════

     Il caricamento partiva quando la scheda della pietra si apriva: due
     megabyte da aspettare con la C che pulsa, ogni volta. Ma noi sappiamo
     quale pietra sta per essere aperta un istante PRIMA — quando il mouse si
     ferma sulla carta della lista — e in quell'istante la rete e' libera.

     Quindi: al passaggio del mouse su una carta si comincia a scaricare le
     128 pose della SCHEDA di quella pietra. Chi poi clicca trova il lavoro
     gia' fatto o quasi; chi non clicca ha speso qualche centinaio di
     chilobyte su una rete che stava ferma.

     Il magazzino e' condiviso e tenuto per sigla, cosi' tornare indietro e
     riaprire la stessa pietra non riscarica niente. Si tengono le ultime
     QUANTE_CALDE: senza tetto, passando il mouse su venti carte si
     terrebbero in memoria quaranta megabyte di immagini. */
  /* QUANTE PIETRE SI TENGONO IN MEMORIA, e perche' due e non sei.

     Un fotogramma pesa 36 KB e ce ne sono 256 per pietra: 9,2 MB di dati
     compressi, e fino a 256 MB di bitmap una volta decodificati (500x500
     pixel per quattro canali fanno un megabyte l'uno). Con sei pietre in
     magazzino si chiedeva al browser di tenere in piedi cinquantacinque
     megabyte di immagini fuori dal documento: Chrome butta le decodifiche e
     le rifa' quando servono, e una decodifica rifatta mentre la pietra gira
     si vede — la rotazione si ferma un istante e riparte. E' il "sembra
     ricaricarsi" della segnalazione.

     Due e' il minimo che serve davvero: la pietra aperta e quella che si sta
     scaldando col mouse sulla carta accanto. Chi apre, torna indietro e apre
     la vicina non riscarica niente; chi ne apre sei di fila riscarica la
     prima, ma quella l'ha guardata due minuti fa. */
  var CALDE = {}, ORDINE_CALDE = [], QUANTE_CALDE = 2;
  var SCALDANDO = 0, MAX_INSIEME = 16;   /* misurato: oltre le sedici richieste
                                            insieme non si guadagna piu' niente */

  /* SFRATTARE VUOL DIRE LASCIARE ANDARE, non solo dimenticare il nome.
     Cancellando la voce dalla mappa gli oggetti Image restavano vivi finche'
     qualcuno li teneva per mano — e qualcuno li teneva: la POSA della pietra
     aperta punta a quella stessa mappa di immagini. Svuotando src, invece,
     un'immagine fuori dal documento non ha piu' niente da tenere e il browser
     la libera subito. */
  function sfratta(id) {
    var c = CALDE[id];
    if (c && c.tenute) {
      for (var k in c.tenute) {
        if (Object.prototype.hasOwnProperty.call(c.tenute, k)) {
          try { c.tenute[k].src = ""; } catch (e) {}
        }
      }
      c.tenute = {};
      c.pronte = 0;
    }
    delete CALDE[id];
  }

  function scaldaScheda(x) {
    if (!x || !x.id || !x.giro || !x.giroN) return null;
    if (CALDE[x.id]) return CALDE[x.id];
    var elenco = pose(x);
    var c = CALDE[x.id] = { tenute: {}, pronte: 0, quante: elenco.length, elenco: elenco };
    ORDINE_CALDE.push(x.id);
    while (ORDINE_CALDE.length > QUANTE_CALDE) {
      var vecchia = ORDINE_CALDE.shift();
      /* mai la pietra che si sta guardando: e' quella che gira */
      if (inEsame && vecchia === inEsame.id) { ORDINE_CALDE.push(vecchia); break; }
      sfratta(vecchia);
    }

    var i = 0;
    function prossima() {
      if (i >= elenco.length) return;
      var n = elenco[i++];
      SCALDANDO++;
      var im = new Image();
      im.crossOrigin = "anonymous";     /* serve a campionare il fondo */
      /* PRONTA VUOL DIRE DECODIFICATA, non scaricata. onload dice solo che i
         byte sono arrivati: la decodifica viene dopo e su un webp grande costa
         parecchio. Contando gli onload il magazzino diceva "100%" mentre il
         motore doveva ancora aprire i fotogrammi uno per uno, e i primi giri
         si vedevano formarsi. decode() promette esattamente quello che serve:
         pronto da disegnare. Dove non c'e' (browser vecchi) si torna al
         comportamento di prima, che e' comunque meglio di niente. */
      var contata = false;
      function conta() { if (contata) return; contata = true; c.pronte++; }
      im.onload = function () {
        /* la coda va avanti SUBITO: se aspettasse la decodifica, un decode che
           non torna fermerebbe anche gli scaricamenti */
        SCALDANDO--; prossima();
        if (im.decode) {
          im.decode().then(conta, conta);
          /* la rete: dopo 400 ms si conta comunque. Su una pagina che non
             dipinge decode() non torna mai, e senza questo la percentuale
             resterebbe a zero. */
          setTimeout(conta, 400);
        } else { conta(); }
      };
      /* UN FOTOGRAMMA CHE NON ARRIVA NON E' UN FOTOGRAMMA PRONTO. Prima
         onerror contava come onload: con dei buchi si arrivava lo stesso al
         100%. Adesso si contano a parte — la pietra parte ugualmente, ma il
         numero non mente. */
      im.onerror = function () { c.rotte = (c.rotte || 0) + 1; SCALDANDO--; prossima(); conta(); };
      im.src = fotogramma(x, n);
      c.tenute[n] = im;
    }
    /* si parte con sedici in volo, e ognuna che arriva tira la successiva */
    for (var q = 0; q < MAX_INSIEME && q < elenco.length; q++) prossima();
    return c;
  }

  /* mette in moto una pietra; la si ferma e riprende senza mai ricaricare */
  function faiGirare(img, elenco, x, ms, avute) {
    for (var i = 0; i < GIRANTI.length; i++) if (GIRANTI[i].img === img) GIRANTI.splice(i--, 1);
    var g = { img: img, pose: elenco, x: x, ms: ms, avute: avute || null,
              t0: (window.performance ? performance.now() : 0), k: -1, fermo: false };
    GIRANTI.push(g);
    accendiMotore();
    return g;
  }
  /* riprendendo, il tempo di riferimento si riscrive dalla posa in cui siamo:
     la pietra riparte da dove era, non da capo e senza recuperi a raffica */
  function riprendiGiro(g) {
    if (!g) return;
    g.t0 = (window.performance ? performance.now() : 0) - g.k * g.ms;
    g.fermo = false;
    accendiMotore();
  }

  function url360(x, autoplay) {
    if (!x.haVideo || !x.video) return "";
    var base = String(x.video).split("?")[0];
    /* NELLA SCHEDA DELLA PIETRA GIRA DA SOLA, in elenco no. Sono due richieste
       diverse dello stesso cliente e sono tutt'e due ragionevoli: in una
       griglia di dodici pietre che girano tutte insieme non si guarda niente,
       mentre sulla pagina di UNA pietra il giro e' il contenuto.
       L'ultimo segmento e' quello che comanda: .../video/rsp/autoplay parte da
       sola, .../video/500/500 si ferma sul primo fotogramma. Attenzione a non
       scrivere .../video/rsp da solo: quella non e' una pagina valida e al
       posto della pietra esce la maschera di accesso di Nivoda. */
    if (!autoplay) return base;
    var m = base.match(/^(https:\/\/loupe360\.com\/[^\/]+\/[^\/]+)\/video(?:\/.*)?$/);
    return m ? m[1] + "/video/rsp/autoplay" : base;
  }


  /* Quante pagine esterne teniamo accese insieme. Era 4, e voleva dire che su
     dodici schede otto restavano vuote finche' non ci passavi sopra: il
     cliente vuole vedere subito il primo fotogramma di tutte. Dodici e' il
     numero di schede che carichiamo per volta, quindi accese sono tutte
     quelle che ha davanti. */
  /* Il tetto non e' piu' una misura di risparmio ma una rete di sicurezza:
     con "vedi le altre" le schede diventano ventiquattro, trentasei, e a
     dodici il tetto ricominciava a spegnere e riaccendere. Sessanta e' oltre
     qualunque lista vera. */
  /* ══════════════════ IL GIRO NELLE SCHEDE ══════════════════
     Niente piu' iframe, niente coda, niente tetto, niente accendi/spegni: la
     scheda ha un <img> e basta. Passandoci sopra col mouse, la posizione
     orizzontale del puntatore sceglie la posa — da sinistra a destra, un giro
     intero — e le immagini si scaricano solo quando servono, restando poi
     nella memoria del browser (sono in cache per sei mesi).

     E' la cosa che il cliente chiedeva da stamattina e che con l'iframe non
     si poteva fare: "il mouse controlla in automatico la rotazione, senza
     bisogno di premere". */

  function poseDi(card) {
    var giro = card.getAttribute("data-cp3-giro");
    var n = parseInt(card.getAttribute("data-cp3-giron"), 10) || 0;
    if (!giro || !n) return null;
    return { giro: giro, n: n, pose: indiciPose(n, POSE_LISTA) };
  }

  function mostraPosa(card, frazione) {
    var g = poseDi(card);
    var im = card.querySelector("[data-cp3-360img]");
    if (!g || !im) return;
    var quante = g.pose.length;
    var i = Math.floor(frazione * quante) % quante;
    if (i < 0) i += quante;
    var n = g.pose[i];
    /* se questa carta sta girando da sola (pulsante 360 da telefono), il
       mouse non ci mette becco: sarebbero due padroni sullo stesso
       fotogramma, e la guardia qui sotto non basterebbe perche' il motore
       non scrive data-posa */
    if (card._giroVivo) return;
    if (im.getAttribute("data-posa") === String(n)) return;
    /* NIENTE LAMPI BIANCHI. Prima si cambiava indirizzo e basta: se quel
       fotogramma non era ancora arrivato, il browser svuotava l'immagine e
       per un istante la scheda diventava bianca — ed e' proprio il "salto"
       segnalato. Adesso si cambia SOLO se il fotogramma e' gia' in memoria;
       se non lo e' si resta su quello di adesso, e la pietra al massimo gira
       un po' a scatti per il primo mezzo secondo invece di lampeggiare. */
    var pronta = card._pose && card._pose[n];
    if (!pronta || !pronta.complete || !pronta.naturalWidth) return;
    im.setAttribute("data-posa", String(n));
    im.src = pronta.src;
  }

  /* SI SCARICA TUTTO SUBITO, ma UNA SCHEDA PER VOLTA.

     Prima le pose si prendevano solo quando il mouse entrava: risparmiava
     traffico, ma il mouse arrivava sempre prima delle immagini e la pietra
     girava a vuoto — la segnalazione del cliente. Adesso appena il primo
     fotogramma di una scheda e' in pagina, quella scheda si mette in coda e
     si prende le sue sedici pose.

     La coda serve: dodici schede per sedici pose sono quasi duecento
     richieste, e sparate insieme mettono in ginocchio anche la rete di casa.
     Una scheda alla volta, in ordine di comparsa; se il mouse arriva su una
     scheda che non e' ancora il suo turno, quella passa davanti a tutte. */
  var CODA_GIRI = [], codaAlLavoro = false, codaSospesa = false;

  function scaldaGiro(card, subito) {
    if (subito && !card._completa) {
      /* il mouse si e' fermato qui: questa carta merita tutte le pose */
      card._completa = 1;
      if (!card._inCoda) { card._inCoda = 1; CODA_GIRI.unshift(card); tiraCoda(); return; }
    }
    if (card._pose && card._completa && card.getAttribute("data-cp3-giropronto") === "2") return;
    if (card._pose && !subito) return;
    if (card._inCoda) {
      if (subito) {                              /* il mouse comanda: passa davanti */
        var q = CODA_GIRI.indexOf(card);
        if (q > 0) { CODA_GIRI.splice(q, 1); CODA_GIRI.unshift(card); }
      }
      return;
    }
    if (!poseDi(card)) return;
    card._inCoda = 1;
    if (subito) CODA_GIRI.unshift(card); else CODA_GIRI.push(card);
    tiraCoda();
  }

  function tiraCoda() {
    /* Mentre si guarda una pietra, la banda serve tutta a lei: la coda delle
       carte si SOSPENDE. Non si svuota — disegnaLista() non ricrea le carte
       gia' in pagina, quindi cancellarle dalla coda vorrebbe dire lasciarle
       senza pose per sempre. */
    if (codaSospesa || codaAlLavoro) return;
    var card = CODA_GIRI.shift();
    if (!card) return;
    card._inCoda = 0;
    var g = poseDi(card);
    if (!g || !card.isConnected) return tiraCoda();
    codaAlLavoro = true;
    card._pose = card._pose || {};
    /* DUE TEMPI. Prima le 16 pose che bastano a far girare la carta — sono un
       sottoinsieme esatto delle 32, quindi non si scarica niente due volte —
       e solo se il mouse si ferma davvero si completa a 32. Chi scorre e basta
       paga come prima; chi guarda vede 11,25 gradi per posa invece di 22,5.
       Sedici richieste insieme: misurato, 32 fotogrammi arrivano in 627 ms in
       parallelo contro 2.065 in sequenza, e oltre le sedici connessioni non si
       guadagna piu' niente. */
    var elenco = (card._completa ? g.pose : indiciPose(g.n, POSE_PRIME))
                   .filter(function (n) { return !card._pose[n]; });
    if (!elenco.length) { codaAlLavoro = false; return tiraCoda(); }
    var restano = elenco.length;
    function unaInMeno() {
      if (--restano > 0) return;
      card.setAttribute("data-cp3-giropronto", card._completa ? "2" : "1");
      codaAlLavoro = false;
      tiraCoda();
    }
    elenco.forEach(function (n) {
      var im = new Image();
      im.onload = im.onerror = unaInMeno;
      im.src = g.giro + n + ".webp";
      card._pose[n] = im;
    });
    /* se un fotogramma non risponde piu', la coda non deve fermarsi per
       sempre: dopo dodici secondi si passa alla scheda dopo comunque */
    setTimeout(function () {
      if (codaAlLavoro && restano > 0) { restano = 0; codaAlLavoro = false; tiraCoda(); }
    }, 12000);
  }

  /* CHI SI FERMA SU UNA CARTA, QUELLA APRIRA'. Non muove niente in lista:
     comincia soltanto a prendere i fotogrammi della SCHEDA di quella pietra,
     cosi' un attimo dopo il giro e' gia' pronto. Stava dentro agganciaGiro —
     che dal 20 settembre non si chiama piu', perche' faceva girare la pietra
     col mouse — ed e' l'unica cosa di quel blocco che valeva la pena tenere. */
  function preparaScheda(lista) {
    if (lista._preparata) return;
    lista._preparata = 1;
    lista.addEventListener("pointerenter", function (e) {
      var card = e.target.closest ? e.target.closest(".cp3-card") : null;
      if (!card) return;
      var x = inMano(card.getAttribute("data-cp3-id"));
      if (x) scaldaScheda(x);
    }, true);
  }

  function agganciaGiro(lista) {
    /* GLI ASCOLTATORI STANNO SUL CONTENITORE, e il contenitore e' sempre lo
       stesso nodo: si attaccano una volta e basta. Prima disegnaLista() li
       riattaccava a ogni "vedi le altre pietre" e a ogni ritorno dalla scheda,
       e dopo sei giri ogni singolo movimento del mouse rifaceva sei volte lo
       stesso lavoro sulla stessa carta. */
    if (lista._agganciata) return;
    lista._agganciata = 1;
    lista.addEventListener("pointermove", function (e) {
      var card = e.target.closest ? e.target.closest(".cp3-card") : null;
      if (!card || !poseDi(card)) return;
      var r = card.getBoundingClientRect();
      mostraPosa(card, (e.clientX - r.left) / r.width);
    });
    lista.addEventListener("pointerenter", function (e) {
      var card = e.target.closest ? e.target.closest(".cp3-card") : null;
      if (!card) return;
      scaldaGiro(card, true);
      /* e intanto si comincia a prendere le 128 pose della SCHEDA di questa
         pietra: chi si ferma col mouse su una carta, nove volte su dieci e'
         la carta che aprira' */
      var x = inMano(card.getAttribute("data-cp3-id"));
      if (x) scaldaScheda(x);
    }, true);
    /* uscendo si torna alla posa di partenza: una griglia dove ogni pietra e'
       girata a caso non si guarda */
    lista.addEventListener("pointerleave", function (e) {
      var card = e.target.closest ? e.target.closest(".cp3-card") : null;
      if (card) mostraPosa(card, 0);
    }, true);
  }

  /* IL COLORE DEL FONDO DELLA SCHEDA, preso dal fotogramma stesso.

     Ogni fornitore fotografa a modo suo: chi su grigio, chi su bianco, chi in
     orizzontale e chi quasi quadrato. Con il fotogramma "contain" dentro un
     riquadro quadrato, ogni scheda mostrava un rettangolo di forma e colore
     diversi dentro il proprio quadrato — dodici schede che sembravano dodici
     siti. Tingendo il riquadro dello stesso colore del fotogramma, il
     rettangolo sparisce nel quadrato e le schede tornano tutte uguali, senza
     tagliare un millimetro di pietra.

     Si campiona da una COPIA chiesta con il permesso di lettura, non
     dall'immagine in pagina: se un giorno l'archivio smettesse di darlo,
     resterebbe il bianco di prima e l'immagine visibile non ne saprebbe
     niente. */
  function tingiCulla(card, im) {
    if (card._tinta) return;
    card._tinta = 1;
    var culla = card.querySelector("[data-cp3-culla]");
    if (!culla || !im) return;
    var copia = new Image();
    copia.crossOrigin = "anonymous";
    copia.onload = function () {
      var c = fondoDaiBordi(copia);
      if (c) culla.style.background = "rgb(" + c[0] + "," + c[1] + "," + c[2] + ")";
    };
    copia.src = im.getAttribute("src");
  }

  /* quando la prima immagine e' arrivata: la C smette di pulsare, il riquadro
     si tinge e la scheda si mette in coda per prendersi tutte le pose */
  function segnaFotogrammi(lista) {
    lista.querySelectorAll("[data-cp3-360img]").forEach(function (im) {
      var card = im.closest(".cp3-card");
      if (!card) return;
      function pronta() {
        card.classList.add("is-fotogramma");
        tingiCulla(card, im);
        /* niente scaldaGiro: i fotogrammi del giro in lista non servono piu'.
           Quelli della SCHEDA li prende scaldaScheda al passaggio del mouse,
           che e' un'altra cosa e resta. */
      }
      if (im.complete && im.naturalWidth) pronta();
      else im.addEventListener("load", pronta);
    });
  }

  var lista0 = el("[data-cp3-lista]");

  /* IL PASSAGGIO DEL MOUSE STA IN agganciaGiro (riga 2656), e li' soltanto.
     Qui c'erano due ascoltatori della macchina vecchia — quella che accendeva
     un iframe di loupe360 per ogni scheda — rimasti attaccati quando il giro
     e' diventato fatto di fotogrammi nostri. Parlavano di otto cose che non
     esistono piu' (AUTO_360, ultimaSotto, attesa, vive, MAX_360, liberaPosto,
     accendi, ATTESA_360) e al primo movimento del mouse sulla griglia la
     console stampava «AUTO_360 is not defined». Tolti il 20 settembre 2026. */

  /* Il tocco, per chi non ha il mouse. Il pulsante sta FUORI dall'ancora e
     sopra di essa: il suo tocco non può in nessun caso diventare il clic che
     porta alla scheda della pietra. Una pietra per volta: due visori accesi
     insieme su un telefono sono due applicazioni React insieme. */
  /* DA TELEFONO non c'e' un mouse che passa sopra: il pulsante 360 fa fare
     alla pietra un giro completo da solo, alla stessa velocita' di tutto il
     resto della pagina. Ripremendo si ferma.
     Aveva un difetto suo: il contatore andava su 32 valori mentre le pose
     erano 16, quindi ogni posa restava ferma il doppio e il giro durava meta'
     del previsto. Adesso e' il motore unico a occuparsene, con le pose vere. */
  lista0.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-cp3-tocco]") : null;
    if (!b) return;
    var card = b.closest(".cp3-card");
    var g = card && poseDi(card);
    if (!g) return;
    if (card._giroVivo) {
      card._giroVivo.fermo = true;
      card._giroVivo = null;
      b.setAttribute("aria-pressed", "false");
      mostraPosa(card, 0);
      return;
    }
    scaldaGiro(card, true);
    b.setAttribute("aria-pressed", "true");
    var im = card.querySelector("[data-cp3-360img]");
    if (im) card._giroVivo = faiGirare(im, g.pose,
      { giro: g.giro, giroN: g.n }, MS_LISTA, card._pose);
  });


  var DISEGNI = { Rotondo: "taglio-rotondo.jpg", Ovale: "taglio-ovale.jpg", Cushion: "taglio-cushion.jpg",
    Principessa: "taglio-princess.jpg", Goccia: "taglio-goccia.jpg", Smeraldo: "taglio-smeraldo.jpg",
    Marquise: "taglio-marquise.jpg", Radiant: "taglio-radiant.jpg" };
  function disegnoTaglio(x) { return DISEGNI[x.forma] || "taglio-rotondo.jpg"; }

  /* ————— le risposte date, ognuna cliccabile per cambiarla ————— */
  /* Le pastiglie delle scelte sono state tolte dal documento su richiesta:
     la funzione resta perche' e' l'unico posto che sa scrivere quel riepilogo,
     e se un giorno lo si rimette basta rimettere il contenitore. */
  function disegnaScelte() {
    var box = el("[data-cp3-scelte]");
    if (!box) return;
    box.innerHTML = "";
    var voci = [
      { t: "Taglio",    v: (trova(FORME, S.forma) || {}).nome || "—", vai: 2 },
      { t: "Dimensione", v: (bCaratura() || {}).nome || "tutte", vai: 2 },
      { t: "Qualità",   v: (bQualita() || {}).nome || "tutte", vai: 2 }
    ];
    voci.forEach(function (v) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cp3-chip";
      b.setAttribute("aria-label", v.t + ": " + v.v + ". Cambia questa risposta");
      b.innerHTML = v.t + ": <b>" + fuggi(v.v) + "</b> <span aria-hidden=\"true\">✎</span>";
      b.addEventListener("click", function () { vai(v.vai, true); });
      box.appendChild(b);
    });
    var r = document.createElement("button");
    r.type = "button";
    r.className = "cp3-ricomincia";
    r.textContent = "Ricomincia";
    r.addEventListener("click", function () {
      S.forma = ""; S.colore = ""; S.caratura = ""; S.fascia = "";
      vai(1, true);
    });
    box.appendChild(r);
  }

  /* ————— zero pietre: si dice, e si offrono le uscite col numero vero —————
     Le due strade più probabili sono cambiare budget o caratura (che sono le
     domande che stringono), più la rete di sicurezza: tutte le pietre del
     taglio scelto, che non è mai vuota. */
  function proponiVuoto(mio) {
    var box = el("[data-cp3-vuoto]");
    var bt = el("[data-cp3-vuoto-b]");
    bt.innerHTML = "";
    box.hidden = false;
    /* UNA RIGA E BASTA (13 settembre 2026). Diceva anche che l'archivio
       cambia ogni ora: e' vero, ma e' come funziona il nostro magazzino, non
       una cosa che riguarda chi sta cercando un anello. */
    el("[data-cp3-vuoto-t]").textContent =
      "Nessun risultato con i filtri scelti.";

    /* UN INVITO SOLO (10 settembre 2026). Qui ce n'erano cinque: contattaci,
       cambio la dimensione, cambio la fascia, cambio il taglio, e "mostrami
       tutte le <forma>" col numero vero. Servivano a non lasciare un vicolo
       cieco, ma erano cinque pulsanti dentro un cartello grigio in mezzo a una
       pagina bianca, e il cliente li ha fatti togliere.
       Le tre uscite che cambiavano una scelta non mancano: quelle scelte sono
       i filtri qui sopra, che restano in vista e si toccano. Resta il contatto,
       che e' l'unica cosa che la pagina da sola non puo' fare — e apre il
       modulo gia' compilato con quello che si stava cercando. */
    var bc = document.createElement("button");
    bc.className = "cp3-vuoto-cerca";
    bc.textContent = "Contattaci";
    bc.addEventListener("click", function () { chiediRicerca(bQualita() || null); });
    bt.appendChild(bc);
  }

  /* ══════════════════════════════════════════════════════════════════════
     LA SCHEDA DELLA PIETRA
     ══════════════════════════════════════════════════════════════════════
     Arrivata dalla vecchia pagina v1 il 15 agosto 2026, quando il cliente ha
     chiesto di cancellarla — i nomi dei file eliminati stanno nel riquadro in
     cima a questa sezione, che non viene servito al browser. Il testo delle
     spiegazioni e la scheda tecnica sono quelli, parola per parola: erano
     stati scritti e corretti con lui, e riscriverli qui avrebbe voluto dire
     rifare quel lavoro. Quello che è cambiato è il MEDIA — solo il 360 — e il
     fondo della colonna di sinistra, campionato dal vivo.
     ══════════════════════════════════════════════════════════════════════ */

  var inEsame = null;      /* la pietra aperta adesso */
  var daEsito = false;     /* si è arrivati dai risultati o da un collegamento? */
  var giroTinta = 0;       /* per buttare via le tinte arrivate in ritardo */

  /* ————— si entra da qui: il clic su una scheda dei risultati —————
     Il collegamento resta vero e funzionante (vedi versoScheda). Qui si
     intercetta SOLO il clic normale: con un modificatore, o col tasto
     centrale, il browser deve poter aprire la scheda in una pagina nuova. */
  el("[data-cp3-lista]").addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest(".cp3-card-corpo") : null;
    if (!a) return;
    var card = a.closest(".cp3-card");
    var id = card && card.getAttribute("data-cp3-id");
    /* senza l'oggetto sotto mano non si intercetta niente: il collegamento
       vero porta allo stesso indirizzo e la pietra si chiede all'archivio */
    if (!id || !inMano(id)) return;
    e.preventDefault();
    daEsito = true;
    S.pietra = id;
    vai("pietra", true);
  });

  function inMano(id) {
    for (var i = 0; i < S.pietre.length; i++) if (S.pietre[i].id === id) return S.pietre[i];
    return null;
  }

  /* ————— disegnare la scheda ————— */
  function scheda() {
    var mio = giro;
    /* L'USCITA SI CHIAMA COL NOME DEL POSTO IN CUI RIPORTA, e sono tre posti
       diversi: chi arriva dai risultati ci "torna"; chi ha ricevuto il
       collegamento non ci è mai stato — "torna" sarebbe una bugia — ma se
       nell'indirizzo ci sono i filtri quelle pietre esistono e gliele si
       offre; senza filtri l'unico posto sensato è l'inizio del percorso. */
    el("[data-cp3-p-torna]").textContent =
      daEsito ? "← Torna alle pietre" : S.forma ? "← Vedi le altre pietre" : "← Cerca la tua pietra";
    var x = inMano(S.pietra);
    if (x) { mostraScheda(x); return; }
    /* collegamento diretto: la pietra non è fra quelle caricate e si chiede
       all'archivio, una sola, per sigla */
    attesaScheda();
    fetch(apiPietraOra() + "?id=" + encodeURIComponent(S.pietra), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(
        function (d) {
          if (mio !== giro) return;               /* si è già usciti dalla scheda */
          if (!d || !d.ok || !d.pietra) { schedaPersa(); return; }
          mostraScheda(d.pietra);
        },
        /* IL SECONDO ARGOMENTO DI .then E NON UN .catch IN FONDO, ed è una
           differenza che si vede in faccia al cliente: un .catch in coda
           raccoglierebbe anche gli errori di mostraScheda, e un errore nostro
           mentre disegniamo la scheda finirebbe scritto al visitatore come
           "questa pietra non c'è più" — cioè una notizia falsa su una pietra
           che invece è lì. Così il ripiego copre solo quello che deve: la rete
           che non risponde e una risposta che non è JSON. */
        function () { if (mio === giro) schedaPersa(); }
      );
  }

  function scriviScheda(sel, testo) { var e = el(sel); if (e) e.textContent = testo; }
  function scriviHtml(sel, html) { var e = el(sel); if (e) e.innerHTML = html; }

  function attesaScheda() {
    el("[data-cp3-p-uscite]").hidden = true;
    scriviScheda("[data-cp3-p-briciola]", "");
    scriviScheda("[data-cp3-p-lab]", "");
    scriviScheda("[data-cp3-fuoco-p]", "Un momento");
    scriviScheda("[data-cp3-p-riga]", "Stiamo chiedendo questa pietra al nostro archivio.");
    scriviScheda("[data-cp3-p-prezzo]", "");
    scriviHtml("[data-cp3-p-spiega]", "");
    scriviHtml("[data-cp3-p-spec]", "");
    scriviHtml("[data-cp3-p-cert]", "");
    scriviScheda("[data-cp3-p-nota]", "");
    scriviScheda("[data-cp3-p-media-nota]", "");
    el("[data-cp3-p-tela]").innerHTML = "";
  }

  /* La pietra non c'è più — succede: il feed si rinfresca ogni ora e questo
     indirizzo può essere stato salvato ieri. Non è un guasto e non si scrive
     come tale: si dice cos'è successo e si offre la strada che resta. */
  function schedaPersa() {
    inEsame = null;
    el("[data-cp3-p-uscite]").hidden = true;
    scriviScheda("[data-cp3-p-briciola]", "");
    scriviScheda("[data-cp3-p-lab]", "");
    scriviScheda("[data-cp3-fuoco-p]", "Questa pietra non c'è più");
    scriviScheda("[data-cp3-p-riga]",
      "Il nostro archivio cambia ogni ora e questo diamante oggi non c'è: " +
      "o è stato venduto, o il fornitore l'ha ritirato.");
    scriviScheda("[data-cp3-p-prezzo]", "");
    scriviHtml("[data-cp3-p-spiega]",
      '<p>Puoi ripartire dalla ricerca — le pietre disponibili adesso sono quelle — ' +
      'oppure <a href="' + fuggi(CONTATTI) + '">scriverci</a>: se ci dici cosa cercavi ' +
      "ne troviamo una simile e te la mostriamo.</p>");
    scriviHtml("[data-cp3-p-spec]", "");
    scriviHtml("[data-cp3-p-cert]", "");
    scriviScheda("[data-cp3-p-nota]", "");
    scriviScheda("[data-cp3-p-media-nota]", "");
    el("[data-cp3-p-tela]").innerHTML = "";
  }

  function mostraScheda(x) {
    inEsame = x;
    /* L'ora in cui il prezzo viene MOSTRATO, non quella dell'invio: sono due
       momenti diversi, e chi in boutique risponde deve conoscere il primo. */
    S.vistoIl = new Date();

    scriviScheda("[data-cp3-p-briciola]", (daEsito ? "Le pietre trovate / " : "") + titoloPietra(x));

    disegnaMedia(x);
    tingiColonna(null);   /* pulisce: il colore lo posa disegnaMedia */

    scriviScheda("[data-cp3-p-lab]",
      (x.naturale === false ? "Diamante" : "Diamante naturale") + " · Certificato " + (x.laboratorio || "GIA"));
    scriviScheda("[data-cp3-fuoco-p]", titoloPietra(x));
    accordaFlottanti(x);
    scriviScheda("[data-cp3-p-riga]", rigaSintesi(x));
    scriviScheda("[data-cp3-p-prezzo]", euroPub(x.prezzo));
    var cons = el("[data-cp3-p-consegna]");
    if (cons) {
      var da = x.consegnaDa, aa = x.consegnaA;
      if (da && aa && aa > da) cons.textContent = "In negozio da noi in " + da + "-" + aa + " giorni lavorativi";
      else if (da) cons.textContent = "In negozio da noi in " + da + " giorni lavorativi";
      cons.hidden = !cons.textContent;
    }
    scriviHtml("[data-cp3-p-spiega]", spiegazioni(x));
    scriviHtml("[data-cp3-p-spec]", specifiche(x));
    scriviHtml("[data-cp3-p-cert]", bloccoCertificato(x));
    scriviScheda("[data-cp3-p-nota]",
      "Il certificato " + (x.laboratorio || "GIA") + " originale accompagna sempre la pietra. " +
      "Il prezzo è quello di oggi: il nostro archivio si aggiorna ogni ora e la disponibilità " +
      "te la confermiamo noi.");
    el("[data-cp3-p-uscite]").hidden = false;
  }

  /* ————— IL MEDIA: SOLO IL 360 —————
     Richiesta del cliente, testuale: "come media metti solo ed esclusivamente
     il 360 della pietra, niente altre immagini". Quindi niente galleria,
     niente pila che scorre, niente seconda fotografia sotto.

     IL VISORE E' NOSTRO. Fino a stamattina qui c'era una pagina di
     loupe360 dentro un riquadro: girava da sola ma si fermava al passaggio
     del mouse e per farla ripartire bisognava RICARICARLA — di qui il
     "sembra riavviarsi e rifare il loop" della segnalazione — e si portava
     dietro le sue barre di scorrimento, che nessun ritaglio nascondeva del
     tutto.

     Adesso sono fotogrammi nostri (vedi il motore del giro piu' su): un
     <img> che cambia immagine trentadue volte a giro. Ne viene che il giro
     non si interrompe mai, che il mouse lo guida senza fermarlo, che uscendo
     riprende da dove era, che non c'e' nessuna barra da nascondere e che il
     fondo si campiona dal fotogramma vero. */
  function disegnaMedia(x) {
    var tela = el("[data-cp3-p-tela]");
    var nota = el("[data-cp3-p-media-nota]");
    tela.innerHTML = "";
    if (tela._posa && tela._posa.giro) tela._posa.giro.fermo = true;
    tela._posa = null;
    /* SI SPENGONO I TIMER DELLA PIETRA DI PRIMA.

       Ogni pietra aperta lasciava due temporizzatori in volo — un intervallo
       da 120 ms che aspetta i fotogrammi e il tetto dei venti secondi — e
       nessuno li fermava passando a un'altra pietra. Quando i fotogrammi
       della pietra VECCHIA finivano di arrivare, il loro apri() partiva lo
       stesso; e siccome la tela e' sempre lo stesso nodo, quell'apri()
       prendeva la C d'oro che stava pulsando per la pietra NUOVA e la
       spegneva, lasciando un quadrato vuoto finche' la nuova non era pronta.
       E' il "dopo un tot il video sembra ricaricarsi" della segnalazione: si
       innesca ogni volta che si aprono due pietre di fila, cioe' ogni volta
       che qualcuno confronta. */
    if (tela._timer) {
      clearInterval(tela._timer.i);
      clearTimeout(tela._timer.t);
      tela._timer = null;
    }

    var g = pose(x);
    if (g.length) {
      /* L'attesa non e' piu' muta: sotto la C c'e' scritto che cosa sta
         succedendo e a che punto e'. Il riquadro NON e' aria-hidden come
         prima — adesso porta un testo che serve anche a chi non vede lo
         schermo — ed e' aria-live="polite", cosi' il lettore annuncia la fine
         del caricamento senza interrompere quello che sta leggendo. */
      tela.innerHTML = '<span class="cp3-p-caric" role="status" aria-live="polite">' +
        '<img src="' + fuggi(ASSETS + "curnis-c-oro.png") + '" alt="" loading="eager">' +
        '<span class="cp3-p-caric-txt">Caricamento in corso' +
          '<b data-cp3-caric-q></b></span>' +
        '<span class="cp3-p-barra" aria-hidden="true"><i data-cp3-caric-barra></i></span>' +
        "</span>";
      var img = document.createElement("img");
      img.className = "cp3-p-360";
      img.alt = titoloPietra(x) + ", che gira su s\u00e9 stesso a 360 gradi";
      img.decoding = "async";
      /* il permesso di leggere i pixel: serve per tingere la colonna del
         fondo esatto della pietra, e l'archivio dei fotogrammi lo concede */
      img.crossOrigin = "anonymous";
      img.src = fotogramma(x, g[0]);
      tela.appendChild(img);

      /* IL MAGAZZINO E' GIA' AVVIATO, quasi sempre: scaldaScheda parte al
         passaggio del mouse sulla carta della lista, cioe' un secondo o due
         prima del clic. Qui si aggancia soltanto — e se nessuno era passato
         col mouse (collegamento diretto, tastiera) parte adesso. */
      var caldo = scaldaScheda(x) || { tenute: {}, pronte: 0, quante: g.length };
      var tenute = caldo.tenute;

      /* LO STATO STA SULLA TELA, non nella chiusura. E si chiama POSA e
         non con la lettera sola: quella lettera e' gia' lo stato della
         pagina, e un "var" con lo stesso nome qui dentro lo coprirebbe
         per tutta la funzione — e' una var, quindi vale dalla prima riga. Gli ascoltatori del mouse
         si attaccano una volta sola (la tela e' sempre lo stesso elemento:
         cambia solo quello che c'e' dentro): se si riattaccassero a ogni
         pietra aperta, dopo venti pietre ce ne sarebbero sessanta, e quelli
         vecchi continuerebbero a muovere immagini non piu' in pagina. */
      var POSA = tela._posa = { g: g, x: x, img: img, tenute: tenute,
        giro: null,
        /* IL PUNTATORE PUO' ESSERE GIA' DENTRO, e lo stato vero si LEGGE, non
           si ricorda. Chi clicca una carta della lista lascia il mouse
           esattamente dove nascera' la tela: pointerenter e' gia' passato — o
           non passera' mai piu', se il mouse non si muove. Fidarsi
           dell'evento porta a due guai opposti: o il motore parte libero
           mentre il mouse scrive lo stesso fotogramma (due padroni, e la
           pietra sbatte fra due pose: e' lo "scattoso" della segnalazione),
           oppure il comando col mouse resta morto per tutta quella pietra. */
        guidato: (tela.matches ? tela.matches(":hover") : false) };
      var avvio = null;

      /* L'ATTESA E' VISIBILE E ONESTA. Finche' i fotogrammi non ci sono tutti
         si vede la C di Curnis che pulsa e la pietra sta nascosta: appare
         gia' in movimento, senza il mezzo secondo di saltelli di prima.
         Il tetto e' generoso (venti secondi) perche' su una rete lenta e'
         meglio aspettare che vedere una pietra che si strappa; se scade si
         parte lo stesso con quello che c'e'. */
      function apri() {
        /* QUESTA E' LA TELA DI UN'ALTRA PIETRA: qui non si tocca niente.
           Terza cintura, oltre allo spegnimento dei timer: se per qualunque
           strada un apri() vecchio arrivasse fin qui, si ferma da solo. */
        if (tela._posa !== POSA) return;
        if (POSA.giro) return;

        /* L'ULTIMA PAROLA CE L'HA IL TAG CHE SI VEDE, non il magazzino.
           Il contatore misura le immagini tenute in memoria; quella dipinta
           sullo schermo e' un altro elemento, con la sua src e la sua
           decodifica. Al 100% del magazzino quel tag poteva non aver ancora
           dipinto niente, e la tenda si alzava sul vuoto: e' il difetto
           segnalato — "arriva al 100%, scompare, ma sotto sta ancora
           caricando".
           Aspettando la sua decode() la tenda si alza sul primo fotogramma
           gia' disegnato. I controlli si rifanno DENTRO la promessa: fra la
           chiamata e la risposta si puo' aprire un'altra pietra. */
        var alzata = false;
        function alza() {
          if (alzata) return;
          alzata = true;
          if (tela._posa !== POSA || POSA.giro) return;
          scopri();
        }
        if (POSA.img.decode) {
          POSA.img.decode().then(alza, alza);
          /* stessa rete: se la decodifica non torna — pagina in secondo piano —
             la tenda si alza lo stesso dopo mezzo secondo, che e' il
             comportamento di prima. Meglio un fotogramma che si forma di una
             tenda che non se ne va piu'. */
          setTimeout(alza, 500);
        } else { alza(); }
      }
      function scopri() {
        var c = tela.querySelector(".cp3-p-caric");
        if (c) c.classList.add("is-via");
        POSA.img.classList.add("is-pronto");
        /* la didascalia e' stata tolta: chi ci passa sopra col mouse lo scopre
           da solo, e una riga di istruzioni sotto una pietra la sminuisce */
        nota.textContent = "";
        POSA.giro = faiGirare(POSA.img, POSA.g, x, MS_SCHEDA, POSA.tenute);
        /* se il mouse e' gia' li', comanda lui: il motore nasce fermo */
        if (POSA.guidato) POSA.giro.fermo = true;
      }
      /* LA C RESTA FINCHE' NON E' PRONTO IL CENTO PER CENTO. Aprire a meta'
         vuol dire far partire il giro su fotogrammi che non ci sono ancora:
         il motore li salta, e la pietra "scatta". Il tetto qui sotto e' solo
         una rete di sicurezza per la rete che muore, non un ripiego di
         comodo: se scatta, si parte con quello che c'e' perche' una C che
         pulsa per sempre e' peggio. */
      /* La stessa battuta che aspetta scrive anche a che punto siamo: e' gia'
         li' ogni ottanta millesimi, e un secondo temporizzatore per dire un
         numero sarebbe uno spreco. Si scrive solo quando il numero CAMBIA:
         riscrivere "31%" ottanta volte al secondo fa lavorare il browser per
         niente e fa ripetere la frase ai lettori di schermo. */
      var quantoDetto = -1;
      var etiQ = tela.querySelector("[data-cp3-caric-q]");
      var barra = tela.querySelector("[data-cp3-caric-barra]");
      avvio = setInterval(function () {
        if (caldo.quante) {
          /* NIENTE PIU' TETTO A 99. Prima la cifra era Math.min(99, ...): al
             cento per cento continuava a dire 99, e chi guardava vedeva il
             numero incastrato li' per qualche secondo mentre finivano gli
             ultimi fotogrammi — poi la tenda si alzava di colpo. Sembrava
             bloccato, ed e' esattamente la segnalazione: "quando il caricamento
             finisce resta tutto bloccato e poi viene mostrato il video, quindi
             non era tutto caricato".
             Adesso il numero dice la verita' e arriva a 100, e la tenda si alza
             subito dopo. */
          var q = Math.floor(caldo.pronte * 100 / caldo.quante);
          if (q > 100) q = 100;
          if (q !== quantoDetto) {
            quantoDetto = q;
            if (etiQ) etiQ.textContent = " \u00b7 " + q + "%";
            if (barra) barra.style.width = q + "%";
          }
        }
        if (caldo.pronte >= caldo.quante) { clearInterval(avvio); clearTimeout(tetto); apri(); }
      }, 80);
      var tetto = setTimeout(function () { clearInterval(avvio); apri(); }, 45000);
      /* si tengono, per poterli spegnere quando si apre un'altra pietra */
      tela._timer = { i: avvio, t: tetto };

      if (!tela._ascolta) {
        tela._ascolta = 1;
        tela.addEventListener("pointerenter", function () {
          var s = tela._posa;
          if (!s) return;
          s.guidato = true;
          if (s.giro) s.giro.fermo = true;      /* il motore si ferma, non muore */
        });
        tela.addEventListener("pointermove", function (e) {
          var s = tela._posa;
          if (!s || !s.guidato) return;
          var r = tela.getBoundingClientRect();
          if (!r.width) return;
          var q = Math.floor((e.clientX - r.left) / r.width * s.g.length);
          var i = ((q % s.g.length) + s.g.length) % s.g.length;
          if (s.giro) s.giro.k = i;             /* cosi' riprendera' da qui */
          s.img.src = fotogramma(s.x, s.g[i]);
        });
        tela.addEventListener("pointerleave", function () {
          var s = tela._posa;
          if (!s) return;
          s.guidato = false;
          riprendiGiro(s.giro);                 /* riparte da dove era */
        });
      }

      /* IL FONDO DELLA COLONNA DAL FOTOGRAMMA VERO. Adesso si puo': i
         fotogrammi sono immagini normali servite con il permesso di lettura,
         e il colore che si campiona e' quello dello stesso scatto che si
         vede — non piu' di un'altra fotografia. */
      /* IL COLORE SI CAMPIONA DA UN'IMMAGINE TUTTA SUA.
         Prima si ascoltava il "load" dell'immagine che gira. Ma quella e'
         la stessa che il motore del giro riscrive decine di volte al secondo:
         se il primo fotogramma non aveva finito di arrivare, cambiando src il
         caricamento si annulla e il "load" non arriva piu' — l'ascolto era
         "once", quindi il colore non si posava e la colonna restava bianca.
         E' esattamente il "alcune volte si mette il colore giusto, altre volte
         e' bianco" segnalato dal cliente: dipendeva da che cosa era gia' in
         memoria.
         Con un'immagine fuori dalla pagina, che nessuno riscrive, la corsa non
         c'e' piu'. */
      (function () {
        var sonda = new Image();
        sonda.crossOrigin = "anonymous";
        sonda.onload = function () { tingiColonna(sonda); };
        sonda.src = img.currentSrc || img.src;
      })();

      nota.textContent = "";
      return;
    }

    /* SENZA IL 360 NON SI MOSTRA NIENTE DEL FORNITORE. La fotografia ferma
       c'è e sarebbe comoda, ma il cliente l'ha vietata dappertutto: resta il
       disegno del taglio, che è roba nostra, e la didascalia dice la verità
       invece di far finta. */

    var d = document.createElement("img");
    d.className = "cp3-p-disegno";
    d.alt = "";
    d.src = ASSETS + disegnoTaglio(x);
    tela.appendChild(d);
    nota.textContent = "Di questa pietra non abbiamo né il giro a 360° né la fotografia. Qui sopra c'è " +
      "il disegno del suo taglio: è un'illustrazione, non lo scatto di questo diamante.";
  }

  /* ————— IL FONDO DELLA COLONNA, CAMPIONATO DAL VIVO —————
     Richiesta del cliente, testuale: "ogni immagine 360 ha tipo uno sfondo
     grigio, ma cambia da fornitore a fornitore. voglio che in automatico tutta
     la parte a sinistra sia dello stesso colore".

     SI CAMPIONA DALLA FOTOGRAFIA, NON DAL 360, e va detto chiaro: il 360 è una
     pagina di un altro dominio dentro un riquadro, e i suoi pixel non si
     possono leggere in nessun modo (nessuna origine estranea si legge, ed è
     giusto che sia così). La fotografia sì: il CDN delle immagini risponde con
     Access-Control-Allow-Origin: * — verificato con una richiesta HEAD — e con
     crossOrigin="anonymous" la si può disegnare su una tela e leggerne i
     pixel senza sporcarla. Le due cose vengono dallo stesso studio dello
     stesso fornitore, quindi il grigio è lo stesso; se un giorno divergessero,
     il posto dove rifare i conti è qui.

     SI PRENDONO I BORDI E SE NE FA LA MEDIANA. I bordi perché al centro c'è la
     pietra, che del fondo non sa niente. La mediana e non la media perché un
     riflesso, un angolo di cartoncino più chiaro o una firma stampata sono
     valori estremi: la media li assorbe e sposta la tinta di qualche punto,
     la mediana li ignora del tutto.

     SE QUALCOSA NON RIESCE — niente fotografia, CORS che cambia, tela sporca,
     un browser senza canvas — non succede NIENTE: resta il fondo chiaro del
     tema. Mai un colore a caso. E la tinta si posa una volta sola, senza
     transizione (vedi il foglio di stile): un fondo che sfuma sotto gli occhi
     mentre si guarda una pietra è esattamente il lampo da evitare. */
  /* I due pulsanti fissi si riaccordano a ogni pietra aperta: il collegamento
     al certificato porta il numero di QUESTA pietra, e la richiesta apre la
     stessa finestra del pulsante in fondo alla scheda — una strada sola, non
     due che possono divergere. */
  function accordaFlottanti(x) {
    var box = el("[data-cp3-flot]");
    if (!box) return;
    var gia = el("[data-cp3-flot-gia]");
    if (gia) {
      if (x && (x.certificato_pdf || x.certificato_n)) {
        gia.hidden = false;
        /* PRIMA IL PDF VERO. Il rapporto firmato dal GIA e' un documento: chi
           preme "vedi il certificato" vuole quello, non una pagina che gli
           chiede di ricopiare il numero in una casella. Il PDF c'e' su circa
           una pietra su due (26 su 48 in un sondaggio di oggi); quando manca
           si ripiega sul controllo ufficiale del GIA, che a partire dal numero
           mostra gli stessi dati. Il server lascia passare solo i PDF ospitati
           su archivi che non nominano il fornitore. */
        gia.setAttribute("href", x.certificato_pdf
          ? x.certificato_pdf
          : "https://www.gia.edu/report-check?reportno=" +
            encodeURIComponent(x.certificato_n));
      } else {
        gia.hidden = true;
      }
    }
    var pz = el("[data-cp3-flot-pz]");
    if (pz) pz.textContent = x && x.prezzo != null ? euroPub(x.prezzo) : "";
    var nm = el("[data-cp3-flot-nome]");
    if (nm) nm.textContent = x ? titoloPietra(x) : "";
    var rg = el("[data-cp3-flot-riga]");
    if (rg) rg.textContent = x ? rigaBanner(x) : "";
    var info = el("[data-cp3-flot-info]");
    if (info && !info.hasAttribute("data-acceso")) {
      info.setAttribute("data-acceso", "1");
      info.addEventListener("click", function () {
        var b = el("[data-cp3-p-boutique]");
        if (b) b.click();
      });
    }
  }

  /* IL FONDO DELLA COLONNA SI CAMPIONA DI NUOVO.

     Era stato spento per una ragione vera: lo prendevamo dalla fotografia
     ferma del fornitore mentre a schermo girava il visore di loupe360, che
     ha un fondo suo e viene da un altro archivio — due grigi diversi, e si
     vedeva. Dei pixel del visore non si poteva sapere niente: erano dentro
     un riquadro di un altro dominio.

     Adesso il media E' una nostra immagine, servita con il permesso di
     lettura. Il colore si prende dai BORDI del primo fotogramma, cioe'
     esattamente il fondo dello studio che ha scattato quella pietra, e la
     colonna diventa dello stesso colore: il quadrato del ritaglio smette di
     leggersi come un riquadro incollato sulla pagina. Se la lettura non
     riesce non si inventa niente e resta la carta del tema. */
  function tingiColonna(img) {
    var media = el("[data-cp3-p-media]");
    if (!media) return;
    /* NON PIU' LA COLONNA, SOLO LA TENDA. Il colore letto dai bordi del
       fotogramma serviva a far sparire il rettangolo del ritaglio; adesso quel
       rettangolo e' una polaroid dichiarata, e la colonna resta carta. Il
       colore continua a servire all'attesa: una tenda di quel grigio somiglia
       al fondo dello scatto, quindi quando la pietra compare non c'e' salto. */
    media.style.removeProperty("--cp3-tenda");
    media.classList.remove("cp3-p-media--scuro");
    if (!img || !img.naturalWidth) return;
    var c = fondoDaiBordi(img);
    if (!c) return;
    media.style.setProperty("--cp3-tenda", "rgb(" + c[0] + "," + c[1] + "," + c[2] + ")");
    if (luminanza(c) < 0.45) media.classList.add("cp3-p-media--scuro");
  }

  function fondoDaiBordi(img) {
    var L = 48;                         /* la fotografia si rimpicciolisce: del fondo interessa
                                           il colore, non il dettaglio, e 48×48 pixel si leggono
                                           in un battito */
    var BORDO = 3;                      /* la cornice da cui si campiona */
    var cv = document.createElement("canvas");
    cv.width = L; cv.height = L;
    var cx = cv.getContext ? cv.getContext("2d") : null;
    if (!cx) return null;
    var d;
    try {
      cx.drawImage(img, 0, 0, L, L);
      d = cx.getImageData(0, 0, L, L).data;
    } catch (e) {
      return null;                      /* tela sporca: il CDN non ha dato il permesso */
    }
    var R = [], G = [], B = [];
    for (var y = 0; y < L; y++) {
      for (var xx = 0; xx < L; xx++) {
        if (xx >= BORDO && xx < L - BORDO && y >= BORDO && y < L - BORDO) continue;
        var i = (y * L + xx) * 4;
        if (d[i + 3] < 250) continue;   /* trasparente: non è fondo, è niente */
        R.push(d[i]); G.push(d[i + 1]); B.push(d[i + 2]);
      }
    }
    if (R.length < 40) return null;
    return [mediana(R), mediana(G), mediana(B)];
  }
  function mediana(v) { v.sort(function (a, b) { return a - b; }); return v[v.length >> 1]; }
  /* la luminanza relativa della WCAG, non la media dei tre canali: il verde
     pesa sette volte il blu, e a occhio la differenza si vede */
  function luminanza(c) {
    var s = [];
    for (var i = 0; i < 3; i++) {
      var n = c[i] / 255;
      s.push(n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4));
    }
    return 0.2126 * s[0] + 0.7152 * s[1] + 0.0722 * s[2];
  }

  /* ————— uscire dalla scheda ————— */
  function spegniScheda() {
    var tela = el("[data-cp3-p-tela]");
    if (tela) tela.innerHTML = "";
    var media = el("[data-cp3-p-media]");
    if (media) { media.style.removeProperty("--cp3-tenda"); media.classList.remove("cp3-p-media--scuro"); }
    giroTinta++;
    inEsame = null;
  }

  el("[data-cp3-p-torna]").addEventListener("click", function () {
    /* Chi è arrivato dai risultati torna INDIETRO davvero: così il browser
       ripristina da sé la posizione nella pagina, e le pietre sono già in
       mano (vedi la firma dei filtri). Chi è arrivato da un collegamento
       ricevuto non ha un "indietro" dentro il sito: per lui si va all'inizio
       del percorso, che è l'unico posto sensato. */
    if (daEsito && history.length > 1) { history.back(); return; }
    S.pietra = "";
    vai(S.forma ? "esito" : 1, true);
  });

  /* ————— come si dice una pietra in italiano —————
     Testi presi dalla v1 senza cambiarne una parola: erano stati scritti e
     corretti col cliente. */
  function mm1(n) { return Number(n).toFixed(1).replace(".", ","); }
  function virgola(v) { return String(v).replace(".", ","); }

  /* I MILLIMETRI, e il tranello delle forme non rotonde. Sul rotondo lunghezza
     e larghezza coincidono e si dice "6,8 mm di diametro". Sulle fancy no:
     scrivere il solo numero della lunghezza fa credere che una pera da 10,2 mm
     sia il doppio di un rotondo da 6,8, mentre pesano quasi uguale. */
  function misuraCorta(x) {
    if (x.forma === "Brillante") return mm1(x.mm_l || x.mm) + " mm";
    if (x.mm_l && x.mm_w) return mm1(x.mm_l) + " × " + mm1(x.mm_w) + " mm";
    return x.mm ? mm1(x.mm) + " mm" : "";
  }
  function misuraLunga(x) {
    if (x.forma === "Brillante") return mm1(x.mm_l || x.mm) + " mm di diametro";
    return misuraCorta(x);
  }
  /* LA RIGA DELLA BARRA. Non e' quella della scheda: qui servono le due cose
     che si confrontano fra una pietra e l'altra — colore e purezza — perche'
     la barra e' l'unica cosa che resta sotto gli occhi mentre si scorre. La
     misura in millimetri viene dopo, che e' il "quanto si vede al dito". */
  function rigaBanner(x) {
    var p = [];
    if (x.tinta) p.push(x.colore);
    else if (x.colore) p.push("Colore " + x.colore);
    if (x.purezza) p.push("Purezza " + x.purezza);
    var m = misuraLunga(x); if (m) p.push(m);
    return p.join(" \u00b7 ");
  }

  function rigaSintesi(x) {
    var p = [];
    var m = misuraLunga(x); if (m) p.push(m);
    /* SU UNA FANCY LA PAROLA DEL COLORE E' UN'ALTRA. coloreParola traduce la
       lettera della scala D-Z ("bianchissima", "bianca calda"): su una pietra
       di colore quella lettera non esiste e la frase usciva sbagliata. Qui si
       usa quello che c'e' scritto sul certificato, tradotto — "giallo
       intenso" — che e' anche l'unica cosa che il cliente sta comprando. */
    if (x.tinta) {
      p.push(x.colore_it || x.colore);
      /* IL NOME CON CUI SI VENDE, che sul certificato non c'è: "champagne",
         "cognac". Stava sotto il colore nella griglia, in corpo minore, ed è
         uscito insieme a tutte le altre righe piccole — ma è l'unica di
         quelle che non era una spiegazione: era un secondo nome della pietra.
         Qui sta accanto al colore, che è il suo posto naturale. */
      if (x.etichetta) p.push(x.etichetta);
    } else {
      p.push(coloreParola(x.colore));
    }
    p.push(purezzaParola(x));
    return p.join(" · ");
  }
  function coloreParola(c) {
    if (c === "D" || c === "E" || c === "F") return "bianchissima";
    if (c === "G" || c === "H") return "bianca";
    return "bianca calda";
  }
  function purezzaParola(x) {
    /* Il grado GIA comanda: da VS2 in su una pietra è pulita a occhio nudo PER
       DEFINIZIONE, e il campo eyeClean del fornitore non può né confermarlo
       (sarebbe ovvio) né smentirlo (vincerebbe un giudizio a occhio contro il
       laboratorio). L'occhio nudo del fornitore parla solo dove il grado
       lascia il dubbio: SI1 e SI2. */
    if (x.purezza === "FL" || x.purezza === "IF") return "senza inclusioni";
    if (/^VV?S/.test(x.purezza || "")) return "pulita a occhio nudo";
    if (x.occhioNudo === true) return "pulita a occhio nudo";
    if (x.occhioNudo === false) return "qualche inclusione si intuisce da vicino";
    if (x.purezza === "SI2") return "inclusioni ben visibili con la lente";
    return "inclusioni visibili con la lente";
  }
  /* Il titolo è un NOME, quello con cui la chiameresti a voce, non un'etichetta
     di magazzino: "Diamante ovale da 2,01 ct" e non "2,01 ct · Ovale". */
  var NOME_FORMA = { Rotondo: "Diamante rotondo", Ovale: "Diamante ovale",
    Cushion: "Diamante cushion", Principessa: "Diamante taglio principessa",
    Goccia: "Diamante taglio goccia", Smeraldo: "Diamante taglio smeraldo",
    Marquise: "Diamante marquise", Radiant: "Diamante radiant",
    Cuore: "Diamante taglio cuore" };
  function titoloPietra(x) {
    var n = NOME_FORMA[x.forma] || ("Diamante " + String(x.forma || "").toLowerCase());
    /* sulle fancy il colore entra nel titolo: fra dodici schede tutte gialle
       la forma da sola non basta a riconoscere quella che si stava guardando */
    /* IL COLORE IN ITALIANO, non la frase del certificato (15 settembre 2026).
       Qui entrava x.colore, cioe' la dicitura intera del GIA: uscivano titoli
       come "Diamante ovale Fancy Light Greenish Yellow da 0,70 ct" — inglese
       in mezzo a una frase italiana, e lunghissimo. La frase del certificato
       resta dove serve davvero: la barra in fondo e il blocco delle
       spiegazioni, dove si legge accanto al documento. */
    if (x.tinta && (x.colore_it || x.colore)) n = n + " " + (x.colore_it || x.colore);
    return n + " da " + ct(x.carati) + " ct";
  }

  /* ————— come si spiegano i gradi, in una riga ————— */
  /* UN TESTO PER OGNI GRADO, da D a H (19 settembre 2026): prima D, E ed F ne
     condividevano uno e G ed H un altro. Le frasi nuove sono complete e
     cominciano da maiuscola, percio' chi le stampa NON antepone piu' "È ": i
     gradi sotto la H, che restano come erano, se lo portano dentro. */
  var COLORE = {
    D: "Il grado più alto della scala GIA: un diamante completamente incolore, dalla luminosità eccezionale.",
    E: "Un bianco eccezionalmente puro, appartenente alla fascia dei diamanti incolori.",
    F: "Una tonalità ancora classificata come incolore, luminosa e raffinata.",
    G: "Un diamante quasi incolore, con una tonalità molto difficile da percepire a occhio nudo.",
    H: "Un bianco equilibrato e luminoso, con una lieve sfumatura generalmente poco percepibile una volta montato."
  };
  function spiegaColore(c) {
    if (COLORE[c]) return COLORE[c];
    return "È bianca calda: ha una punta di calore che l'oro giallo asseconda.";
  }
  var PUREZZA = {
    FL: "Nessuna inclusione o imperfezione interna o esterna visibile a un gemmologo con ingrandimento 10×.",
    IF: "Nessuna inclusione interna visibile a 10×; possono essere presenti soltanto minime caratteristiche superficiali.",
    VVS1: "Inclusioni estremamente minute, eccezionalmente difficili da individuare anche con ingrandimento.",
    VVS2: "Inclusioni estremamente minute, molto difficili da individuare anche con ingrandimento.",
    VS1: "Inclusioni minime, difficili da individuare con ingrandimento e normalmente non percepibili a occhio nudo.",
    VS2: "Piccole inclusioni visibili con ingrandimento, generalmente difficili da percepire a occhio nudo.",
    SI1: "Ha inclusioni che con la lente si vedono, a occhio nudo no.",
    SI2: "Ha inclusioni che con la lente si vedono bene; da vicino, su qualche pietra, si intuiscono."
  };
  /* SOLO FL E IF SI SCRIVONO PER ESTESO nel titolo: sono le uniche due sigle
     che non si capiscono da sole. Sulle altre il titolo resta la sigla. */
  var PUREZZA_TITOLO = { FL: "FL — Flawless", IF: "IF — Internally Flawless" };
  /* PUREZZA_CORTA E' USCITA con le righe piccole della griglia, che erano
     l'unico posto che la usava. Diceva in tre parole quello che PUREZZA qui
     sopra dice per intero nel blocco delle spiegazioni: era una seconda
     versione dello stesso testo, e due versioni dello stesso testo prima o
     poi si contraddicono. */

  /* LE SEGNALAZIONI DEL FORNITORE. Non sono sì/no: sono scale, e il feed lascia
     passare solo i due gradi che si vedono davvero (2 e 3). Il grado 1 — VLB,
     VVLM, LG — non arriva nemmeno qui, ed è giusto così: spaventare un cliente
     su una pietra perfettamente normale è un danno, non una precauzione.
     ATTENZIONE: nella colonna verde il codice LG vuol dire LIGHT GREEN, non
     lab grown. Qui non arriva mai (è grado 1), ma se un giorno arrivasse non
     va MAI raccontato come "diamante di laboratorio". */
  var SEGN_CORTA = {
    bruna:       { 2: "una punta di calore", 3: "una dominante bruna che si vede" },
    verde:       { 2: "una lievissima dominante verde", 3: "una dominante verde visibile" },
    lattiginosa: { 2: "un aspetto un po' lattiginoso", 3: "un aspetto lattiginoso" }
  };
  var SEGN_LUNGA = {
    bruna: {
      2: "Il certificato le riconosce una punta di calore: sull'oro giallo è un pregio, sul bianco si nota appena.",
      3: "Il certificato le riconosce una dominante bruna che si vede: rende meno luce di quanto il suo grado lascerebbe pensare. Vale la pena guardarla dal vivo prima di decidere."
    },
    verde: {
      2: "Il certificato le riconosce una lievissima dominante verde: montata non si nota.",
      3: "Il certificato le riconosce una dominante verde visibile. Vale la pena guardarla dal vivo prima di decidere."
    },
    lattiginosa: {
      2: "Il certificato la segnala un po' lattiginosa: la luce ne esce meno netta.",
      3: "Il certificato la segnala lattiginosa: è la cosa che toglie più luce di tutte. Guardala dal vivo prima di decidere."
    }
  };
  function segnalazioni(x) { return (x && x.segnalazioni) || []; }

  function spiegazioni(x) {
    var p = [];
    /* LE PIETRE DI COLORE NON PASSANO DA spiegaColore() (15 settembre 2026).
       Quella funzione conosce solo D, E, F, G e H: qualunque altra cosa cade
       sull'ultimo return, e una fancy ci finiva sempre. Risultato, letto in
       pagina: "Colore Fancy Vivid Blue. È bianca calda: ha una punta di calore
       che l'oro giallo asseconda." Su tutte e 6.816 le pietre di colore.
       Qui il ramo delle fancy dice quello che i dati sanno davvero — la
       dicitura del certificato, la sua resa italiana e il gradino della scala
       — e il ramo dei bianchi resta identico a com'era: serve a decine di
       migliaia di pietre e non si tocca per sistemarne 6.816. */
    if (x.tinta) {
      var sc = "<p><b>Colore " + fuggi(x.colore) + ".</b> È la dicitura del certificato, e non si traduce";
      if (x.colore_it) sc = sc + ": in italiano è " + fuggi(x.colore_it);
      sc = sc + ". Nei diamanti di colore la scala non misura quanto colore manca, ma quanto ce n'è";
      /* IL GRADINO FRA VIRGOLETTE, e non "qui è chiaro": in italiano "chiaro"
         vuol dire tutt'e due le cose — poco intenso e ovvio — e la frase si
         leggeva come "e qui è evidente". Le virgolette dicono che quella
         parola e' un valore della scala, non un commento. */
      if (x.intensita_it) sc = sc + ": questa sta al gradino «" + fuggi(x.intensita_it) + "»";
      /* LE SFUMATURE, se il certificato ne segnala (15 settembre 2026).
         "Greenish" vuol dire che la pietra va verso il verde leggermente: sono
         le parole che il GIA mette prima del colore di base, e fino a oggi
         finivano nel cestino — otto certificati diversi davano tutti "giallo
         chiaro". Qui si leggono, ed e' l'unico posto dove c'e' lo spazio per
         dirle per esteso. */
      if (x.sfumature_it) sc = sc + ", e " + fuggi(x.sfumature_it);
      p.push(sc + ".</p>");
    } else if (x.colore) {
      p.push("<p><b>Colore " + fuggi(x.colore) + ".</b> " + spiegaColore(x.colore) + "</p>");
    }
    if (PUREZZA[x.purezza]) p.push("<p><b>Purezza " + fuggi(PUREZZA_TITOLO[x.purezza] || x.purezza) + ".</b> " + PUREZZA[x.purezza] + "</p>");
    /* stessa regola di purezzaParola: l'occhio nudo del fornitore si scrive
       solo su SI1/SI2, dove il grado GIA lascia davvero il dubbio. Su una FL
       direbbe l'ovvio, o peggio la smentirebbe. */
    if (x.purezza === "SI1" || x.purezza === "SI2") {
      if (x.occhioNudo === true)
        p.push("<p><b>Pulita a occhio nudo.</b> Le sue inclusioni si trovano con la lente, non guardandola.</p>");
      else if (x.occhioNudo === false)
        p.push("<p><b>A occhio nudo.</b> Guardandola da vicino qualche inclusione si intuisce anche senza lente.</p>");
    }

    /* Il grado di taglio esiste solo sui rotondi: il GIA non lo assegna alle
       altre forme. Una riga "Taglio: —" sembrerebbe un dato mancante per
       sbaglio invece che una scelta del laboratorio. */
    if (x.taglio) {
      p.push("<p><b>Taglio " + fuggi(x.taglio) + ".</b> " +
        (x.taglio === "Excellent"
          ? "Proporzioni, simmetria e finitura studiate per esaltare al massimo brillantezza, scintillio e ritorno di luce."
          : x.taglio === "Ideal"
            ? "Proporzioni, simmetria e finitura studiate per esaltare al massimo brillantezza, scintillio e ritorno di luce."
            : "È il giudizio del laboratorio sulle proporzioni della pietra.") + "</p>");
    } else {
      p.push("<p><b>Il taglio.</b> Sulle forme diverse dalla rotonda il GIA non assegna un grado di taglio. " +
        "Qui contano la simmetria e come la pietra si comporta girando" +
        (url360(x) ? ": falla girare qui accanto." : ".") + "</p>");
    }

    if (x.fluorescenza) {
      var forte = x.fluorescenza_codice === "STG" || x.fluorescenza_codice === "VST";
      /* LA VOCE APRE LA FRASE, QUINDI VA IN MAIUSCOLA (19 settembre 2026): il
         testo consegnato dice «Fluorescenza: Nessuna.» e toLowerCase() la
         spegneva. Il resto della parola resta minuscolo, cosi' «Molto forte»
         non diventa «Molto Forte». */
      var fluoNome = String(x.fluorescenza).toLowerCase();
      fluoNome = fluoNome.charAt(0).toUpperCase() + fluoNome.slice(1);
      p.push("<p><b>Fluorescenza: " + fuggi(fluoNome) + ".</b> " +
        (x.fluorescenza_codice === "NON"
          ? "Nessuna fluorescenza percepibile sotto luce ultravioletta: il diamante mantiene il proprio aspetto naturale."
          : forte
            ? "Alcuni diamanti, sotto il sole, emettono un bagliore azzurrino. Su questa è marcato: sulla maggior parte " +
              "delle pietre non si nota, su alcune in pieno sole si legge un velo. Se ti interessa, guardala in " +
              "negozio alla luce naturale prima di decidere."
            : "Alcuni diamanti, sotto il sole, emettono un bagliore azzurrino. Su questa è appena accennato: " +
              "alla luce di tutti i giorni non cambia nulla.") + "</p>");
    }

    segnalazioni(x).forEach(function (s) {
      var t = (SEGN_LUNGA[s.tipo] || {})[s.intensita];
      if (t) p.push("<p><b>Una cosa da sapere.</b> " + t + "</p>");
    });

    if (x.origine) {
      p.push("<p><b>Origine: " + fuggi(x.origine) + ".</b> È la provenienza dichiarata sul certificato. " +
        "Non tutte le pietre ce l'hanno: quando c'è, è un'informazione in più che possiamo darti.</p>");
    }
    return p.join("");
  }

  /* ————— la scheda tecnica, a gruppi —————
     Ci sono TUTTI i campi che l'archivio ci dà. Restano fuori solo quelli che
     non devono uscire (il costo, lo sconto e il prezzo al carato del fornitore,
     che nel feed non vengono nemmeno letti) e quelli che sono termini fra noi e
     Nivoda, non fra noi e te. */
  function gruppi(x) {
    var g = [];

    /* "CARATTERISTICHE" e non "La pietra" (10 set 2026): sotto un titolo che
       adesso dice gia' "Il tuo diamante", ripetere "la pietra" non aggiungeva
       niente. */
    g.push(["Caratteristiche", [
      ["Forma", x.forma],
      ["Peso", ct(x.carati) + " ct"],
      /* il terzo elemento a true vuol dire "questa cella è già HTML": tutto
         quello che viene dall'archivio va comunque fatto passare da fuggi(),
         anche una lettera sola, o è una porta aperta lasciata socchiusa */
      /* NELLA GRIGLIA C'E' IL DATO E BASTA, non la sua spiegazione.

         Qui sotto il colore c'era la parola con cui la pietra si vende
         ("bianchissima", o su una fancy "si vende come champagne") e sotto la
         purezza la frase del GIA per esteso. Due righe in corpo minore che
         alzavano la prima fila e lasciavano le altre tre corte.

         Le parole non sono sparite: stanno nel blocco di spiegazioni sotto la
         griglia, dove c'e' lo spazio per dirle intere invece che in tre
         parole strette in una cella. Il nome commerciale delle fancy —
         champagne, cognac — non era una spiegazione ma un secondo nome, e
         quello e' passato nella riga di sintesi sotto il titolo. */
      ["Colore", x.colore],
      ["Purezza", x.purezza]
    ]]);

    /* "ALTRE CARATTERISTICHE" e non piu' "le proporzioni": qui dentro ci
       sono anche la fluorescenza e le misure al dito, che proporzioni non
       sono. E la fluorescenza ci sale: da sola sotto un titolo suo faceva un
       riquadro spaiato in fondo alla colonna. */
    /* e questo diventa "Dettagli": con il primo gruppo che si chiama
       "Caratteristiche", "altre caratteristiche" sarebbe stato un rimando. */
    g.push(["Dettagli", [
      /* la riga del taglio esiste solo dove il grado esiste */
      ["Taglio", x.taglio],
      ["Lucidatura", x.lucidatura],
      ["Simmetria", x.simmetria],
      ["Cintura", x.cintura],
      ["Tavola", x.tavola != null ? virgola(x.tavola) + "%" : null],
      ["Profondità", x.profondita != null ? virgola(x.profondita) + "%" : null],
      ["Misure", x.misure],
      ["Al dito", misuraLunga(x)],
      ["Fluorescenza", x.fluorescenza]
    ]]);

    /* IL GRUPPO "DA SAPERE" E' USCITO DALLA GRIGLIA (10 settembre 2026).
       Era una casella con due parole — "una punta di calore" — dentro una
       griglia di dati misurati, e diceva la stessa cosa che il paragrafo
       "Una cosa da sapere." qui sotto dice per esteso e con il perche'.
       Due volte la stessa informazione, una delle quali senza contesto.
       Le funzioni segnalazioni() e SEGN_CORTA restano: le usa il paragrafo. */

    /* UN RIQUADRO SOLO. Erano due — "Laboratorio: GIA" e "Certificato n." —
       e dicevano la stessa cosa in due caselle: il laboratorio e' scritto
       dentro il numero stesso, che e' un numero GIA. Accorpati, la riga in
       fondo alla colonna smette di essere una griglia mezza vuota. */
    g.push(["Il documento", [
      ["Certificato", x.certificato_n
        ? '<a href="https://www.gia.edu/report-check?reportno=' + encodeURIComponent(x.certificato_n) +
          '" target="_blank" rel="noopener">' + fuggi(x.laboratorio || "GIA") + " n. " +
          fuggi(x.certificato_n) + "</a>"
        : fuggi(x.laboratorio || "GIA"), true]
    ]]);

    return g;
  }

  function specifiche(x) {
    return gruppi(x).map(function (gr) {
      var righe = gr[1].filter(function (r) { return r[1]; });
      if (!righe.length) return "";
      return '<section class="cp3-p-gruppo"><h2>' + fuggi(gr[0]) + "</h2>" +
        '<dl class="cp3-p-dl">' + righe.map(function (r) {
          return "<div><dt>" + fuggi(r[0]) + "</dt><dd>" + (r[2] ? r[1] : fuggi(r[1])) + "</dd></div>";
        }).join("") + "</dl></section>";
    }).join("");
  }

  /* Il certificato in PDF sta su domini di terzi: si apre in una scheda nuova e
     non si incorpora, perché un 404 dentro la nostra pagina sembrerebbe un
     guasto nostro. Quando manca — poco più di una pietra su tre — non si
     scrive mai "certificato non disponibile": il certificato c'è, è il file
     che non abbiamo sottomano, e prometterlo dove non c'è è la cosa che non si
     fa. */
  function bloccoCertificato(x) {
    var p = [];
    if (x.certificato_pdf) {
      p.push('<p><a href="' + fuggi(x.certificato_pdf) + '" target="_blank" rel="noopener">' +
        "Apri il certificato " + fuggi(x.laboratorio || "GIA") + " (PDF)</a> — si apre in una scheda nuova.</p>");
    } else {
      p.push("<p>Il certificato " + fuggi(x.laboratorio || "GIA") + " originale accompagna la pietra. " +
        "Se vuoi vederlo prima, chiedicelo: te lo mandiamo.</p>");
    }
    if (x.certificato_n) {
      p.push('<p>Puoi verificare il numero ' + fuggi(x.certificato_n) + ' direttamente sul ' +
        '<a href="https://www.gia.edu/report-check?reportno=' + encodeURIComponent(x.certificato_n) +
        '" target="_blank" rel="noopener">sito del GIA</a>, senza passare da noi.</p>');
    }
    return p.join("");
  }

  /* La stessa roba su una riga sola, per il modulo della richiesta: chi
     risponde deve avere tutto sotto gli occhi senza aprire niente. */
  function datiInRiga(x) {
    var out = [];
    gruppi(x).forEach(function (gr) {
      gr[1].forEach(function (r) {
        if (!r[1]) return;
        var v = String(r[1]).replace(/<small>/g, " (").replace(/<\/small>/g, ")").replace(/<[^>]+>/g, "");
        out.push(r[0] + " " + v.trim());
      });
    });
    return out.join(" · ");
  }

  /* ————— LA RICHIESTA IN BOUTIQUE —————
     Porta con sé tutto quello che serve a chi risponde, comprese le risposte
     del percorso: se quella pietra è stata venduta, chi legge sa già cosa
     proporre al suo posto. La finestra è snippets/richiesta-pietra.liquid,
     resa in fondo a questa sezione. */
  /* ————— IL SOLITARIO SU MISURA DA QUESTA PIETRA —————
     Stessa finestra della richiesta in boutique, stessa pietra: cambia
     l'intento, che viene scritto nel titolo e nell'allargamento cosi' chi
     legge in negozio sa subito che non e' una richiesta di prezzo ma
     l'inizio di un progetto. Se il JavaScript non parte, l'ancora resta un
     collegamento ai contatti e non si perde niente. */
  var bSol = el("[data-cp3-solitario]");
  if (bSol) bSol.addEventListener("click", function (ev) {
    var x = inEsame;
    if (!x || !window.CurnisRichiestaPietra) return;      /* niente pietra: segue il link */
    ev.preventDefault();
    window.CurnisRichiestaPietra.apri({
      titolo: "Solitario su misura · " + titoloPietra(x),
      spec: rigaSintesi(x),
      dati: datiInRiga(x),
      prezzo: euroPub(x.prezzo),
      rif: x.certificato_n ? "Certificato GIA n. " + x.certificato_n : "",
      foto: "", video: (x.video || ""),
      laboratorio: x.laboratorio || "GIA",
      quando: new Date().toLocaleString("it-IT"),
      percorso: percorsoInChiaro(),
      allargamento: "richiesta di anello solitario su misura da questa pietra",
      pagina: location.href
    });
  });

  el("[data-cp3-p-boutique]").addEventListener("click", function () {
    var x = inEsame;
    if (!x || !window.CurnisRichiestaPietra) return;
    window.CurnisRichiestaPietra.apri({
      titolo: titoloPietra(x) + " · " + (x.colore || "") + " · " + (x.purezza || "") + " · " + (x.laboratorio || "GIA"),
      spec: rigaSintesi(x),
      dati: datiInRiga(x),
      prezzo: euroPub(x.prezzo),
      /* NIENTE RIFERIMENTO INTERNO nella richiesta: e' una sigla che non dice
         niente ne' al cliente ne' a chi legge in negozio. Quello che serve per
         ritrovare la pietra e' il numero del certificato, che e' universale e
         si controlla sul sito del GIA. */
      rif: x.certificato_n ? "Certificato GIA n. " + x.certificato_n : "",
      /* Al modulo di richiesta NON si passa piu' la fotografia ferma: quel
         modulo la mostra, e il cliente l'ha vietata dappertutto. Resta il
         video, che e' quello che vogliamo far vedere. */
      foto: "",
      video: x.video || "",
      laboratorio: x.laboratorio || "GIA",
      quando: (S.vistoIl || new Date()).toLocaleString("it-IT"),
      percorso: percorsoInChiaro(),
      allargamento: "",
      pagina: location.href
    });
  });

  function percorsoInChiaro() {
    /* Chi arriva da un collegamento diretto non ha fatto nessun percorso: si
       scrive quello, e non quattro risposte finte. */
    if (!S.forma && !S.caratura && !S.fascia) return "Arrivata da un collegamento diretto alla pietra.";
    var p = [];
    /* Ogni riga si difende da sola: questo testo finisce nella mail che
       arriva in boutique, e un nome che manca deve produrre una parola
       mancante, non fermare l'invio della richiesta. */
    var nomeDi = function (o, seManca) { return (o && o.nome) ? o.nome : seManca; };
    /* sul ramo delle fancy il taglio non si sceglie: la scelta e' il colore */
    if (fancyOra()) p.push("colore " + nomeDi(trova(COLORI, S.colore), "non scelto").toLowerCase());
    else p.push(S.forma ? nomeDi(trova(FORME, S.forma), "taglio non riconosciuto") : "taglio non scelto");
    p.push(S.caratura ? nomeDi(bCaratura(), "misura non riconosciuta").toLowerCase() : "dimensione non scelta");
    p.push(S.fascia ? "fascia " + nomeDi(bQualita(), "non riconosciuta").toLowerCase() : "tutte le fasce di qualità");
    return p.join(" · ");
  }

  /* ══════════════════ AVVIO ══════════════════ */

  /* Il tasto indietro del browser: lo stato sta nell'indirizzo, basta
     rileggerlo e ridisegnare. Niente da ricostruire a mano. */
  window.addEventListener("popstate", function () {
    S.daPopstate = true;
    /* Anche col tasto indietro del browser: leggiUrl() riscrive il passo ma
       non tocca i cursori, che nell'indirizzo non ci sono. Senza questa riga
       il difetto tornava per la strada del browser invece che per quella del
       pulsante. */
    var prima = S.passo;
    leggiUrl();
    if (!cursoriValgonoQui(S.passo) && cursoriValgonoQui(prima)) cursoriFuori();
    disegna(false);
  });

  /* ————— LA BARRA RESTA IN BASSO PER TUTTO IL PANNELLO (13 set 2026) —————

     La barra e' "sticky bottom", e uno sticky resta incollato solo finche' il
     SUO GENITORE scorre: il genitore e' .cp3-p-info, la colonna dei testi, che
     finisce 497 px dopo l'inizio della pagina. Da li' in giu' — banner di
     chiusura, pezzi simili, altre due schermate e mezzo — la barra se ne
     andava su con la colonna. E' la segnalazione: "non resta bloccato in basso
     ma scorre verso l'alto".

     Sul telefono la si sposta in fondo a .cp3-p, che e' tutto il pannello
     della pietra (2442 px invece di 784): cosi' resta incollata al bordo basso
     per tutta la scheda e si stacca alla fine, che e' il comportamento che il
     cliente ha detto di voler tenere.

     Sul desktop NON si tocca: li' la barra vive dentro la colonna di destra ed
     e' larga quanto lei; spostandola diventerebbe larga tutta la pagina, che
     non e' quello che e' stato chiesto. Il posto giusto si ricalcola a ogni
     cambio di misura della finestra. */
  (function () {
    var flot = el("[data-cp3-flot]");
    var pannello = el("[data-cp3-scheda]");
    if (!flot || !pannello) return;
    var casaSua = flot.parentElement;           /* .cp3-p-info, il posto del desktop */
    var stretto = window.matchMedia("(max-width: 900px)");
    function sistema() {
      if (stretto.matches) {
        if (flot.parentElement !== pannello) pannello.appendChild(flot);
      } else if (flot.parentElement !== casaSua) {
        casaSua.appendChild(flot);
      }
    }
    if (stretto.addEventListener) stretto.addEventListener("change", sistema);
    else if (stretto.addListener) stretto.addListener(sistema);
    /* ANCHE IL RIDIMENSIONAMENTO, e non per abbondanza: il «change» del media
       query non scatta in ogni caso in cui la finestra cambia misura davvero
       — misurato passando da 375 a 1280 px, la barra restava in fondo al
       pannello e diventava larga tutta la pagina. sistema() e' idempotente. */
    window.addEventListener("resize", sistema);
    sistema();
  })();

  leggiUrl();
  scriviUrl(false);
  disegna(false);
})();
